export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which of the following is <i>not</i> part of the form factor of a server?",
    "choice_a": "Size",
    "choice_b": "Appearance",
    "choice_c": "Dimensions",
    "choice_d": "Security",
    "correct_answer": "D",
    "explanation": "Form factor refers to the physical appearance and dimensions of the server.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      17,
      1,
      6,
      18,
      21
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 2,
    "question": "Which function is made easier when a server has a rail kit?",
    "choice_a": "Installation",
    "choice_b": "Maintenance",
    "choice_c": "Configuration",
    "choice_d": "Network access",
    "correct_answer": "B",
    "explanation": "Rail kits, when implemented, allow for the server to be slid out of the rack for maintenance.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      17,
      16,
      2,
      4
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 3,
    "question": "Which of the following is the unit of measurement when discussing rack components?",
    "choice_a": "M",
    "choice_b": "I",
    "choice_c": "U",
    "choice_d": "C",
    "correct_answer": "C",
    "explanation": "Each U is 1.75 inches (4.445 cm) high.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      17,
      6,
      3,
      4
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 4,
    "question": "Which of the following is another term for RAID 1?",
    "choice_a": "Duplicating",
    "choice_b": "Doubling",
    "choice_c": "Duplexing",
    "choice_d": "Mirroring",
    "correct_answer": "D",
    "explanation": "RAID 1 is also known as disk mirroring. This is a method of producing fault tolerance by writing all data simultaneously to two separate drives.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      61,
      62,
      21,
      53,
      52
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 5,
    "question": "What is the primary function of PXE?",
    "choice_a": "Remote booting",
    "choice_b": "Secure routing",
    "choice_c": "Remote administration",
    "choice_d": "Redundant connections",
    "correct_answer": "A",
    "explanation": "The Preboot Execution Environment (PXE) is an industry standard client/server interface that allows networked computers that are not yet loaded with an operating system to be configured and booted remotely by an administrator.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      29,
      25,
      24,
      141,
      133
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 6,
    "question": "Shares are used to allocate which of the following to VMs?",
    "choice_a": "ROM",
    "choice_b": "CPU",
    "choice_c": "NVRAM",
    "choice_d": "L2 cache",
    "correct_answer": "B",
    "explanation": "There are three ways the allocation of the use of the physical CPU(s) can be controlled. These methods are as follows:<ul><li>Shares: Using values such as Low, Normal, High, and Custom (in VMWare, for example), these values are compared to the sum of all shares of all virtual machines on\u00a0the server. Therefore, they define the relative percentage each VM can use.</li><li>Reservation: Guaranteed CPU allocation for a VM.</li><li>Limit: Upper limit for a VM\u2019s CPU allocation.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      46,
      40,
      81,
      44,
      37
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 7,
    "question": "What is the most common protocol a SAN uses?",
    "choice_a": "IPX",
    "choice_b": "IP",
    "choice_c": "Ethernet",
    "choice_d": "Fibre Channel",
    "correct_answer": "D",
    "explanation": "In a classic SAN, devices communicate using the Fibre Channel protocol over a fiber network of storage devices typically connected to a Fibre Channel switch.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      67,
      14,
      13,
      20,
      66
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 8,
    "question": "Which of the following is true of a NAS?",
    "choice_a": "A NAS has lower latency and higher reliability than a SAN.",
    "choice_b": "A NAS typically supports only RAID 5.",
    "choice_c": "A NAS does not support high throughput.",
    "choice_d": "Implementing a NAS is inexpensive.",
    "correct_answer": "D",
    "explanation": "Implementing a NAS is inexpensive when compared to implementing a SAN.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      67,
      62,
      61,
      64,
      63
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 9,
    "question": "Which of the following is a standard firmware interface for servers and PCs designed to replace BIOS?",
    "choice_a": "SCSI",
    "choice_b": "ISCSI",
    "choice_c": "UEFI",
    "choice_d": "FDDI",
    "correct_answer": "C",
    "explanation": "Some advantages of UEFI firmware are:<ul><li>Better security; protects the preboot process</li><li>Faster startup times and resuming from hibernation</li><li>Support for drives larger than 2.2 terabytes (TB)</li><li>Support for 64-bit firmware device drivers</li><li>Capability to use BIOS with UEFI hardware.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      54,
      51,
      53,
      49,
      19
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 10,
    "question": "What is the role of a DHCP server in a network?",
    "choice_a": "Issues IP configurations",
    "choice_b": "Translates private to public addresses",
    "choice_c": "Authenticates users",
    "choice_d": "Resolves IP addresses to hostnames",
    "correct_answer": "A",
    "explanation": "DHCP servers are used to automate the process of providing an IP configuration to devices in the network. These servers respond to broadcast-based requests for a configuration by offering an IP address, subnet mask, and default gateway to the DHCP client.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      142,
      130,
      132,
      26,
      141
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 11,
    "question": "The metric IOPS is used to describe the performance of which resource?",
    "choice_a": "Memory",
    "choice_b": "Disk",
    "choice_c": "CPU",
    "choice_d": "Network",
    "correct_answer": "B",
    "explanation": "IOPS (input/output operations per second) is a common disk metric that describes how fast the disk subsystem is able to read and write to the drive. The higher this value, the better.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      38,
      36,
      37,
      40,
      39
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 12,
    "question": "As the number of users assigned to a printer increases, which resource should be increased?",
    "choice_a": "Disk",
    "choice_b": "Network",
    "choice_c": "CPU",
    "choice_d": "Memory",
    "correct_answer": "D",
    "explanation": "Print servers need lots of memory to hold the print jobs waiting in the print queue. The exact amount will depend on the number of users assigned to the printers being managed by this print server.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      33,
      37,
      34,
      35,
      68
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 13,
    "question": "What is the function of the command-line utility wevtutil?",
    "choice_a": "Manages log files",
    "choice_b": "Manages network connections",
    "choice_c": "Manages memory issues",
    "choice_d": "Manages CPU affinity",
    "correct_answer": "A",
    "explanation": "Managing log files can be done at the command line using the following command, inserting the name of the log file and the maximum size in bytes:<br><code>wevtutil sl <LogName> /ms:<MaxSizeInBytes></code>.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      27,
      148,
      144,
      145,
      41
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 14,
    "question": "Which of the following are simply whole numbers?",
    "choice_a": "Strings",
    "choice_b": "Arrays",
    "choice_c": "Integers",
    "choice_d": "Conditionals",
    "correct_answer": "C",
    "explanation": "Integers are simply whole numbers. This data type can be used to:<ul><li>Assign a value to a variable</li><li>Set the parameters of a loop</li><li>Define a condition to be met.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      145,
      144,
      147,
      148,
      68
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 15,
    "question": "Which RAID version requires at least three drives?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "C",
    "explanation": "A minimum of three drives is required for RAID 5.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      61,
      62,
      52,
      64,
      53
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 16,
    "question": "Which of the following statements is true with respect to safes?",
    "choice_a": "No safes are fireproof.",
    "choice_b": "Consumer Reports assigns ratings to safes that you can use to assess the suitability of the safe.",
    "choice_c": "Those that are fire-resistant will protect a backup tape from being damaged.",
    "choice_d": "When considering a safe, you should focus on two items: the cost and the size.",
    "correct_answer": "C",
    "explanation": "With respect to fire, no safe is fireproof. Many are fire-resistant and will protect a document from being destroyed, which occurs at a much higher temperature than many of the other items (such as backup tapes and CDs) can tolerate without damage. For these reasons, items such as backup tapes should be stored off-site.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      91,
      114,
      152,
      150,
      155
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 17,
    "question": "Which of the following is true of an HIDS?",
    "choice_a": "A high number of false negatives can cause a lax attitude on the part of the security team.",
    "choice_b": "An HIDS cannot address authentication issues.",
    "choice_c": "Encrypted packets can be analyzed.",
    "choice_d": "An HIDS monitors only traffic destined for the machine on which it is installed.",
    "correct_answer": "D",
    "explanation": "A host-based system is installed on the device (for purposes of our discussion, a server) and the system focuses solely on identifying attacks on that device only.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      108,
      90,
      109,
      105,
      99
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 18,
    "question": "Which of the following is a compact, hot-pluggable transceiver not standardized by any governing body like the IEEE?",
    "choice_a": "SELinux",
    "choice_b": "PXE",
    "choice_c": "SPF",
    "choice_d": "QoS",
    "correct_answer": "C",
    "explanation": "The small form-factor pluggable (SFP) is a compact, hot-pluggable transceiver that, though not standardized by any governing body like the IEEE, was created through a multisource agreement (MSA) between competing manufacturers. For this reason, you may find that there is not full compatibility among these from various sources.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      14,
      13,
      20,
      15,
      66
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 19,
    "question": "Which of the following would Joe use to digitally sign a document so that Sally can verify his signature?",
    "choice_a": "Joe\u2019s private key",
    "choice_b": "Sally\u2019s private key",
    "choice_c": "Joe\u2019s public key",
    "choice_d": "Sally\u2019s public key",
    "correct_answer": "A",
    "explanation": "Since Sally will use Joe\u2019s public key to verify the signature, he must sign it with his private key.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      111,
      100,
      122,
      123,
      117
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 20,
    "question": "Which authentication mechanism is an example of something you are?",
    "choice_a": "Password",
    "choice_b": "Username",
    "choice_c": "Smartcard",
    "choice_d": "Retina scan",
    "correct_answer": "D",
    "explanation": "While passwords and usernames are examples of something you know and a smartcard is an example of something you possess, a retina scan provides something you are.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      122,
      86,
      119,
      111,
      117
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 21,
    "question": "What is a common host-based firewall on Linux-based systems?",
    "choice_a": "<code>iptables</code>",
    "choice_b": "<code>nessus</code>",
    "choice_c": "<code>tripwire</code>",
    "choice_d": "<code>scannow</code>",
    "correct_answer": "A",
    "explanation": "On Linux-based systems a common host-based firewall is <code>iptables</code>, which replaces a previous package called <code>ipchains</code>. It has the ability to accept or drop packets.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      105,
      106,
      108,
      93,
      99
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 22,
    "question": "Which of the following can be accomplished using port security?",
    "choice_a": "Set the minimum number of MAC addresses that can be seen on a port.",
    "choice_b": "Set the maximum number of IP addresses that can be seen on a port.",
    "choice_c": "Define which MAC addresses are not allowed on the port.",
    "choice_d": "Set the maximum number of MAC addresses that can be seen on a port.",
    "correct_answer": "D",
    "explanation": "It is possible to specify a maximum number of MAC addresses allowed on a port.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      143,
      138,
      136,
      148,
      145
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 23,
    "question": "Which of the following is one that is a process, completes its work, but is mistakenly marked as a dead process, preventing it from ending?",
    "choice_a": "Orphan",
    "choice_b": "Active",
    "choice_c": "Zombie",
    "choice_d": "Inactive",
    "correct_answer": "C",
    "explanation": "A zombie process (work performed on behalf of services is done using processes) is one that is a child of another process. It becomes a zombie when it completes its work but is mistakenly marked as a dead process, preventing it from ending.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      210,
      173,
      189,
      168,
      163
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 24,
    "question": "Which is the minimum category of cable required for 100 Mbps transmissions?",
    "choice_a": "CAT3",
    "choice_b": "CAT5",
    "choice_c": "CAT5e",
    "choice_d": "CAT6",
    "correct_answer": "B",
    "explanation": "CAT5 transmits data at speed up to 100 Mbps and specifies cable lengths up to 100 meters.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      12,
      11,
      14,
      20,
      15
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 25,
    "question": "Which of the following services uses port number 443?",
    "choice_a": "SFTP",
    "choice_b": "NTP",
    "choice_c": "HTTP",
    "choice_d": "HTTPS",
    "correct_answer": "D",
    "explanation": "HTTPS is a secure form of HTTP that uses port 443.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      141,
      142,
      134,
      41,
      43
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 26,
    "question": "Backdoors are also sometimes called which of the following?",
    "choice_a": "Teardrops",
    "choice_b": "Remote access trojans",
    "choice_c": "Trapdoors",
    "choice_d": "Rootkits",
    "correct_answer": "B",
    "explanation": "A Trojan horse can create a backdoor. These backdoors are also sometimes called remote access Trojans (RATs) because they allow the hacker to connect to the machine without going through any sort of authentication process.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      93,
      104,
      105,
      106,
      109
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 27,
    "question": "Which of the following parts of a MAC address is unique for each interface made by a vendor?",
    "choice_a": "UAA",
    "choice_b": "BAA",
    "choice_c": "OUI",
    "choice_d": "EUI-64",
    "correct_answer": "C",
    "explanation": "Each part of this address communicates information. The left half of the address is called the organizationally unique identifier (OUI). It identifies the vendor who made the interface. The right half is called the universally administered address (UAA). It will be unique for each interface made by the vendor. Together they make a globally unique MAC address.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      39,
      141,
      137,
      132,
      134
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 28,
    "question": "How many sets of backup tapes are used in the GFS system?",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "4",
    "choice_d": "5",
    "correct_answer": "B",
    "explanation": "In the Grandfather-Father-Son (GFS) backup scheme, three sets of backups are defined. Most often these three definitions are daily, weekly, and monthly.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      151,
      152,
      157,
      149,
      155
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 29,
    "question": "When creating a backup, what function can be used to verify the integrity of the results?",
    "choice_a": "Checksums",
    "choice_b": "Encryption",
    "choice_c": "Digital signatures",
    "choice_d": "Transaction logs",
    "correct_answer": "A",
    "explanation": "If you create the backup using checksums (which is an option with many utilities), it will allow you to check that the data has not changed since it was made or that it has been corrupted or damaged.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      155,
      149,
      152,
      150,
      151
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 30,
    "question": "If you perform a full backup once a week and use a differential backup scheme the rest of the week, how many tapes are required for a restore four days after the full backup is taken?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "You will need the last full backup tape and the last differential tape. Each differential tape contains all changes that occurred since the last full backup.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      149,
      151,
      156,
      157,
      155
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 31,
    "question": "Which of the following components is a system responsible for preventing attacks?",
    "choice_a": "HIDS",
    "choice_b": "NIDS",
    "choice_c": "IPS",
    "choice_d": "DC",
    "correct_answer": "C",
    "explanation": "An IPS is a system responsible for preventing attacks. When an attack begins, an IPS takes actions to contain the attack.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      106,
      107,
      104,
      93,
      121
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 32,
    "question": "Which of the following is a suite of protocols that establishes a secure channel between two devices?",
    "choice_a": "IPsec",
    "choice_b": "SPI",
    "choice_c": "iSCSI",
    "choice_d": "VLAN",
    "correct_answer": "A",
    "explanation": "Internet Protocol Security (IPsec) is a suite of protocols that establishes a secure channel between two devices. IPsec is commonly implemented over VPNs, but that is not its only use.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      113,
      106,
      122,
      123,
      108
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 33,
    "question": "Which of the following is not true about server backplanes?",
    "choice_a": "They can be a single point of failure.",
    "choice_b": "They provide data and control signal connectors for CPU.",
    "choice_c": "Backplane failures are uncommon.",
    "choice_d": "You should implement redundant backplanes.",
    "correct_answer": "B",
    "explanation": "Backplanes are advantageous in that they provide data and control signal connectors for the hard drives. They also provide the interconnection for the front I/O board, power and locator buttons, and system/component status LEDs. Unfortunately, this creates a serious single point of failure because if the backplane fails, we lose communication with the servers to which it is connected.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      180,
      174,
      178,
      162,
      163
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 34,
    "question": "Which of the following steps in the CompTIA troubleshooting method comes first?",
    "choice_a": "Verify full system functionality and, if applicable, implement preventive measures.",
    "choice_b": "Document findings, actions, and outcomes throughout the process.",
    "choice_c": "Identify the problem and determine the scope.",
    "choice_d": "Perform a root cause analysis.",
    "correct_answer": "C",
    "explanation": "The steps in order are:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      162,
      163,
      164,
      165,
      166
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 35,
    "question": "Which command is used on a Windows computer to identify the path taken to a destination network?",
    "choice_a": "<code>traceroute</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ipconfig/trace</code>",
    "choice_d": "<code>trace</code>",
    "correct_answer": "B",
    "explanation": "The <code>tracert</code> command (<code>traceroute</code> in Linux and Unix) is used to trace the path of a packet through the network on routers.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      203,
      195,
      196,
      197,
      204
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 36,
    "question": "On which type of device is port security used?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Multiplexer",
    "correct_answer": "B",
    "explanation": "Switches can be used to implement port security. Some of the things you can specify using port security are the only MAC address or addresses allowed to send traffic in the port, the total number of MAC addresses that can transmit on the port, and an action to be taken when a violation occurs (either shut the port down or prevent transmissions by the guilty MAC address).",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      131,
      82,
      83,
      140,
      72
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 37,
    "question": "You receive a destination unreachable message with a source IP address. Where is it coming from?",
    "choice_a": "A remote router",
    "choice_b": "A remote DNS server",
    "choice_c": "A local DNS server",
    "choice_d": "The local router",
    "correct_answer": "A",
    "explanation": "If the message comes with no source IP address, that means the message is coming from the local router (the default gateway of the sender). If it has a source IP address of the sender, then it is another router in the path.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      200,
      195,
      198,
      197,
      163
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 38,
    "question": "The <code>sudo fdisk -l</code> command lists the partitions on what type of system?",
    "choice_a": "Windows",
    "choice_b": "Mac",
    "choice_c": "Novell",
    "choice_d": "Linux",
    "correct_answer": "D",
    "explanation": "The <code>sudo fdisk -l</code> command lists the partitions on a Linux system.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      30,
      31,
      28,
      29,
      27
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 39,
    "question": "In Linux, what is <code>fstab</code> used for?",
    "choice_a": "To mount partitions on boot",
    "choice_b": "To create partitions",
    "choice_c": "To format a partition",
    "choice_d": "To defragment a drive",
    "correct_answer": "A",
    "explanation": "<code>fstab</code> (File System Table) is a file used by Linux operating systems to mount partitions on boot.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      24,
      29,
      28,
      31,
      35
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 40,
    "question": "What component locates the operating system in Linux?",
    "choice_a": "NTLDR",
    "choice_b": "GRUB",
    "choice_c": "Bootmgr",
    "choice_d": "<code>boot.ini</code>",
    "correct_answer": "B",
    "explanation": "In Linux this is handled by GRUB.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      24,
      25,
      27,
      31,
      144
    ],
    "source": "891437_Assessment test"
  },
  {
    "id": 41,
    "question": "What are servers that are designed to be bolted into a framework called?",
    "choice_a": "Tower servers",
    "choice_b": "Blade servers",
    "choice_c": "Rack-mount servers",
    "choice_d": "Virtual servers",
    "correct_answer": "C",
    "explanation": "Rack-mount servers are those that are designed to be bolted into a framework called a rack and thus are designed to fit one of several standard-sized rack slots or bays.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      17,
      1,
      3,
      6,
      2
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 42,
    "question": "Bays are another terms for what?",
    "choice_a": "Rack slots",
    "choice_b": "Blades",
    "choice_c": "PDUs",
    "choice_d": "Slot covers",
    "correct_answer": "A",
    "explanation": "Rack slots or bays hold servers and other devices in racks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      3,
      4,
      6,
      16
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 43,
    "question": "Which of the following allows the server to be serviced without unbolting it from its bay?",
    "choice_a": "Top cover",
    "choice_b": "Rail kit",
    "choice_c": "KVM",
    "choice_d": "Rack stand",
    "correct_answer": "B",
    "explanation": "Rail kits allow the server to be slid out of the rack for maintenance.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      17,
      3,
      16,
      1,
      4
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 44,
    "question": "A 3U server uses how much space in the rack?",
    "choice_a": "5.25 inches",
    "choice_b": "1.75 inches",
    "choice_c": "2.50 inches",
    "choice_d": "7 inches",
    "correct_answer": "A",
    "explanation": "Each U is 1.75 inches, so a 3U would be 5.25 inches.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      6,
      17,
      3,
      4
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 45,
    "question": "Which of the following contain(s) the cable slack to allow the server to be slid out of the rack and is (are) designed to follow the server when it is slid out of the bay?",
    "choice_a": "KVM",
    "choice_b": "Rail kit",
    "choice_c": "Cable management arms",
    "choice_d": "Rack arms",
    "correct_answer": "C",
    "explanation": "To provide the slack required and to keep the cables from blanketing the back of the rack and causing overheating, cable management arms are used. These arms contain the slack and are designed to follow the server when it is slid out of the bay.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      17,
      2,
      3,
      1
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 46,
    "question": "Which of the following interfaces provides as one of its enhancements protection of the preboot process from bootkit attacks?",
    "choice_a": "BIOS",
    "choice_b": "UEFI",
    "choice_c": "LILO",
    "choice_d": "GRUB",
    "correct_answer": "B",
    "explanation": "UEFI performs the equivalent of the BIOS by initiating the platform and loading the operating system. Some of the enhancements this new interface provides are:<ul><li>Protects the preboot process from bootkit attacks</li><li>Resumes from hibernation faster and starts faster</li><li>Supports drives larger than 2.32 TB</li><li>Supports 64-bit firmware drivers, which can be used to access more than 17.2 GB of memory during startup</li><li>Supports both BIOS and UEFI.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      54,
      51,
      49,
      50,
      21
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 47,
    "question": "With which of the following drive types is RAID usually configured?",
    "choice_a": "SCSI",
    "choice_b": "SAS",
    "choice_c": "SATA",
    "choice_d": "PATA",
    "correct_answer": "B",
    "explanation": "RAID can be done with SCSI drives, but it is more often done with serial attached SCSI (SAS) drives.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      66,
      61,
      62,
      21,
      52
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 48,
    "question": "Which statement is true of RAID 0?",
    "choice_a": "It provides fault tolerance.",
    "choice_b": "It requires a minimum of three drives.",
    "choice_c": "It uses parity information.",
    "choice_d": "It improves performance.",
    "correct_answer": "D",
    "explanation": "This is a form of RAID that doesn\u2019t provide fault tolerance. Data is written across multiple drives, so one drive can be reading or writing while the next drive\u2019s read/write head is moving. This makes for faster data access.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      61,
      62,
      21,
      52,
      64
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 49,
    "question": "What is the percentage of available drive space when using RAID 1?",
    "choice_a": "100%",
    "choice_b": "50%",
    "choice_c": "33%",
    "choice_d": "25%",
    "correct_answer": "B",
    "explanation": "Since RAID 1 repeats the data on two drives, only one half of the total drive space is available for data. So if two 250 GB drives are used in the array, 250 GB will be the available drive space.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      61,
      62,
      21,
      63,
      64
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 50,
    "question": "Which of the following is also called striping with parity?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": "C",
    "explanation": "RAID 5 combines the benefits of both RAID 0 and RAID 1 and is also known as striping with parity.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      63,
      64,
      65
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 51,
    "question": "What factor determines the memory requirements for an Active Directory (AD) server?",
    "choice_a": "The size of the AD database",
    "choice_b": "The number of users",
    "choice_c": "The rate of change in the database",
    "choice_d": "The number of commuters in the network",
    "correct_answer": "A",
    "explanation": "The memory requirements depend on the size of the AD database or the <code>ntds.dit</code> file. You should have enough memory to hold this with 20 percent additional space.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      34,
      24,
      37,
      142,
      78
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 52,
    "question": "When the number of users assigned to a print server increases, what resource should be increased?",
    "choice_a": "CPU",
    "choice_b": "Memory",
    "choice_c": "NIC",
    "choice_d": "Disk",
    "correct_answer": "B",
    "explanation": "Print servers need lots of memory to hold the print jobs waiting in the print queue. The exact amount will depend on the number of users assigned to the printers being managed by this print server.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      33,
      37,
      35,
      34,
      68
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 53,
    "question": "You just created five new scopes on your DHCP server. What resource may now be stressed?",
    "choice_a": "CPU",
    "choice_b": "Memory",
    "choice_c": "NIC",
    "choice_d": "Disk",
    "correct_answer": "D",
    "explanation": "Disk is the second critical component. If you intend to host a large number of scopes (scopes are ranges of IP addresses on the server), keep in mind that each time you add a scope you need more disk space.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      142,
      68,
      130,
      141,
      24
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 54,
    "question": "Where is firmware typically stored on a server?",
    "choice_a": "Flash ROM",
    "choice_b": "RAM",
    "choice_c": "Hardware register",
    "choice_d": "NVRAM",
    "correct_answer": "A",
    "explanation": "Any software that is built into a hardware device is called firmware. Firmware is typically in flash ROM and can be updated as newer versions become available.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      51,
      54,
      52,
      21,
      49
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 55,
    "question": "Which of the following consists of high-capacity storage devices that are connected by a high-speed private network (separate from the LAN) using a storage-specific switch?",
    "choice_a": "NAS",
    "choice_b": "SAN",
    "choice_c": "DAS",
    "choice_d": "VAS",
    "correct_answer": "B",
    "explanation": "Storage area networks (SANs) consist of high-capacity storage devices that are connected by a high-speed private network (separate from the LAN) using a storage-specific switch.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      67,
      14,
      20,
      13,
      66
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 56,
    "question": "Which of the following is required for a server to connect to an FC network?",
    "choice_a": "Backplane",
    "choice_b": "Host bus adapter",
    "choice_c": "RAID controller",
    "choice_d": "Transformer",
    "correct_answer": "B",
    "explanation": "In a classic SAN, devices communicate using the Fibre Channel (FC) protocol over a fiber network of storage devices typically connected to a fiber channel switch. This means that any servers that will be directly connected to this fiber network must have a host bus adapter (HBA) installed that can communicate on the fiber network.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      67,
      14,
      20,
      13,
      21
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 57,
    "question": "Which of the following is used to identify HBAs?",
    "choice_a": "MAC address",
    "choice_b": "IP address",
    "choice_c": "DLCI",
    "choice_d": "WWN",
    "correct_answer": "D",
    "explanation": "HBAs have World Wide Names (WWNs) that identify them much like MAC addresses. HBAs have two types of these: one that identifies the HBA and that is used by all ports on the HBA and one that identifies each port on the HBA.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      67,
      14,
      20,
      21,
      13
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 58,
    "question": "Which of the following is a client/server file-sharing protocol used in Unix/Linux?",
    "choice_a": "NTFS",
    "choice_b": "NetBIOS",
    "choice_c": "NFS",
    "choice_d": "NetBEUI",
    "correct_answer": "C",
    "explanation": "NFS is in one of the protocols that can be used to connect to and share data on a NAS device. Network File System (NFS) is a client/server file-sharing protocol used in Unix/Linux.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      67,
      20,
      11,
      13,
      12
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 59,
    "question": "With which type of replication is the write operation to the primary system acknowledged by the primary system before the write is sent to the secondary?",
    "choice_a": "Asynchronous",
    "choice_b": "Constant",
    "choice_c": "Synchronous",
    "choice_d": "Background",
    "correct_answer": "A",
    "explanation": "Using asynchronous replication, the write operation to the primary system is acknowledged by the primary system before the write is sent to the secondary, whereas with synchronous replication, the write is sent to the secondary system without waiting for acknowledgment from the primary.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      159,
      161,
      150,
      156,
      158
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 60,
    "question": "What is the minimum number of drives required to implement RAID 10?",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "4",
    "choice_d": "5",
    "correct_answer": "C",
    "explanation": "RAID 10 is also known as RAID 1+0. Striped sets are mirrored (a minimum of four drives, and the number of drives must be even). It provides fault tolerance and improved performance but increases complexity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      62,
      21,
      52,
      64
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 61,
    "question": "Which RAID method comprises a mirrored stripe set?",
    "choice_a": "RAID 1",
    "choice_b": "RAID 3",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "D",
    "explanation": "Striped sets are mirrored (a minimum of four drives, and the number of drives must be even). It provides fault tolerance and improved performance but increases complexity. Since this is effectively a mirrored stripe set and a stripe set gets 100 percent use of the drive without mirroring, this array will provide half of the total drive space in the array as available drive space.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      61,
      62,
      21,
      53,
      64
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 62,
    "question": "Which statement is false with respect to hardware RAID?",
    "choice_a": "It has a lower cost than software RAID.",
    "choice_b": "It has better performance than software RAID.",
    "choice_c": "It supports online spares.",
    "choice_d": "It has a decreased processor load.",
    "correct_answer": "A",
    "explanation": "Hardware RAID costs more than software RAID.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      62,
      21,
      61,
      53,
      64
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 63,
    "question": "By default, when an Event Viewer log fills to its maximum size, old entries are deleted in which order ?",
    "choice_a": "LIFO",
    "choice_b": "FIFO",
    "choice_c": "Hybrid LIFO",
    "choice_d": "Weighed FIFO",
    "correct_answer": "B",
    "explanation": "By default, when a log fills to its maximum size, old entries are deleted in first in, first out (FIFO) order.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      72,
      37,
      40,
      39,
      24
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 64,
    "question": "Which of the following is <i>not</i> an example of multifactor authentication?",
    "choice_a": "Password and smartcard",
    "choice_b": "Password and pin",
    "choice_c": "Smartcard and retina scan",
    "choice_d": "Iris scan and password",
    "correct_answer": "B",
    "explanation": "Passwords and pins are both something you know. Multifactor authentication must be at least two of the following:<ul><li>Something you have (example: smartcard)</li><li>Something you are (example: fingerprint scan)</li><li>Something you know (example: password).</li></ul>",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      122,
      86,
      119,
      117,
      124
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 65,
    "question": "Which of the following is a series of two doors with a small room between them?",
    "choice_a": "Mantrap, or security vestibule",
    "choice_b": "Gated system",
    "choice_c": "Verification booth",
    "choice_d": "Multigate",
    "correct_answer": "A",
    "explanation": "A mantrap, or security vestibule, is a series of two doors with a small room between them. The user is authenticated at the first door and then allowed into the room. At that point additional verification will occur (such as a guard visually identifying the person), and then the user is allowed through the second door.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      98,
      85,
      122,
      121,
      117
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 66,
    "question": "What technology uses either bar codes or magnetic strips to embed information that can read wirelessly from some distance?",
    "choice_a": "Proximity ID",
    "choice_b": "RFID",
    "choice_c": "Bluetooth",
    "choice_d": "802.16",
    "correct_answer": "B",
    "explanation": "An increasingly popular method of tracking physical assets is to tag them with radio frequency identification (RFID) chips. This allows you to track the location of an asset at any time. This technology uses either bar codes or magnetic strips to embed information that can read wirelessly from some distance.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      86,
      90,
      91,
      85,
      109
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 67,
    "question": "Which of the following cannot be protected from fire damage by safes?",
    "choice_a": "Network diagrams",
    "choice_b": "Backup tapes",
    "choice_c": "Disaster recovery documents",
    "choice_d": "License agreements",
    "correct_answer": "B",
    "explanation": "With respect to fire, first understand that no safe is fireproof. Many are fire resistant and will protect a document from being destroyed, which occurs at a much higher temperature than many other items (such as backup tapes and CDs) can tolerate without damage.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      91,
      152,
      153,
      112,
      149
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 68,
    "question": "Which of the following is a common host-based firewall on Linux-based systems?",
    "choice_a": "Tripwire",
    "choice_b": "LILO",
    "choice_c": "<code>iptables</code>",
    "choice_d": "Black ice",
    "correct_answer": "C",
    "explanation": "On Linux-based systems, a common host-based firewall is <code>iptables</code>, replacing a previous package called <code>ipchains</code>.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      108,
      106,
      96,
      97,
      99
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 69,
    "question": "At what layer of the OSI model does port security operate?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "Port security applies to ports on a switch, and since it relies on monitoring the MAC addresses of the devices attached to the switch ports, we call it Layer 2 security.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      209,
      202,
      205,
      195,
      201
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 70,
    "question": "Which of the following is an agreement that specifies the type of support to be provided and the acceptable amount of time allowed to respond to support calls?",
    "choice_a": "MOU",
    "choice_b": "SLA",
    "choice_c": "DRP",
    "choice_d": "BCP",
    "correct_answer": "B",
    "explanation": "IT support departments typically have written agreements with the customers they support called service level agreements (SLAs). In some cases these agreements are with other departments of the same company for which they provide support. These agreements specify the type of support to be provided and the acceptable amount of time allowed to respond to support calls.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      74,
      60,
      73,
      78,
      79
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 71,
    "question": "Which of the following is a mobile server room cart equipped with a secured laptop that is used to provide a direct connection to malfunctioning servers and computers?",
    "choice_a": "Crash cart",
    "choice_b": "Secure cart",
    "choice_c": "Recovery cart",
    "choice_d": "Response cart",
    "correct_answer": "A",
    "explanation": "A crash cart is a mobile server room cart equipped with a secured laptop that is used to provide a direct connection to malfunctioning servers and computers for restoration of crashes. Crash carts should be designed for mobility, versatility, and durability.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      49,
      50,
      3,
      51,
      54
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 72,
    "question": "Which of the following is the IPv6 loopback address?",
    "choice_a": "::1",
    "choice_b": "FECO::1",
    "choice_c": "FE80::1",
    "choice_d": "2001::1",
    "correct_answer": "A",
    "explanation": "The IPv6 loopback address is all zeroes except for the last hextet, which is 1. It can be expressed as either 0:0:0:0:0:0:0:1 or ::1.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      136,
      137,
      141,
      143,
      135
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 73,
    "question": "Which of the following determines the IPv4 subnet in which a device resides?",
    "choice_a": "Default gateway",
    "choice_b": "IP address",
    "choice_c": "Subnet mask",
    "choice_d": "Host ID",
    "correct_answer": "C",
    "explanation": "When you configure TCP/IP for IPv4 on a host, you typically need only give three values: a unique IP address, a default gateway (router) address, and a subnet mask. It is the subnet mask that determines the network on which the host resides.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      137,
      130,
      136,
      132,
      143
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 74,
    "question": "Which of the following is a TCP/IP feature Microsoft added to their operating systems that has the clients automatically assign themselves an IP address, somewhat randomly, in the 169.254.x.x range with a subnet mask of 255.255.0.0 if a DHCP server cannot be found and the clients are configured to obtain IP addresses automatically?",
    "choice_a": "IPsec",
    "choice_b": "APIPA",
    "choice_c": "NAT",
    "choice_d": "NetBIOS",
    "correct_answer": "B",
    "explanation": "Automatic Private IP Addressing (APIPA) is a TCP/IP feature Microsoft added to their operating systems.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      143,
      142,
      137,
      138,
      130
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 75,
    "question": "What type of IPv6 address does every device generate for each network interface?",
    "choice_a": "Global unicast",
    "choice_b": "Link local",
    "choice_c": "Site local",
    "choice_d": "Multicast",
    "correct_answer": "B",
    "explanation": "In IPv6, there is a type of address called a link local address that the device will generate for each interface with no intervention from a human. The address is not routable and is only good on the segment the device is located on.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      143,
      136,
      142,
      137,
      132
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 76,
    "question": "Which of the following provides the slowest recovery but is the least expensive to maintain?",
    "choice_a": "Warm site",
    "choice_b": "Cold site",
    "choice_c": "Redundant site",
    "choice_d": "Hot site",
    "correct_answer": "B",
    "explanation": "A cold site provides the slowest recovery, but it is the least expensive to maintain. It is also the most difficult to test.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      158,
      161,
      155,
      159,
      156
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 77,
    "question": "Which of the following is designed to minimize the effects of a disaster?",
    "choice_a": "SLA",
    "choice_b": "DRP",
    "choice_c": "BIA",
    "choice_d": "BCP",
    "correct_answer": "B",
    "explanation": "A disaster recovery plan (DRP) minimizes the effect of a disaster and includes the steps necessary to resume normal operation.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      75,
      78,
      80,
      72,
      73
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 78,
    "question": "Which redundancy technique comes at the cost of having a server sitting idle until a failure occurs?",
    "choice_a": "Active/active",
    "choice_b": "Active/passive",
    "choice_c": "Hybrid/passive",
    "choice_d": "Active/hybrid",
    "correct_answer": "B",
    "explanation": "In an active/passive cluster, at least one of the servers in the cluster is not actively working but simply sitting idle until a failure occurs. This arrangement comes at the cost of having a server sitting idle until a failure occurs.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      78,
      80,
      81,
      79,
      84
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 79,
    "question": "Which backup type has the quickest restore?",
    "choice_a": "Incremental",
    "choice_b": "Copy",
    "choice_c": "Hybrid",
    "choice_d": "Differential",
    "correct_answer": "D",
    "explanation": "In an organization that uses a full/differential scheme, the full and only the most recent differential backup must be restored, meaning only two backups are needed to perform a restoration.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      149,
      150,
      151,
      155,
      157
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 80,
    "question": "What is the first step in the CompTIA troubleshooting model?",
    "choice_a": "Test the theory to determine the cause.",
    "choice_b": "Establish a theory of probable cause.",
    "choice_c": "Identify the problem and determine the scope.",
    "choice_d": "Establish a plan of action to resolve the problem and notify impacted users.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The steps in order are:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      162,
      163,
      164,
      165,
      166
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 81,
    "question": "Keeping slot covers in place prevents what event on a server?",
    "choice_a": "Overheating",
    "choice_b": "ESD",
    "choice_c": "Condensation",
    "choice_d": "RFI",
    "correct_answer": "A",
    "explanation": "Replacing slot covers is vital. Servers are designed to circulate air with slot covers in place or cards plugged into the ports. Leaving slots on the back of the computer open alters the air circulation and causes more dust to be pulled into the system.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      17,
      3,
      6,
      4,
      16
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 82,
    "question": "When the read/write heads of a hard drive are making contact with the platters, what is the sound called?",
    "choice_a": "Ping of Death",
    "choice_b": "Click of Death",
    "choice_c": "Face of Death",
    "choice_d": "Deadly Embrace",
    "correct_answer": "B",
    "explanation": "A loud clicking noise, sometimes referred to as the Click of Death, is caused by the read/write heads making contact with the platters. After that happens, both the heads and the platters become damaged, and the system becomes unable to establish a successful starting point to read the drive.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      219,
      167,
      216,
      221,
      224
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 83,
    "question": "Which of the following is a standard firmware interface for PCs that was designed to replace BIOS?",
    "choice_a": "TPM",
    "choice_b": "UEFI",
    "choice_c": "GRUB",
    "choice_d": "TRIOS",
    "correct_answer": "B",
    "explanation": "UEFI (Unified Extensible Firmware Interface) is a standard firmware interface for PCs that was designed to replace BIOS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      51,
      49,
      19,
      18
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 84,
    "question": "What is the prefix for an IPv6 link local address?",
    "choice_a": "FE80::",
    "choice_b": "::",
    "choice_c": "2001::",
    "choice_d": "1270::",
    "correct_answer": "A",
    "explanation": "Link local addresses are self-generated for each interface and always have FE80:: for a prefix.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      143,
      136,
      142,
      141,
      132
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 85,
    "question": "Which of the following is an APIPA-generated IP address?",
    "choice_a": "127.0.0.1",
    "choice_b": "169.2.6.9",
    "choice_c": "168.250.5.6",
    "choice_d": "169.254.5.9",
    "correct_answer": "D",
    "explanation": "Automatic Private IP Addressing (APIPA) is a TCP/IP feature Microsoft added to its operating systems. If a DHCP server cannot be found, the clients automatically assign themselves an IP address, somewhat randomly, in the 169.254.x.x range with a subnet mask of 255.255.0.0.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      143,
      138,
      137,
      130,
      142
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 86,
    "question": "You can ping a remote device by IP address but not by hostname. What service is the source of the problem?",
    "choice_a": "NAT",
    "choice_b": "DNS",
    "choice_c": "RRAS",
    "choice_d": "HTTP",
    "correct_answer": "B",
    "explanation": "When you can reach a device by IP address but not hostname, then name resolution is not working and that is the job of DNS.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      133,
      134,
      130,
      136,
      132
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 87,
    "question": "Which of the following is an example of a private IPv4 address?",
    "choice_a": "192.168.3.5",
    "choice_b": "11.2.2.2",
    "choice_c": "169.254.3.5",
    "choice_d": "172.26.2.2",
    "correct_answer": "A",
    "explanation": "The three ranges for private IP addresses are:<ul><li>10.0.0.0/8</li><li>172.16.0.0/12</li><li>192.168.0.0/16.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      138,
      130,
      142,
      143,
      43
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 88,
    "question": "Which of the following commands is used in Linux to attempt filesystem or drive repairs?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "<code>fdisk</code>",
    "choice_d": "<code>sfc</code>",
    "correct_answer": "A",
    "explanation": "In Linux you can use the <code>fsck</code> command to make a repair attempt. For example, the following command will check the sda1 partition:<br>fsck /dev/sda1.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      224,
      217,
      221,
      222,
      223
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 89,
    "question": "Which command can be used in Linux to identify performance information with respect to memory, CPU, and storage?",
    "choice_a": "<code>grub</code>",
    "choice_b": "<code>top</code>",
    "choice_c": "<code>fsck</code>",
    "choice_d": "<code>scannow</code>",
    "correct_answer": "B",
    "explanation": "Slow disk access can have a number or sources\u2014some may surprise you. While the actual disk itself may be the problem, you can also have low memory and CPU issues that manifest themselves as slow I/O. The root of the problem can be found by using the Linux command <code>top</code>.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      40,
      37,
      38,
      39,
      33
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 90,
    "question": "What can result from a cable that has a cut in the outer covering?",
    "choice_a": "Increased collisions",
    "choice_b": "Increased retransmissions",
    "choice_c": "Routing issues",
    "choice_d": "Duplex mismatches",
    "correct_answer": "B",
    "explanation": "Issues such as cuts in the outer cover and stressed connectors can cause the cable to allow noise into the cable (RFI, EMI) that causes packets to be damaged or corrupted. This leads to retransmissions and lower throughout.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      205,
      195,
      224,
      197,
      163
    ],
    "source": "891437_PracticeTest1"
  },
  {
    "id": 91,
    "question": "Which of the following server types requires a conversion kit to be installed in a rack?",
    "choice_a": "Virtual",
    "choice_b": "Tower",
    "choice_c": "Blade",
    "choice_d": "Rack",
    "correct_answer": "B",
    "explanation": "It is possible to place a tower server in a rack by using a conversion kit. The issue with this approach is that it wastes some space in the rack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      1,
      6,
      3,
      2
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 92,
    "question": "Which of the following attempts to avoid detection by masking itself from applications?",
    "choice_a": "Rootkit",
    "choice_b": "Stealth virus",
    "choice_c": "Multipartite virus",
    "choice_d": "Trojan",
    "correct_answer": "B",
    "explanation": "A stealth virus attempts to avoid detection by masking itself from applications. It may attach itself to the boot sector of the hard drive. When a system utility or program runs, the stealth virus redirects commands around itself to avoid detection.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      94,
      93,
      108,
      102,
      103
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 93,
    "question": "What component in a blade enclosure provides cooling and power to the blade servers?",
    "choice_a": "Rail kit",
    "choice_b": "Bay plugs",
    "choice_c": "Chassis",
    "choice_d": "PDU",
    "correct_answer": "C",
    "explanation": "A blade enclosure is a system that contains houses multiple blade servers. The chassis of the enclosure provides power and cooling to the blade servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      2,
      53,
      10,
      4
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 94,
    "question": "What is a backplane constructed with slots on both sides called?",
    "choice_a": "Dual backplane",
    "choice_b": "Bi-backplane",
    "choice_c": "Midplane",
    "choice_d": "Biplane",
    "correct_answer": "C",
    "explanation": "Some backplanes are constructed with slots on both sides, and in that case they are located in the middle of the enclosure and are called midplanes.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      17,
      10,
      21,
      1,
      4
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 95,
    "question": "If three 250 GB drives are used in RAID 5 array, how much space will be available?",
    "choice_a": "200 GB",
    "choice_b": "300 GB",
    "choice_c": "500 GB",
    "choice_d": "750 GB",
    "correct_answer": "B",
    "explanation": "A minimum of three drives is required. RAID 5 uses 1/<i>n</i> (<i>n</i> = the number of drives in the array) for parity information (for example, one third of the space in a three-drive array), and only 1 \u2013 (1/<i>n</i>) is available for data. So if three 250 GB drives are used in the array (for a total of 750 GB), 500 GB will be the available drive space.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      62,
      21,
      52,
      64
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 96,
    "question": "Which RAID type offers the most options and best performance?",
    "choice_a": "Virtual RAID",
    "choice_b": "Hardware RAID",
    "choice_c": "Software RAID",
    "choice_d": "Hybrid RAID",
    "correct_answer": "B",
    "explanation": "Hardware RAID allows for more types of configurations (for example, including the operating system in a RAID 5 array) and, because it is managed by a hardware controller, better performance.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      62,
      61,
      21,
      52,
      64
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 97,
    "question": "Which statement is false with regard to the ext4 filesystem?",
    "choice_a": "It supports individual file sizes up to 16 TB.",
    "choice_b": "The overall maximum ext4 filesystem size is 2 EB.",
    "choice_c": "The directory can contain 64,000 subdirectories.",
    "choice_d": "You can mount an existing ext3 filesystem as an ext4 filesystem (without having to upgrade it).",
    "correct_answer": "B",
    "explanation": "The following are the strengths of ext4:<ul><li>It supports individual file sizes up to 16 TB.</li><li>The overall maximum ext4 filesystem size is 1 EB (exabyte). [1 EB = 1024 PB (petabyte). 1 PB = 1024 TB (terabyte)].</li><li>The directory can contain 64,000 subdirectories as opposed to 32,000 in ext3.</li><li>You can mount an existing ext3 filesystem as an ext4 filesystem (without having to upgrade it).</li><li>It improves the performance and reliability of the filesystem when compared to ext3.</li><li>In ext4, you also have the option of turning off the journaling feature.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      31,
      68,
      35,
      37,
      40
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 98,
    "question": "Which operating system introduced NTFS?",
    "choice_a": "Windows 95",
    "choice_b": "Windows 98",
    "choice_c": "Windows NT",
    "choice_d": "Windows 2000",
    "correct_answer": "C",
    "explanation": "Introduced along with Windows NT (and available on all Windows Server and client operating systems), NTFS (NT File System) is a much more advanced filesystem in almost every way than all versions of the FAT filesystem.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      31,
      24,
      28,
      27,
      29
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 99,
    "question": "Which filesystem was developed by Sun Microsystems?",
    "choice_a": "VMFS",
    "choice_b": "ZFS",
    "choice_c": "ReiserFS",
    "choice_d": "UFS",
    "correct_answer": "B",
    "explanation": "Zettabyte File System was developed by Sun Microsystems, but it is an open source project as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      31,
      58,
      24,
      28,
      32
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 100,
    "question": "Which server role authenticates users to the network?",
    "choice_a": "Web server",
    "choice_b": "Application server",
    "choice_c": "Directory server",
    "choice_d": "Database server",
    "correct_answer": "C",
    "explanation": "A directory server accepts and verifies the credentials of users. Typically, it not only authenticates them but also provides them with access to resources using single sign-on.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      133,
      142,
      141,
      34,
      35
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 101,
    "question": "What factor drives the numbers of processors required for a file server?",
    "choice_a": "The total number of users",
    "choice_b": "The number of concurrent users you expect",
    "choice_c": "The number of files on the server",
    "choice_d": "The size of the file on the server",
    "correct_answer": "B",
    "explanation": "The number of processors is driven by the number of concurrent users you expect and whether you will be doing encryption on the server.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      35,
      33,
      36,
      68,
      82
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 102,
    "question": "What is typically the resources bottleneck on an email server?",
    "choice_a": "CPU",
    "choice_b": "NIC",
    "choice_c": "Memory",
    "choice_d": "Disk",
    "correct_answer": "D",
    "explanation": "The disk system is most often the bottleneck on an email server. It should be high speed, perhaps solid state, and it should be configured in a RAID5 configuration unless you are using a distributed configuration and the server is not the mailbox server.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      61,
      64,
      65,
      62,
      53
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 103,
    "question": "Which server role requires the least computing resources?",
    "choice_a": "NTP",
    "choice_b": "DNS",
    "choice_c": "DHCP",
    "choice_d": "RRAS",
    "correct_answer": "A",
    "explanation": "NTP servers do not typically have high resource requirements, and this service is a good candidate to add to a server already performing another role.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      33,
      34,
      35,
      142,
      24
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 104,
    "question": "Which of the following is <i>not</i> true of a NAS?",
    "choice_a": "A NAS is easily accessed over TCP/IP Ethernet-based networks.",
    "choice_b": "Implementing a NAS is inexpensive.",
    "choice_c": "A NAS typically supports multiple RAID methods.",
    "choice_d": "A NAS has lower latency and higher reliability than a SAN.",
    "correct_answer": "D",
    "explanation": "A NAS has higher latency and lower reliability than a SAN.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      67,
      15,
      62,
      61,
      53
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 105,
    "question": "Which type of data access is provided by SAN?",
    "choice_a": "File level",
    "choice_b": "Block level",
    "choice_c": "Folder level",
    "choice_d": "Drive level",
    "correct_answer": "B",
    "explanation": "A key difference between the operation of a NAS and that of a SAN is that a SAN provides block-level access to data as opposed to a NAS, which provides file-level access to data.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      67,
      62,
      61,
      66,
      52
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 106,
    "question": "Which of the following encapsulates SCSI commands within IP packets?",
    "choice_a": "FCoE",
    "choice_b": "iSCSI",
    "choice_c": "EAP",
    "choice_d": "GRE",
    "correct_answer": "B",
    "explanation": "Internet Small Computer System Interface (iSCSI) is an IP-based networking storage standard method of encapsulating SCSI commands (which are used with storage area networks) within IP packets.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      67,
      66,
      20,
      21,
      52
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 107,
    "question": "Which of the following is <i>not</i> an advantage of iSCSI?",
    "choice_a": "Simplicity, due to its reliance on Ethernet",
    "choice_b": "Elimination of distance limitations imposed by SCSI transfers",
    "choice_c": "Not being susceptible to network congestion",
    "choice_d": "Low cost in simple deployments",
    "correct_answer": "C",
    "explanation": "On the contrary, iSCSI is susceptible to network congestion.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      67,
      15,
      20,
      11,
      13
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 108,
    "question": "How is JBOD different from RAID 5?",
    "choice_a": "JBOD provides fault tolerance.",
    "choice_b": "JBOD requires four disks.",
    "choice_c": "JBOD uses a single disk.",
    "choice_d": "JBOD does not provide fault tolerance.",
    "correct_answer": "D",
    "explanation": "The acronym JBOD refers to \u201cjust a bunch of disks.\u201d The disks in this \u201cbunch of disks\u201d are independent of one another, unlike disks that participate in a RAID arrangement of some sort. While the data may be striped across the disks, no fault tolerance is provided.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      61,
      63,
      62,
      21,
      66
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 109,
    "question": "Which of the following uses sequential access to the data?",
    "choice_a": "Tape drive",
    "choice_b": "External drive",
    "choice_c": "CD",
    "choice_d": "DVD",
    "correct_answer": "A",
    "explanation": "One of the historical shortcomings of tape is its sequential access method.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      67,
      61,
      62,
      64,
      63
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 110,
    "question": "What Windows folder contains all the files that are required for a Windows installation and for updates?",
    "choice_a": "<code>WINNT\\winsxs</code>",
    "choice_b": "<code>Windows\\winsxs</code>",
    "choice_c": "<code>Windows\\winup</code>",
    "choice_d": "<code>Windows\\install</code>",
    "correct_answer": "B",
    "explanation": "The folder called <code>Windows\\winsxs</code> contains all the files that are required for a Windows installation. Any updates to those files are also held within this folder, also called the component store as the updates are installed.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      24,
      25,
      29,
      28,
      27
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 111,
    "question": "How many bits are in an IPv6 address?",
    "choice_a": "32",
    "choice_b": "64",
    "choice_c": "128",
    "choice_d": "256",
    "correct_answer": "C",
    "explanation": "IPv6 uses a 128-bit addressing scheme, allowing a huge number of possible addresses.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      136,
      137,
      130,
      131,
      132
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 112,
    "question": "How does RAID 6 differ from RAID 5?",
    "choice_a": "RAID 6 can recover from a two-drive failure whereas RAID 5 cannot.",
    "choice_b": "RAID 5 can recover from a two-drive failure whereas RAID 6 cannot.",
    "choice_c": "RAID 6 can recover from a three-drive failure whereas RAID 5 cannot.",
    "choice_d": "RAID 5 can recover from a three-drive failure whereas RAID 5 cannot.",
    "correct_answer": "A",
    "explanation": "RAID 6 writes parity information across the drives as is done in RAID 5, but it writes two stripes, which allows the system to recover from a two-drive failure, whereas RAID 5 cannot.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      64,
      63,
      65
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 113,
    "question": "When you utilize compression to save disk space, what resource will be stressed when opening and closing compressed files?",
    "choice_a": "Memory",
    "choice_b": "NIC",
    "choice_c": "Disk",
    "choice_d": "CPU",
    "correct_answer": "D",
    "explanation": "Be aware that when you compress files and folders that are frequently accessed you will be placing a load on the CPU of the server as it decompresses the file to make it available and then compresses it again when saved.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      40,
      46,
      33,
      36,
      34
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 114,
    "question": "Which type of IDS requires constant updating?",
    "choice_a": "Signature-based",
    "choice_b": "Anomaly-based",
    "choice_c": "HIDS",
    "choice_d": "NIDS",
    "correct_answer": "A",
    "explanation": "A signature-based IDS, which can be either host-based (HIDS) or network-based (NIDS), analyzes traffic and compares patterns, called signatures, that reside within the IDS database. This means it requires constant updating of the signature database.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      108,
      94,
      102,
      103,
      104
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 115,
    "question": "In a biometric authentication system, what is it called when a user who should not be permitted access is permitted access?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "True negative",
    "choice_d": "True positive",
    "correct_answer": "A",
    "explanation": "A false positive means the system allowed someone in who should not have been allowed in. A false negative occurs when a legitimate user is denied entry.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      86,
      122,
      125,
      90,
      87
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 116,
    "question": "The purpose of which of the following is to grant access to all resources with a single password?",
    "choice_a": "Secondary authentication",
    "choice_b": "Single sign-on",
    "choice_c": "Pass-through authentication",
    "choice_d": "MAC bypass",
    "correct_answer": "B",
    "explanation": "The purpose of a single sign-on (SSO) is to give users access to all the applications and systems they need when they log on. This has become a reality in many environments, including Kerberos, Microsoft Active Directory, Novell eDirectory, and some certificate model implementations.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      123,
      118,
      117,
      125,
      121
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 117,
    "question": "Which of the following is the amount of time a UPS can provide power at a given level?",
    "choice_a": "Capacity",
    "choice_b": "Runtime",
    "choice_c": "VA",
    "choice_d": "Load",
    "correct_answer": "B",
    "explanation": "The runtime is the amount of time that the UPS can provide power at a given power level.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      8,
      4,
      6,
      7,
      9
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 118,
    "question": "What is a firewall with two network interface cards (NICs) called?",
    "choice_a": "Multihoned",
    "choice_b": "Dual-homed",
    "choice_c": "Binet",
    "choice_d": "Dual-net",
    "correct_answer": "B",
    "explanation": "Any type of firewall that has two NICs is referred to as a dual-homed firewall. One of the cards is connected to the outside network, and the other is connected to the internal network.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      140,
      139,
      141,
      39,
      83
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 119,
    "question": "What type of firewall reads the individual commands of the protocols that are being served?",
    "choice_a": "Packet filtering",
    "choice_b": "Application-level proxy",
    "choice_c": "Stateful",
    "choice_d": "Dual-homed",
    "correct_answer": "B",
    "explanation": "The proxy function can occur at either the application level or the session level of the OSI model. Application-level proxy functions read the individual commands of the protocols that are being served.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      106,
      113,
      107,
      93,
      94
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 120,
    "question": "With which type of firewall are records kept using a table that tracks every communications channel?",
    "choice_a": "Proxy",
    "choice_b": "Stateful",
    "choice_c": "Application-level proxy",
    "choice_d": "Dual-homed",
    "correct_answer": "B",
    "explanation": "In stateful inspection (or stateful packet filtering), records are kept using a state table that tracks every communications channel. Stateful inspections occur at all levels of the network and provide additional security, especially in connectionless protocols such as User Datagram Protocol (UDP) and Internet Control Message Protocol (ICMP).",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      106,
      108,
      110,
      113,
      121
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 121,
    "question": "Which of the following is a circuit board that fits into an Industry Standard Architecture (ISA) or Peripheral Component Interconnect (PCI) expansion slot in the motherboard and reports numeric codes as the boot process progresses?",
    "choice_a": "boot card",
    "choice_b": "error link",
    "choice_c": "POST card",
    "choice_d": "test link",
    "correct_answer": "C",
    "explanation": "Each of those codes corresponds to a particular component being checked. If the POST card stops at a certain number, you can look up that number in the manual that came with the card to determine the problem.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      171,
      181,
      168,
      178,
      193
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 122,
    "question": "Which of the following is the prefix for an IPv6 link local address?",
    "choice_a": "2001::",
    "choice_b": "FE80::",
    "choice_c": "FEC0::",
    "choice_d": "FE20::",
    "correct_answer": "B",
    "explanation": "The devices always generate the address using the same IPv6 prefix (the equivalent of a network ID in IPv4), which is FE80::/64. The remainder of the address is created by spreading the 48-bit MAC address across the last 64 bits.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      143,
      136,
      137,
      141,
      142
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 123,
    "question": "What must be used to allow DHCP broadcasts to go from one network to another?",
    "choice_a": "NAT",
    "choice_b": "PAT",
    "choice_c": "DHCP relay agent",
    "choice_d": "DHCP NAT",
    "correct_answer": "C",
    "explanation": "The client uses broadcasts to request the data and thus\u2014normally\u2014can\u2019t communicate with DHCP servers beyond their own subnet (broadcasts don\u2019t route). A DHCP relay agent, however, can be employed to allow DHCP broadcasts to go from one network to another.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      132,
      26,
      137,
      131
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 124,
    "question": "Which technology utilizes FQDNs?",
    "choice_a": "NAT",
    "choice_b": "DNS",
    "choice_c": "IPSec",
    "choice_d": "Teredo",
    "correct_answer": "B",
    "explanation": "Fully qualified domain names (FQDN) identify the host and the location of the hostname in the DNS namespace of the organization. It consists of at least two parts and perhaps more.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      134,
      133,
      135,
      141,
      142
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 125,
    "question": "In which allocation system does the load balancer allocate work requests to each server sequentially, resulting in each getting an equal number of requests?",
    "choice_a": "Most recently used",
    "choice_b": "Round robin",
    "choice_c": "Last used",
    "choice_d": "Weighted round robin",
    "correct_answer": "B",
    "explanation": "In a round robin allocation system, the load balancer allocates work requests to each server sequentially, resulting in each getting an equal number of requests. This could mean that a user may make two requests that actually go to two different servers.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      81,
      80,
      46,
      78,
      83
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 126,
    "question": "Which of the following is a leased facility that contains all the resources needed for full operation?",
    "choice_a": "Warm site",
    "choice_b": "Cold site",
    "choice_c": "Hot site",
    "choice_d": "Dual site",
    "correct_answer": "C",
    "explanation": "A hot site is a leased facility that contains all the resources needed for full operation. This environment includes computers, raised flooring, full utilities, electrical and communications wiring, networking equipment, and uninterruptible power supplies (UPSs).",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      158,
      159,
      114,
      154,
      88
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 127,
    "question": "Which of the following is the process of combining multiple physical network connections into a single logical interface?",
    "choice_a": "Trunking",
    "choice_b": "NIC teaming",
    "choice_c": "Dual piping",
    "choice_d": "Combonet",
    "correct_answer": "B",
    "explanation": "Redundancy can be provided at the network interface level. NIC teaming is the process of combining multiple physical network connections into a single logical interface. This process goes by other names as well, including <i>link aggregation</i> and <i>link bonding</i>.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      84,
      82,
      83,
      80,
      81
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 128,
    "question": "Which of the following is a full backup performed by synthesizing the data from the previous full backup (either a regular full backup for the first backup, or the previous synthetic full backup) and the periodic incremental backups?",
    "choice_a": "Incremental backup",
    "choice_b": "Differential backup",
    "choice_c": "Synthetic full backup",
    "choice_d": "Full backup",
    "correct_answer": "C",
    "explanation": "The incremental backups are the only files that need to be transferred during replication, greatly reducing the bandwidth needed for offsite replication.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      150,
      149,
      159,
      153,
      157
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 129,
    "question": "During what type of backup is the current status of the archive bit ignored, everything is backed up, and the archive bit for each file is cleared?",
    "choice_a": "Differential",
    "choice_b": "Full",
    "choice_c": "Incremental",
    "choice_d": "Daily",
    "correct_answer": "B",
    "explanation": "A full backup takes the longest time and the most space to complete. However, if an organization only uses full backups, then only the latest full backup needs to be restored, meaning it is the quickest restore.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      149,
      150,
      157,
      155,
      151
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 130,
    "question": "What is the last step in the CompTIA troubleshooting model?",
    "choice_a": "Test the theory to determine the cause.",
    "choice_b": "Document findings, actions, and outcomes throughout the process.",
    "choice_c": "Identify the problem and determine the scope.",
    "choice_d": "Establish a plan of action to resolve the problem and notify impacted users.",
    "correct_answer": "B",
    "explanation": "The steps in order are:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      164,
      163,
      162,
      166,
      165
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 131,
    "question": "How are POST issues reported during startup when the display is not functional?",
    "choice_a": "Beep code",
    "choice_b": "LEDs",
    "choice_c": "Stored in a log",
    "choice_d": "Memory dump",
    "correct_answer": "A",
    "explanation": "If the system boots to the point where the video driver is loaded and the display is operational, any problems will be reported with a numeric error code. If the system cannot boot to that point, problems will be reported with a beep code.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      171,
      168,
      174,
      187,
      162
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 132,
    "question": "What should the ambient temperature inside a server be?",
    "choice_a": "35\u201355 degrees",
    "choice_b": "45\u201365 degrees",
    "choice_c": "60\u201390 degrees",
    "choice_d": "70\u2013100 degrees",
    "correct_answer": "C",
    "explanation": "Take care to keep the ambient air within normal ranges (approximately 60\u201390 degrees Fahrenheit) and at a constant temperature.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      89,
      88,
      91,
      85,
      87
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 133,
    "question": "Which of the following is only used in email?",
    "choice_a": "Security groups",
    "choice_b": "Distribution groups",
    "choice_c": "Domain groups",
    "choice_d": "Organizational units",
    "correct_answer": "B",
    "explanation": "Security groups are used to assign rights and permissions. A second type of group is a distribution group, also called a distribution list. These are groups used in email. When a distribution group is created, its main function is to serve as a group to which an email can be sent and every member of the group receives the email.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      118,
      124,
      117,
      123,
      122
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 134,
    "question": "Which of the following can occur if humidity levels are too low?",
    "choice_a": "RFI",
    "choice_b": "EMI",
    "choice_c": "ESD",
    "choice_d": "Crosstalk",
    "correct_answer": "C",
    "explanation": "It is a balancing act keeping humidity at the right level since low humidity causes electrostatic discharge (ESD) and high humidity causes moisture condensation.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      176,
      177,
      175,
      162,
      163
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 135,
    "question": "Which of the following is a Linux tool for detecting bad sectors?",
    "choice_a": "<code>fstab</code>",
    "choice_b": "<code>badblocks</code>",
    "choice_c": "<code>chkdsk</code>",
    "choice_d": "<code>grub</code>",
    "correct_answer": "B",
    "explanation": "<code>badblocks</code> has several different modes to be able to detect bad sectors in Linux.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      219,
      217,
      221,
      224,
      228
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 136,
    "question": "Which command on a Windows device would be the best to use to determine exactly where in the network the packet is being dropped?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>traceroute</code>",
    "correct_answer": "C",
    "explanation": "The <code>tracert</code> command (called <code>traceroute</code> in Linux and Unix) is used to trace the path of a packet through the network. Its best use is in determining exactly where in the network the packet is being dropped. It will show each hop (router) the packet crosses and how long it takes to do so.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      195,
      204,
      196,
      163,
      197
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 137,
    "question": "Which of the following is not a switch used with the <code>ipconfig</code> command?",
    "choice_a": "<code>release</code>",
    "choice_b": "<code>flushdns</code>",
    "choice_c": "<code>renew</code>",
    "choice_d": "<code>clearcache</code>",
    "correct_answer": "D",
    "explanation": "While <code>/release</code> and <code>/renew</code> can be used to release and renew a dynamically acquired IP configuration, and <code>/flushdns</code> is used to delete the DNS revolver cache, there is no <code>clearcache</code> switch.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      198,
      196,
      204,
      199,
      195
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 138,
    "question": "What command generated the following output?<br><code> Default Server:  nameserver1.domain.com</code><br><code>   Address:  10.0.0.1</code><br><code> &gt;  </code>",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>ifconfig</code>",
    "choice_d": "<code>nethost</code>",
    "correct_answer": "A",
    "explanation": "The <code>nslookup</code> command is a command-line administrative tool for testing and troubleshooting DNS servers.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      204,
      203,
      199,
      196,
      195
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 139,
    "question": "Which command shows a real-time view of running processes in Linux?",
    "choice_a": "<code>lilo</code>",
    "choice_b": "<code>top</code>",
    "choice_c": "<code>grub</code>",
    "choice_d": "<code>fixboot</code>",
    "correct_answer": "B",
    "explanation": "In Linux, the <code>top</code> command provides a system information summary that shows resource utilization, including CPU and memory usage.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      40,
      37,
      36,
      34,
      33
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 140,
    "question": "Which of the following is a tool used in Linux to mount partitions on boot?",
    "choice_a": "<code>fstab</code>",
    "choice_b": "<code>top</code>",
    "choice_c": "<code>grub</code>",
    "choice_d": "<code>fixboot</code>",
    "correct_answer": "A",
    "explanation": "<code>fstab</code> (File System Table) is a file used by Linux operating systems to mount partitions on boot.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      29,
      24,
      31,
      28,
      27
    ],
    "source": "891437_PracticeTest2"
  },
  {
    "id": 141,
    "question": "Which term refers to the size, appearance, or dimensions of a server?",
    "choice_a": "Form factor",
    "choice_b": "Footprint",
    "choice_c": "Physical reference",
    "choice_d": "Outline",
    "correct_answer": "A",
    "explanation": "When we use the term <i>form factor</i> when discussing any computing device or component, we are talking about its size, appearance, or dimensions. It is typically used to differentiate one physical implementation of the same device or component from another. In the case of servers, we are talking about the size and dimensions of the enclosure in which the server exists.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      17,
      1,
      6,
      64,
      53
    ],
    "source": "891437_c01"
  },
  {
    "id": 142,
    "question": "Which of the following is used to make physical maintenance easier with a rack server?",
    "choice_a": "KVM",
    "choice_b": "Rail kits",
    "choice_c": "Baffles",
    "choice_d": "Rack slot",
    "correct_answer": "B",
    "explanation": "Rail kits, when implemented, allow you to slide the server out of the rack for maintenance.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      17,
      3,
      16,
      53,
      2
    ],
    "source": "891437_c01"
  },
  {
    "id": 143,
    "question": "How large is each U in a rack?",
    "choice_a": "19 inches.",
    "choice_b": "4.445 inches.",
    "choice_c": "1.75 inches.",
    "choice_d": "It depends on the rack.",
    "correct_answer": "C",
    "explanation": "Each U is 1.75 inches (4.445 cm) high.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      1,
      3,
      17,
      2,
      6
    ],
    "source": "891437_c01"
  },
  {
    "id": 144,
    "question": "What technology consists of a server chassis housing multiple thin, modular circuit boards, each of which acts as a server?",
    "choice_a": "Rack servers",
    "choice_b": "Towers",
    "choice_c": "KVM",
    "choice_d": "Blade technology",
    "correct_answer": "D",
    "explanation": "This technology consists of a server chassis housing multiple thin, modular circuit boards, known as server blades. Each blade (or card) contains processors, memory, integrated network controllers, and other input/output (I/O) ports.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      17,
      1,
      6,
      10,
      21
    ],
    "source": "891437_c01"
  },
  {
    "id": 145,
    "question": "What type of CPU cache holds data that is waiting to enter the CPU?",
    "choice_a": "L1",
    "choice_b": "L2",
    "choice_c": "L3",
    "choice_d": "L4",
    "correct_answer": "C",
    "explanation": "The Level 1 cache, also known as the L1 or front-side cache, holds data that is waiting to enter the CPU. On modern systems, the L1 cache is built into the CPU.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      22,
      23,
      18,
      54,
      51
    ],
    "source": "891437_c01"
  },
  {
    "id": 146,
    "question": "What term describes the relationship between the internal speed of the CPU and the speed of the system bus?",
    "choice_a": "CPU time",
    "choice_b": "Multiplier",
    "choice_c": "Differential",
    "choice_d": "Coefficient",
    "correct_answer": "B",
    "explanation": "The internal speed may be the same as the motherboard\u2019s speed (the external or bus speed), but it\u2019s more likely to be a multiple of it. For example, a CPU may have an internal speed of 1.3 GHz but an external speed of 133 MHz. That means for every tick of the system crystal\u2019s clock, the CPU has 10 internal ticks of its own clock.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      23,
      19,
      21,
      20,
      51
    ],
    "source": "891437_c01"
  },
  {
    "id": 147,
    "question": "What term describes the time the CPU was executing in kernel mode?",
    "choice_a": "User time",
    "choice_b": "Steal time",
    "choice_c": "System time",
    "choice_d": "Idle time",
    "correct_answer": "C",
    "explanation": "When monitoring CPU performance, the following are common metrics and their meanings:<br><b>User time</b>\u2014The time the CPU was busy executing code in user space <br><b>System time</b>\u2014The time the CPU was busy executing code in kernel space <br><b>Idle time</b>\u2014The time the CPU was not busy; measures unused CPU capacity <br><b>Steal time (virtualized hardware)</b>\u2014The time the operating system wanted to execute but was not allowed to by the hypervisor, because it was not the CPU\u2019s turn for a time.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      23,
      19,
      6,
      8,
      51
    ],
    "source": "891437_c01"
  },
  {
    "id": 148,
    "question": "What are revisions in CPUs called?",
    "choice_a": "Service packs",
    "choice_b": "Hot fixes",
    "choice_c": "Base layers",
    "choice_d": "Stepping levels",
    "correct_answer": "D",
    "explanation": "When CPUs undergo revisions, the revisions are called stepping levels. When a manufacturer invests money to do a stepping, that means they have found bugs in the logic or have made improvements to the design that allow for faster processing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      22,
      18,
      51,
      54
    ],
    "source": "891437_c01"
  },
  {
    "id": 149,
    "question": "Which CPU architecture was designed for a tablet?",
    "choice_a": "ARM",
    "choice_b": "x86",
    "choice_c": "x64",
    "choice_d": "LGA",
    "correct_answer": "A",
    "explanation": "ARM requires fewer resources than either x86 or the x64. In that regard they are suitable for tablets, smartphones, and other smaller devices.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      18,
      19,
      17,
      20,
      21
    ],
    "source": "891437_c01"
  },
  {
    "id": 150,
    "question": "DDR3 memory is _______ as fast as DDR2.",
    "choice_a": "Three times",
    "choice_b": "Twice",
    "choice_c": "Half",
    "choice_d": "One-third",
    "correct_answer": "B",
    "explanation": "The primary benefit of DDR3 over DDR2 is that it transfers data at twice the rate of DDR2 (eight times the speed of its internal memory arrays), enabling higher bandwidth or peak data rates.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      19,
      22,
      23,
      18,
      52
    ],
    "source": "891437_c01"
  },
  {
    "id": 151,
    "question": "True/False: DDR doubles the rate by accessing the memory module twice per clock cycle.",
    "choice_a": "True",
    "choice_b": "False",
    "choice_c": "",
    "choice_d": "",
    "correct_answer": "A",
    "explanation": "True.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      22,
      23,
      6,
      52
    ],
    "source": "891437_c01"
  },
  {
    "id": 152,
    "question": "What statement is true with regard to dual-channel memory?",
    "choice_a": "Installing different size modules in the same bank will result in the modules operating in single-channel mode.",
    "choice_b": "Installing different size modules in the same bank will result in the modules operating in dual-channel mode.",
    "choice_c": "Installing equal size modules in the same bank will result in the modules operating in single-channel mode.",
    "choice_d": "Installing different size modules in the same bank will increase the performance of the bank.",
    "correct_answer": "A",
    "explanation": "When installing the memory, install the same size modules in the same bank. If you do not, the modules will not operate in dual-channel mode. This will impair the performance of the bank.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      19,
      54,
      51,
      22,
      23
    ],
    "source": "891437_c01"
  },
  {
    "id": 153,
    "question": "Which of the following is the time to access a memory address column if the correct row is already open?",
    "choice_a": "CAS Latency",
    "choice_b": "Row Address to Column Address Delay",
    "choice_c": "Row Precharge Time",
    "choice_d": "Row Active Time",
    "correct_answer": "A",
    "explanation": "<i>Memory timing measures the performance of RAM and is composed of four components:</i><br><i><b>CAS Latency</b></i>\u2014<i>The time to access</i> an address column if the correct row is already open <br><b>Row Address to Column Address Delay</b>\u2014The time to read the first bit of memory without an active row <br><b>Row Precharge Time</b>\u2014The time to access an address column if the wrong row is open <br><b>Row Active Time</b>\u2014The time needed to internally refresh a row.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      19,
      23,
      22,
      52,
      6
    ],
    "source": "891437_c01"
  },
  {
    "id": 154,
    "question": "Which of the following can be mixed when installing memory? (Choose two.)",
    "choice_a": "Different speeds",
    "choice_b": "Different types",
    "choice_c": "Different form factors",
    "choice_d": "Different manufacturers",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "You can mix speeds and manufacturers but not form factors or types.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      18,
      54,
      52,
      21,
      51
    ],
    "source": "891437_c01"
  },
  {
    "id": 155,
    "question": "Which of the following is a double-wide version of the 32-bit PCI local bus?",
    "choice_a": "PCI",
    "choice_b": "PCI-X",
    "choice_c": "PCIe",
    "choice_d": "PCI/2",
    "correct_answer": "B",
    "explanation": "PCI-extended (PCI-X) is a double-wide version of the 32-bit PCI local bus. It runs at up to four times the clock speed, achieving higher bandwidth, but otherwise uses the same protocol and a similar electrical implementation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      21,
      11,
      15,
      1
    ],
    "source": "891437_c01"
  },
  {
    "id": 156,
    "question": "Which type of NIC detects the type of device on the other end and changes the use of the wire pairs accordingly?",
    "choice_a": "Auto-MDIX",
    "choice_b": "Full-duplex",
    "choice_c": "Converged",
    "choice_d": "HBA",
    "correct_answer": "A",
    "explanation": "An auto-MDIX card is capable of detecting what type of device is on the other end and changing the use of the wire pairs accordingly. For example, normally a PC connected to another PC requires a crossover cable, but if both ends can perform this sensing, that is not required.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      20,
      12,
      15,
      11,
      14
    ],
    "source": "891437_c01"
  },
  {
    "id": 157,
    "question": "What type of NIC acts as both a host bus adapter (HBA) for the SAN and the network card for the server?",
    "choice_a": "Auto-MDIX",
    "choice_b": "Full-duplex",
    "choice_c": "Converged",
    "choice_d": "HBA",
    "correct_answer": "C",
    "explanation": "Many servers attach to storage networks and may run converged network adapters (CNAs), which act both as a host bus adapter (HBA) for the SAN and as the network card for the server.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      20,
      67,
      14,
      66,
      15
    ],
    "source": "891437_c01"
  },
  {
    "id": 158,
    "question": "Which of the following supplies power connections to various components?",
    "choice_a": "Cable management arm",
    "choice_b": "Front plane",
    "choice_c": "Midplane",
    "choice_d": "MBP",
    "correct_answer": "C",
    "explanation": "The midplane or backplane also supplies power connections to various components. When a midplane is in use, connections are provided on the back side for power modules.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      10,
      4,
      7,
      9,
      53
    ],
    "source": "891437_c01"
  },
  {
    "id": 159,
    "question": "What is the height of a 2U system?",
    "choice_a": "1.75\u2033",
    "choice_b": "3.5\u2033",
    "choice_c": "5.25\u2033",
    "choice_d": "7\u2033",
    "correct_answer": "B",
    "explanation": "1U and 2U systems are 1.75\u2033 and 3.5\u2033, respectively.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      1,
      17,
      3,
      4,
      53
    ],
    "source": "891437_c01"
  },
  {
    "id": 160,
    "question": "Which of the following is a multiple-disk technology that either increases performance or allows for the automatic recovery of data from a failed hard drive by simply replacing the failed drive?",
    "choice_a": "DLP",
    "choice_b": "RAID",
    "choice_c": "UEFUI",
    "choice_d": "SFP",
    "correct_answer": "B",
    "explanation": "There are several types of RAID that provide varying degrees of increased performance and/or fault tolerance. All of these techniques involve two or more hard drives operating together in some fashion.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      61,
      62,
      53,
      21,
      64
    ],
    "source": "891437_c01"
  },
  {
    "id": 161,
    "question": "Which of the following is <i>not</i> true with respect to UEFI?",
    "choice_a": "It provides better security by helping to protect the preboot process.",
    "choice_b": "It provides faster startup and resuming from hibernation times.",
    "choice_c": "It does not provide support for drives larger than 2.2 terabytes (TB).",
    "choice_d": "It supports modern, 64-bit firmware device drivers.",
    "correct_answer": "C",
    "explanation": "Some of the enhancements this new interface provides are better security by helping to protect the preboot process against bootkit attacks; faster startup and resuming from hibernation times; support for drives larger than 2.2 TB; support for modern, 64-bit firmware device drivers that the system can use to address more than 17.2 billion GB of memory during startup; and capability to use BIOS with UEFI hardware.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      27,
      24,
      28,
      25,
      29
    ],
    "source": "891437_c02"
  },
  {
    "id": 162,
    "question": "What is the minimum RAM required to run Windows Server 2022?",
    "choice_a": "128 MB",
    "choice_b": "256 MB",
    "choice_c": "512 MB",
    "choice_d": "1 GB",
    "correct_answer": "C",
    "explanation": "Windows Server 2022 requires the following:<ul><li><b>Processor:</b> 1.4 GHz 64-bit processor compatible with x64 instruction set</li><li><b>Memory/RAM:</b> 512 MB</li><li><b>Disk space</b>: Minimum 32 GB (Windows Server 2022 using the Server Core installation option).</li></ul>",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      24,
      28,
      25,
      29,
      27
    ],
    "source": "891437_c02"
  },
  {
    "id": 163,
    "question": "Which of the following is a Microsoft filesystem?",
    "choice_a": "ext2",
    "choice_b": "NTFS",
    "choice_c": "ReiserFS",
    "choice_d": "UFS",
    "correct_answer": "B",
    "explanation": "Introduced by Microsoft along with Windows NT (and available on all Windows Server operating systems), NTFS is a much more advanced filesystem in almost every way than all versions of the FAT filesystem.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      31,
      24,
      27,
      28,
      25
    ],
    "source": "891437_c02"
  },
  {
    "id": 164,
    "question": "Which filesystem was created by Sun Microsystems?",
    "choice_a": "ext2",
    "choice_b": "ZFS",
    "choice_c": "ReiserFS",
    "choice_d": "UFS",
    "correct_answer": "B",
    "explanation": "The Zettabyte File System (ZFS) was developed by Sun Microsystems. It is part of Sun\u2019s Solaris operating system and is thus available on both SPARC and x86-based systems, but it\u2019s also an open source project.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      24,
      28,
      58,
      44
    ],
    "source": "891437_c02"
  },
  {
    "id": 165,
    "question": "Where is the swap file located?",
    "choice_a": "In memory",
    "choice_b": "In the L1 cache",
    "choice_c": "On the hard drive",
    "choice_d": "Across the network",
    "correct_answer": "C",
    "explanation": "Today\u2019s operating systems support the use of swap files. These are files located on the hard drive that are used to temporarily hold items moved from memory when there is a shortage of memory required for a particular function.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      31,
      36,
      33,
      34
    ],
    "source": "891437_c02"
  },
  {
    "id": 166,
    "question": "During which type of installation do you walk through the installation and answer the questions as prompted?",
    "choice_a": "Unattended",
    "choice_b": "Attended",
    "choice_c": "Image",
    "choice_d": "Bare-metal",
    "correct_answer": "B",
    "explanation": "During an attended installation, you walk through the installation and answer the questions as prompted. Questions typically ask for the product key, the directory in which you want to install the OS, and relevant network settings.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      25,
      24,
      29,
      28,
      26
    ],
    "source": "891437_c02"
  },
  {
    "id": 167,
    "question": "What tool is used in Windows Server 2012 R2 to create a baseline?",
    "choice_a": "Performance Monitor",
    "choice_b": "Action Center",
    "choice_c": "System Information",
    "choice_d": "Event Viewer",
    "correct_answer": "A",
    "explanation": "You can use third-party monitoring tools or you can rely on some that are built into the system, such as the Performance Monitor tool in Windows Server 2012 R2. This tool can be used to take snapshots over a period of time as well so that you get a feel for the rise and fall of the workload on the server.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      40,
      37,
      39,
      73,
      148
    ],
    "source": "891437_c02"
  },
  {
    "id": 168,
    "question": "What is another term for a swap file?",
    "choice_a": "vDisk",
    "choice_b": "Pagefile",
    "choice_c": "Transaction log",
    "choice_d": "Checkpoint file",
    "correct_answer": "B",
    "explanation": "The swap file is often called the pagefile.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      33,
      30,
      31,
      68,
      148
    ],
    "source": "891437_c02"
  },
  {
    "id": 169,
    "question": "How large should the pagefile be on a Windows server that is not a database server?",
    "choice_a": "Half the size of RAM",
    "choice_b": "Equal to the size of RAM",
    "choice_c": "1.5 times the size of RAM",
    "choice_d": "Twice the size of RAM",
    "correct_answer": "C",
    "explanation": "With Windows servers, set the pagefile to 1.5 times the RAM.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      34,
      35,
      27,
      28,
      25
    ],
    "source": "891437_c02"
  },
  {
    "id": 170,
    "question": "Which of the following installation types makes use of an answer file?",
    "choice_a": "Unattended",
    "choice_b": "Attended",
    "choice_c": "Image",
    "choice_d": "Bare-metal",
    "correct_answer": "A",
    "explanation": "In a Windows classic unattended installation, this file is called an answer file and the file provides the answers to the question posed during the installation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      25,
      29,
      27,
      26,
      24
    ],
    "source": "891437_c02"
  },
  {
    "id": 171,
    "question": "Which of the following is an industry standard client-server interface that allows networked computers that are not yet loaded with an operating system to be configured and booted remotely by an administrator?",
    "choice_a": "DNS",
    "choice_b": "PXE",
    "choice_c": "iDRAC",
    "choice_d": "NBP",
    "correct_answer": "B",
    "explanation": "The Preboot Execution Environment (PXE) is an industry-standard client-server interface that allows networked computers that are not yet loaded with an operating system to be configured and booted remotely by an administrator.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      29,
      25,
      28,
      24,
      141
    ],
    "source": "891437_c02"
  },
  {
    "id": 172,
    "question": "The CPU Processor\\% Processor Time value should never exceed which value?",
    "choice_a": "60%",
    "choice_b": "65%",
    "choice_c": "70%",
    "choice_d": "85%",
    "correct_answer": "D",
    "explanation": "Processor\\% Processor Time represents the percentage of time the CPU spends executing a non-idle thread. This should not be over 85 percent on a sustained basis.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      40,
      34,
      68,
      78,
      82
    ],
    "source": "891437_c02"
  },
  {
    "id": 173,
    "question": "Which of the following is an email protocol?",
    "choice_a": "TFTP",
    "choice_b": "IMAP4",
    "choice_c": "PXE",
    "choice_d": "VMM",
    "correct_answer": "B",
    "explanation": "Mail servers run email server software and use SMTP to send email on behalf of users who possess mailboxes on the server and to transfer emails between email servers. Those users will use a client email protocol to retrieve their email from the server. Two of the most common are POP3, which is a retrieve-only protocol, and IMAP4, which has more functionality and can be used to manage the email on the server.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      141,
      133,
      41,
      142,
      140
    ],
    "source": "891437_c02"
  },
  {
    "id": 174,
    "question": "What Microsoft technology allows you to connect to remote computers and run programs on them?",
    "choice_a": "iDRAC",
    "choice_b": "RDP",
    "choice_c": "iDRAC",
    "choice_d": "SSL",
    "correct_answer": "B",
    "explanation": "Developed by Microsoft, Remote Desktop Protocol (RDP) allows you to connect to remote computers and run programs on them. When you use RDP, you see the desktop of the computer you\u2019ve signed into on your screen.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      44,
      28,
      45,
      148,
      72
    ],
    "source": "891437_c02"
  },
  {
    "id": 175,
    "question": "Which protocol offers an encrypted command line?",
    "choice_a": "Telnet",
    "choice_b": "RDP",
    "choice_c": "SSH",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "If you don\u2019t need access to the graphical interface and you just want to connect to a server to operate at the command line, you have two options: Telnet and SSH. Telnet works just fine, but it transmits all of the data in cleartext, which obviously would be a security issue. Therefore, the connection tool of choice has become Secure Shell (SSH). It\u2019s not as easy to set up because it encrypts all of the transmissions and that\u2019s not possible without an encryption key.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      41,
      141,
      27,
      139,
      77
    ],
    "source": "891437_c02"
  },
  {
    "id": 176,
    "question": "Which of the following is a Linux filesystem?",
    "choice_a": "ext2",
    "choice_b": "NTFS",
    "choice_c": "RFS",
    "choice_d": "UFS",
    "correct_answer": "A",
    "explanation": "ext2, ext3, and ext4 are Linux filesystems. As you would expect, each version is more capable than the previous one.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      24,
      25,
      27,
      30
    ],
    "source": "891437_c02"
  },
  {
    "id": 177,
    "question": "Which remote management technology is <i>not</i> graphical in nature?",
    "choice_a": "VNC",
    "choice_b": "SSH",
    "choice_c": "RDP",
    "choice_d": "SSL",
    "correct_answer": "B",
    "explanation": "If you don\u2019t need access to the graphical interface and you just want to connect to a server to operate at the command line, you have two options: Telnet and SSH. While Telnet works just fine, it transmits all of the data in cleartext, which obviously would be a security issue. Therefore, the connection tool of choice has become Secure Shell (SSH).",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      27,
      41,
      144,
      148,
      25
    ],
    "source": "891437_c02"
  },
  {
    "id": 178,
    "question": "Which statement is true with respect to hypervisors?",
    "choice_a": "Type II is called native.",
    "choice_b": "Type II runs directly on the host\u2019s hardware.",
    "choice_c": "A Type II hypervisor runs within a conventional operating system environment.",
    "choice_d": "VMware Workstation and VirtualBox exemplify Type I hypervisors.",
    "correct_answer": "C",
    "explanation": "Type I hypervisor (or native, bare-metal) runs directly on the host\u2019s hardware. A Type II hypervisor runs within a conventional operating system. VMware Workstation and VirtualBox exemplify Type II hypervisors.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      44,
      43,
      45,
      28,
      24
    ],
    "source": "891437_c02"
  },
  {
    "id": 179,
    "question": "Where are VMs stored in a virtual environment?",
    "choice_a": "On a host",
    "choice_b": "On a guest",
    "choice_c": "In memory",
    "choice_d": "In the virtual box",
    "correct_answer": "A",
    "explanation": "The VMs reside on the host servers and the host servers are attached to the shared storage devices.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      44,
      46,
      38,
      45,
      34
    ],
    "source": "891437_c02"
  },
  {
    "id": 180,
    "question": "Which of the following refers to any method of managing the server that does not use the network?",
    "choice_a": "Out-of-band",
    "choice_b": "In-band",
    "choice_c": "Direct",
    "choice_d": "Terminal",
    "correct_answer": "A",
    "explanation": "Out-of-band management refers to any method of managing the server that does not use the network. This provides some advantages, among them:<br>It offers a solution when the network is down or the device is inaccessible.<ul><li>It manages devices with no power and remotely reboots devices that have been crashed, turned off, or hibernating, or that are in sleep mode.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      49,
      50,
      51,
      54,
      4
    ],
    "source": "891437_c03"
  },
  {
    "id": 181,
    "question": "Which of the following licenses is one that though purchased for an older version of software can be used to demonstrate license compliance for a newer version?",
    "choice_a": "Backward compatible",
    "choice_b": "Forward compatible",
    "choice_c": "Side-loaded",
    "choice_d": "Regressive",
    "correct_answer": "B",
    "explanation": "A forward-compatible license is one that, though purchased for an older version of software (for example, Windows Server 2012), can be used to demonstrate license compliance for a newer version (such as Windows Server 2012 R2).",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      59,
      55,
      58,
      60,
      57
    ],
    "source": "891437_c03"
  },
  {
    "id": 182,
    "question": "Which of the following is technology embedded into Hewlett-Packard (HP) servers that allows for out-of-band management of the server?",
    "choice_a": "iDRAC",
    "choice_b": "RDP",
    "choice_c": "iLO",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "Integrated lights-out (iLO) is technology embedded into HP servers that allows for out-of-band management of the server. Out-of-band management refers to any method of managing the server that does not use the network.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      49,
      50,
      54,
      51,
      21
    ],
    "source": "891437_c03"
  },
  {
    "id": 183,
    "question": "Which of the following is software consisting of multiple differently licensed parts?",
    "choice_a": "Rolling manifest",
    "choice_b": "Open source",
    "choice_c": "Backward compatible",
    "choice_d": "Combined work",
    "correct_answer": "D",
    "explanation": "Some software is what we call a <i>combined work</i>, meaning it consists of multiple differently licensed parts. This can present an issue when the various parts have very different and incompatible licensing terms. Sometimes projects wind up with incompatible licenses, and the only feasible way to solve it is the relicensing of the incompatible parts. Relicensing is achieved by contacting all involved developers and other parties and getting their agreement for the changed license.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      59,
      58,
      55,
      57,
      60
    ],
    "source": "891437_c03"
  },
  {
    "id": 184,
    "question": "What type of access does a Dell iDRAC card provide?",
    "choice_a": "Out-of-band",
    "choice_b": "In-band",
    "choice_c": "VPN",
    "choice_d": "SSL",
    "correct_answer": "A",
    "explanation": "A Dell Remote Access Controller (DRAC) card provides out-of-band management for Dell servers. The iDRAC refers to a version of these interface cards that is integrated on the motherboard of the server.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      49,
      50,
      54,
      51,
      2
    ],
    "source": "891437_c03"
  },
  {
    "id": 185,
    "question": "Which of the following describes the process of correcting software licensing noncompliance.?",
    "choice_a": "Level up",
    "choice_b": "True up",
    "choice_c": "Settle up",
    "choice_d": "Pay up",
    "correct_answer": "B",
    "explanation": "A true-up occurs when a company compares the number of actual software license users to the good-faith estimate of the initial contract and corrects any issues.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      57,
      55,
      60,
      59,
      56
    ],
    "source": "891437_c03"
  },
  {
    "id": 186,
    "question": "Which of the following allows a device to be started up from the network by sending a special packet to the NIC?",
    "choice_a": "IRL",
    "choice_b": "WOL",
    "choice_c": "iDRAC",
    "choice_d": "iLO",
    "correct_answer": "B",
    "explanation": "Some network cards offer a feature called Wake on LAN (WOL). This allows the device to be started up from the network by sending a special packet to the NIC (which is not ever actually off).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      50,
      20,
      54,
      51,
      14
    ],
    "source": "891437_c03"
  },
  {
    "id": 187,
    "question": "Which of the following licensing models use a single license key to demonstrate that you have paid for multiple installations?",
    "choice_a": "Per-user",
    "choice_b": "Open source",
    "choice_c": "Volume",
    "choice_d": "Subscription",
    "correct_answer": "C",
    "explanation": "Volume licensing is the process of purchasing a number of installation instances and then using a single volume license key to demonstrate that you have paid for the installations.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      55,
      57,
      59,
      60,
      58
    ],
    "source": "891437_c03"
  },
  {
    "id": 188,
    "question": "Which of the following is a mobile server room table equipped with a secured laptop that is used to provide a direct connection to malfunctioning servers and computers?",
    "choice_a": "iDRAC",
    "choice_b": "Response box",
    "choice_c": "Crash cart",
    "choice_d": "Emergency cart",
    "correct_answer": "C",
    "explanation": "A crash cart is a mobile server room cart equipped with a secured laptop that is used to provide a direct connection to malfunctioning servers and computers for restoration of crashes.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      49,
      50,
      3,
      53,
      54
    ],
    "source": "891437_c03"
  },
  {
    "id": 189,
    "question": "Which of the following specifies the type of support to be provided and the acceptable amount of time allowed to respond to support calls?",
    "choice_a": "Rules of engagement",
    "choice_b": "Support scope",
    "choice_c": "MDA",
    "choice_d": "SLA",
    "correct_answer": "D",
    "explanation": "Maintenance plans may include a service level agreement (SLA). These agreements specify the type of support to be provided and the acceptable amount of time allowed to respond to support calls. Typically, these time windows are different for different types of events.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      74,
      60,
      73,
      72,
      25
    ],
    "source": "891437_c03"
  },
  {
    "id": 190,
    "question": "What is a console cable sometimes called?",
    "choice_a": "Rollover cable",
    "choice_b": "Patch cable",
    "choice_c": "Straight-through",
    "choice_d": "Crossover cable",
    "correct_answer": "A",
    "explanation": "A server may offer the option to connect to it using a special cable called a console cable. These cables are used to connect to and manage routers and switches as well. The port looks like an RJ-45 port, and the cable looks like an Ethernet cable except that it\u2019s flat and wired differently. Sometimes these cables are called rollover cables.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      49,
      50,
      12,
      10,
      15
    ],
    "source": "891437_c03"
  },
  {
    "id": 191,
    "question": "Which of the following demonstrates that you have paid for the right to use the software?",
    "choice_a": "SLA",
    "choice_b": "Service plan",
    "choice_c": "Warranty",
    "choice_d": "License",
    "correct_answer": "D",
    "explanation": "The license demonstrates that you have paid for the right to use the software and does not imply either a warranty or a promise of help and support.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      60,
      55,
      56,
      57,
      59
    ],
    "source": "891437_c03"
  },
  {
    "id": 192,
    "question": "Where is WOL support enabled?",
    "choice_a": "BIOS",
    "choice_b": "IOPS",
    "choice_c": "IOS",
    "choice_d": "TIOS",
    "correct_answer": "A",
    "explanation": "This is a configuration that can be done in the BIOS settings in a fashion similar to the way you disable the USB ports.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      54,
      50,
      51,
      49,
      15
    ],
    "source": "891437_c03"
  },
  {
    "id": 193,
    "question": "In which licensing model do you pay by the month for as long as you want access?",
    "choice_a": "Site-based",
    "choice_b": "Subscription",
    "choice_c": "Per-user",
    "choice_d": "Volume",
    "correct_answer": "B",
    "explanation": "This model evolved from the SaaS cloud model where the software is not installed but instead is run from the cloud.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      58,
      55,
      60,
      59,
      76
    ],
    "source": "891437_c03"
  },
  {
    "id": 194,
    "question": "Which of the following includes any type of instruction for the server that is stored in nonvolatile memory devices such as ROM, EPROM, or flash memory?",
    "choice_a": "Hardware",
    "choice_b": "Software",
    "choice_c": "Firmware",
    "choice_d": "Shareware",
    "correct_answer": "C",
    "explanation": "Firmware includes any type of instruction for the server that is stored in nonvolatile memory devices such as ROM, EPROM, or flash memory. BIOS and UEFI code is the most common example for firmware.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      51,
      54,
      49,
      50,
      52
    ],
    "source": "891437_c03"
  },
  {
    "id": 195,
    "question": "Which of the following is the process of updating the firmware?",
    "choice_a": "Burning",
    "choice_b": "Rewriting",
    "choice_c": "Clustering",
    "choice_d": "Flashing",
    "correct_answer": "D",
    "explanation": "Regardless of the exact procedure, the process is referred to as flashing the BIOS. It means the old instructions are erased from the EEPROM chip and the new instructions are written to the chip.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      51,
      54,
      52,
      21,
      49
    ],
    "source": "891437_c03"
  },
  {
    "id": 196,
    "question": "Which of the following is a licensing method for making a software program free, while requiring that all modified and extended versions of the program also be free and released under the same terms and conditions?",
    "choice_a": "Copyleft",
    "choice_b": "Permissive",
    "choice_c": "Open source",
    "choice_d": "Node locked",
    "correct_answer": "A",
    "explanation": "There are two main types of open source licenses, copyleft and permissive. Copyleft is a method for making a software program free while requiring that all modified and extended versions of the program also be free and released under the same terms and conditions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      58,
      59,
      60,
      57,
      55
    ],
    "source": "891437_c03"
  },
  {
    "id": 197,
    "question": "What must be maintained during the firmware flashing process?",
    "choice_a": "Network connectivity",
    "choice_b": "Power",
    "choice_c": "Data integrity",
    "choice_d": "Positive magnetic pole",
    "correct_answer": "B",
    "explanation": "While the update is completing, ensure that you maintain power to the device.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      51,
      8,
      49,
      7,
      4
    ],
    "source": "891437_c03"
  },
  {
    "id": 198,
    "question": "To provide encryption, the data is encrypted with the receiver\u2019s ________ key, which results in ciphertext that only the receiver\u2019s ________ key can decrypt.",
    "choice_a": "Private, private",
    "choice_b": "Public, public",
    "choice_c": "Public, private",
    "choice_d": "Private, public",
    "correct_answer": "C",
    "explanation": "These keys work together to perform both encryption and digital signatures. To provide encryption, the data is encrypted with the receiver\u2019s public key, which results in ciphertext that only the receiver\u2019s private key can decrypt.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      56,
      77,
      42,
      60,
      70
    ],
    "source": "891437_c03"
  },
  {
    "id": 199,
    "question": "Which of the following is a false statement about hard drives?",
    "choice_a": "The rotational speed of the disk or platter has no influence on how quickly the drive can locate any specific disk sector on the drive.",
    "choice_b": "The faster the rotation, the smaller the delay will be.",
    "choice_c": "The data rate will be higher for data on the outer tracks and lower toward the inner tracks.",
    "choice_d": "A locational delay is called latency.",
    "correct_answer": "A",
    "explanation": "The rotational speed of the disk or platter has a direct influence on how quickly the drive can locate any specific disk sector on the drive. This locational delay is called latency and is measured in milliseconds (ms). The faster the rotation, the smaller the delay will be.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      52,
      64,
      65,
      66,
      62
    ],
    "source": "891437_c03"
  },
  {
    "id": 200,
    "question": "Which RAID type provides no fault tolerance?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "A",
    "explanation": "RAID 0 is also known as disk striping. This is RAID that doesn\u2019t provide fault tolerance. Data is written across multiple drives, so one drive can be reading or writing while the next drive\u2019s read/write head is moving. This makes for faster data access. However, if any one of the drives fails, all content is lost.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      62,
      21,
      53,
      63
    ],
    "source": "891437_c04"
  },
  {
    "id": 201,
    "question": "Which RAID type is also called mirroring?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "B",
    "explanation": "RAID 1 is also known as disk mirroring. This is a method of producing fault tolerance by writing all data simultaneously to two separate drives.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      61,
      62,
      21,
      53,
      64
    ],
    "source": "891437_c04"
  },
  {
    "id": 202,
    "question": "If a hard drive has 120 GB as calculated using the Base 10 number system, what will be the capacity reported by Windows?",
    "choice_a": "120 GB",
    "choice_b": "110 GB",
    "choice_c": "111.8 GB",
    "choice_d": "122.5 GB",
    "correct_answer": "C",
    "explanation": "When the hard disk manufacturer advertises a 120 GB hard drive, they are selling you 120,000,000,000 bytes. Windows divides this number by what it considers a GB (1073741824) and reports the hard disk size as:<br><code>120000000000 (bytes) / 1073741824 (bytes per GB) = 111.8 GB.</code>",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      64,
      52,
      65,
      66,
      67
    ],
    "source": "891437_c04"
  },
  {
    "id": 203,
    "question": "Which of the following folders is the Windows component store directory?",
    "choice_a": "<code>C:\\windows</code>",
    "choice_b": "<code>C:\\windows/winsxs</code>",
    "choice_c": "<code>C:\\winsxs</code>",
    "choice_d": "<code>C:\\winnt/winsxs</code>",
    "correct_answer": "B",
    "explanation": "One of the things that you can do in Windows to mitigate the amount of space used by constant updates is to manage a folder called the component store. This folder, called <code>windows\\winsxs</code>, contains all the files that are required for a Windows installation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      27,
      24,
      29,
      68,
      73
    ],
    "source": "891437_c04"
  },
  {
    "id": 204,
    "question": "Which of the following actions can empty temporary directories?",
    "choice_a": "Running wevutil",
    "choice_b": "Running Disk Cleanup",
    "choice_c": "Running defrag",
    "choice_d": "Running Disk Check",
    "correct_answer": "B",
    "explanation": "Manually performing a disk cleanup will allow you to get rid of these files (and many other useless files as well), but if you would like to create a batch file, you can automate the process.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      148,
      144,
      145,
      147,
      29
    ],
    "source": "891437_c04"
  },
  {
    "id": 205,
    "question": "If three 250 MB disks are present in a RAID 5 array, how much space is actually usable for data?",
    "choice_a": "125 MB",
    "choice_b": "200 MB",
    "choice_c": "250 MB",
    "choice_d": "500 MB",
    "correct_answer": "D",
    "explanation": "A minimum of three drives is required. RAID 5 uses 1/<i>n</i> (<i>n</i> = the number of drives in the array) for parity information (for example, one third of the space in a three-drive array), and only 1 \u2013 (1/<i>n</i>) is available for data. So if three 250 GB drives are used in the array (for a total of 750 GB), 500 GB will be the available drive space.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      61,
      62,
      21,
      52,
      66
    ],
    "source": "891437_c04"
  },
  {
    "id": 206,
    "question": "What is the minimum number of disks required for RAID 5?",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "4",
    "choice_d": "5",
    "correct_answer": "B",
    "explanation": "A minimum of three drives is required.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      21,
      52,
      53
    ],
    "source": "891437_c04"
  },
  {
    "id": 207,
    "question": "RAID 6 writes parity information across the drives as is done in RAID 5, but it writes two stripes. What is the effect of writing two stripes?",
    "choice_a": "Speeds performance",
    "choice_b": "Allows the cable to be longer",
    "choice_c": "Hurts performance",
    "choice_d": "Allows you to use only two drives",
    "correct_answer": "C",
    "explanation": "One disadvantage in using RAID 6 is that each set of parities must be calculated separately, which slows write performance.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      65,
      64,
      21
    ],
    "source": "891437_c04"
  },
  {
    "id": 208,
    "question": "Which of the following is an advantage of software RAID over hardware RAID?",
    "choice_a": "Better performance",
    "choice_b": "Lower cost",
    "choice_c": "Better security",
    "choice_d": "Faster recovery",
    "correct_answer": "D",
    "explanation": "The advantages of using software RAID are lower cost and the ability to implement disk duplexing.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      62,
      21,
      61,
      52,
      64
    ],
    "source": "891437_c04"
  },
  {
    "id": 209,
    "question": "Which of the following is not an advantage of hardware RAID over software RAID?",
    "choice_a": "Decreased processor load",
    "choice_b": "Ability to do disk duplexing",
    "choice_c": "Support for online spares",
    "choice_d": "Faster performance",
    "correct_answer": "B",
    "explanation": "The ability to implement disk duplexing is an advantage of software RAID, not hardware RAID.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      62,
      61,
      21,
      53,
      63
    ],
    "source": "891437_c04"
  },
  {
    "id": 210,
    "question": "You have four 500 GB disks in a RAID 10 array. How much space is available for data?",
    "choice_a": "500 GB",
    "choice_b": "750 GB",
    "choice_c": "1000 GB",
    "choice_d": "2500 GB",
    "correct_answer": "C",
    "explanation": "Since this is effectively a mirrored stripe set and a stripe set gets 100 percent use of the drive without mirroring, this array will provide half of the total drive space in the array as available drive space.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      21,
      53,
      66
    ],
    "source": "891437_c04"
  },
  {
    "id": 211,
    "question": "When separate controller cards are used for each disk, what is it called?",
    "choice_a": "Disk jukebox",
    "choice_b": "JBOD",
    "choice_c": "Disk duplexing",
    "choice_d": "Disk triplexing",
    "correct_answer": "C",
    "explanation": "Disk duplexing is the use of separate controller cards for each disk when implementing disk mirroring (RAID 1), thus providing fault tolerance at both the disk level and the disk controller level, protecting against both a single disk failure and a single controller card failure.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      61,
      62,
      21,
      53,
      52
    ],
    "source": "891437_c04"
  },
  {
    "id": 212,
    "question": "Which of the following allows a cable to be a maximum of 1 meter in length?",
    "choice_a": "SATA",
    "choice_b": "SCSI",
    "choice_c": "Fibre Channel",
    "choice_d": "iSCSI",
    "correct_answer": "A",
    "explanation": "SATA is the slowest and least expensive of the options, with a maximum cable length of 1 meter (3 feet).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      64,
      65,
      62
    ],
    "source": "891437_c04"
  },
  {
    "id": 213,
    "question": "Which of the following is the costliest to implement?",
    "choice_a": "SATA",
    "choice_b": "SCSI",
    "choice_c": "Fibre Channel",
    "choice_d": "iSCSI",
    "correct_answer": "C",
    "explanation": "While Fibre Channel is the fastest and provides the longest allowable cable length, it is the costliest.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      67,
      13,
      14,
      66,
      20
    ],
    "source": "891437_c04"
  },
  {
    "id": 214,
    "question": "Which of the following RPMs will provide the fastest access speed when discussing hard disk drives?",
    "choice_a": "4800",
    "choice_b": "5400",
    "choice_c": "7200",
    "choice_d": "10000",
    "correct_answer": "D",
    "explanation": "The faster the RPM, the faster the disk access will be.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      64,
      52,
      65,
      66,
      61
    ],
    "source": "891437_c04"
  },
  {
    "id": 215,
    "question": "You have three drives that have capacities of 500 MB, 750 MB, and 1000 MB. Setting the cost of parity information aside, what is the total capacity of the array?",
    "choice_a": "1500 MB",
    "choice_b": "2250 MB",
    "choice_c": "3000 MB",
    "choice_d": "3500 MB",
    "correct_answer": "A",
    "explanation": "Mixing any of the following drive specifications in the same array will result in the entire array using the least capable specification (also called \u201cdumbing down\u201d the array):<ul><li>Slowest speed (performance)</li><li>Smallest size</li><li>Smallest buffer.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      62,
      64,
      52,
      21
    ],
    "source": "891437_c04"
  },
  {
    "id": 216,
    "question": "Which of the following technologies supports hot swapping inherently?",
    "choice_a": "SAS",
    "choice_b": "SATA",
    "choice_c": "SCSI",
    "choice_d": "Fibre Channel",
    "correct_answer": "B",
    "explanation": "If you are using SATA disks, hot swapping is inherently supported due to the pin layout.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      66,
      53,
      64,
      65,
      62
    ],
    "source": "891437_c04"
  },
  {
    "id": 217,
    "question": "Which of the following is attached to the system but cannot replace a bad disk without manual intervention?",
    "choice_a": "Hot swap",
    "choice_b": "Hot spare",
    "choice_c": "Cold spare",
    "choice_d": "Standby",
    "correct_answer": "C",
    "explanation": "A cold spare is one that is attached to the system and available but cannot replace the bad disk without administrator intervention and in some cases a reboot.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      62,
      61,
      53,
      66,
      64
    ],
    "source": "891437_c04"
  },
  {
    "id": 218,
    "question": "Which of the following describes the average length of time it takes a vendor to repair a device or component?",
    "choice_a": "MTBF",
    "choice_b": "MMTR",
    "choice_c": "MTTR",
    "choice_d": "MTR",
    "correct_answer": "C",
    "explanation": "One of the metrics that is used in planning both SLAs and IT operations in general is mean time to repair (MTTR). This value describes the average length of time it takes a vendor to repair a device or component.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      75,
      74,
      60,
      70,
      38
    ],
    "source": "891437_c04"
  },
  {
    "id": 219,
    "question": "Which type of fault tolerance is recommended for servers running applications that do not have long-running in-memory state or frequently updated data?",
    "choice_a": "Load balancing",
    "choice_b": "Hot site",
    "choice_c": "Clustering",
    "choice_d": "Cold site",
    "correct_answer": "A",
    "explanation": "In load balancing, a frontend device or service receives work requests and allocates the requests to a number of backend servers. This type of fault tolerance is recommended for applications that do not have a long-running in-memory state or frequently updated data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      81,
      80,
      78,
      79,
      46
    ],
    "source": "891437_c05"
  },
  {
    "id": 220,
    "question": "Which of the following is a standard method of implementing NIC teaming?",
    "choice_a": "802.1ax-2008",
    "choice_b": "802.3",
    "choice_c": "802.1x",
    "choice_d": "802.3g",
    "correct_answer": "A",
    "explanation": "Combining physical links can be done using proprietary methods, and there is also an IEEE standard for the process called 802.3ad, later replaced by 802.1ax-2008.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      84,
      82,
      83,
      81,
      78
    ],
    "source": "891437_c05"
  },
  {
    "id": 221,
    "question": "What file do you edit in Linux to configure the Ethernet 5 interface to be used in a NIC team?",
    "choice_a": "<code>ifcfg-eth1</code>",
    "choice_b": "<code>ifcfg-bond0</code>",
    "choice_c": "<code>ifcfg-eth5</code>",
    "choice_d": "<code>ifcfg-bond5</code>",
    "correct_answer": "C",
    "explanation": "To configure Ethernet 6 to be used as a slave by a NIC team, open the <code>ifcfg-eth5</code> file and edit it as follows. In this case, the NIC team will be created and identified as bond0.<br><code># vi /etc/sysconfig/network-scripts/</code>ifcfg-eth5 <br><code>DEVICE=\"eth1\"</code><br><code>ONBOOT=\"yes\"</code><br><code>BOOTPROTO=\"none\"</code><br><code>USERCTL=no</code><br><code>MASTER=bond0</code><br><code>SLAVE=yes</code>.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      83,
      84,
      39,
      135,
      31
    ],
    "source": "891437_c05"
  },
  {
    "id": 222,
    "question": "___________is when a failed components workload is switched over to a backup component.",
    "choice_a": "Failback",
    "choice_b": "Failover",
    "choice_c": "Crossover",
    "choice_d": "Recall",
    "correct_answer": "B",
    "explanation": "Failover is when a failed components workload is switched over to a backup component. In the case of a NIC team used for fault tolerance, this means that the backup NIC takes over for the failing NIC.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      78,
      80,
      82,
      84,
      79
    ],
    "source": "891437_c05"
  },
  {
    "id": 223,
    "question": "Which of the following is a connection between servers in a load balancing scenario across which the servers send a signal used to determine when the other server is down?",
    "choice_a": "Heartbeat",
    "choice_b": "Cluster ID",
    "choice_c": "Magic packet",
    "choice_d": "WOL",
    "correct_answer": "A",
    "explanation": "A heartbeat connection is a connection between servers in a load balancing scenario across which the servers send a signal (called a heartbeat) used to determine when the other server is down. If one server goes down, the other will service the entire workload.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      79,
      78,
      81,
      80,
      46
    ],
    "source": "891437_c05"
  },
  {
    "id": 224,
    "question": "Which of the following controls the establishment of the aggregated link based on the proper combination of settings of the ends of the multiple links and on the agreement of certain settings on all physical links in the \u201cbundle\u201d?",
    "choice_a": "STP",
    "choice_b": "SSL",
    "choice_c": "LACP",
    "choice_d": "PGP",
    "correct_answer": "C",
    "explanation": "An IEEE standard for the process called 802.3ad, later replaced by 802.1ax-2008, uses a protocol called Link Aggregation Control Protocol (LACP) to control the establishment of the aggregated link based on the proper combination of settings of the ends of the multiple links and on the agreement of certain settings on all physical links in the \u201cbundle\u201d (speed and duplex among them).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      84,
      82,
      83,
      141,
      78
    ],
    "source": "891437_c05"
  },
  {
    "id": 225,
    "question": "Which of the following is a switching loop prevention protocol?",
    "choice_a": "SSL",
    "choice_b": "STP",
    "choice_c": "SSH",
    "choice_d": "SAG",
    "correct_answer": "B",
    "explanation": "For links that run between switches, using an aggregated link is better than using two links that are not aggregated, because in switch networks that include redundant links (which they should, according to best practices) a switching loop prevention protocol called Spanning Tree Protocol (STP) will disable one of the links. When the links are aggregated, STP considers them to be a single link and does not shut any of the ports in the aggregation.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      84,
      82,
      78,
      131,
      79
    ],
    "source": "891437_c05"
  },
  {
    "id": 226,
    "question": "In which clustering deployment are both or all servers actively servicing the workload?",
    "choice_a": "Passive\u2013passive",
    "choice_b": "Active\u2013passive",
    "choice_c": "Active\u2013active",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "In an active\u2013active cluster, both or all servers are actively servicing the workload.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      78,
      81,
      84,
      79,
      46
    ],
    "source": "891437_c05"
  },
  {
    "id": 227,
    "question": "Which method of allocating work in a load balancing scenario attempts to send clients into running servers, preferably the most recently used server, before starting new servers?",
    "choice_a": "MRU",
    "choice_b": "FIFO",
    "choice_c": "Hybrid",
    "choice_d": "LIFO",
    "correct_answer": "A",
    "explanation": "The Most Recently Used (MRU) algorithm attempts to send clients into running servers, preferably the most recently used server, before starting new servers. The goal of this algorithm is to reduce the overhead of starting new servers by using servers that are already running.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      81,
      80,
      78,
      46,
      79
    ],
    "source": "891437_c05"
  },
  {
    "id": 228,
    "question": "Which of the following is the process of combining multiple physical network connections into a single logical interface?",
    "choice_a": "Link bonding",
    "choice_b": "NIC teaming",
    "choice_c": "NIC aggregation",
    "choice_d": "MRU",
    "correct_answer": "B",
    "explanation": "Redundancy can be provided at the network interface level. NIC teaming is the process of combining multiple physical network connections into a single logical interface.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      84,
      82,
      83,
      80,
      81
    ],
    "source": "891437_c05"
  },
  {
    "id": 229,
    "question": "Which of the following is generally recommended for servers running applications that have long-running in-memory state or frequently updated data?",
    "choice_a": "Load balancing",
    "choice_b": "Clustering",
    "choice_c": "RAID",
    "choice_d": "NIC teaming",
    "correct_answer": "B",
    "explanation": "A server cluster is generally recommended for servers running applications that have long-running in-memory state or frequently updated data. Typical uses for server clusters include file servers, print servers, database servers, and messaging servers.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      78,
      79,
      80,
      34,
      35
    ],
    "source": "891437_c05"
  },
  {
    "id": 230,
    "question": "In which load balancing allocation system does the load balancer allocate work requests to each server sequentially, resulting in each getting an equal number of requests?",
    "choice_a": "MRU",
    "choice_b": "Active\u2013active",
    "choice_c": "Round robin",
    "choice_d": "Active\u2013passive",
    "correct_answer": "C",
    "explanation": "In a round robin allocation system, the load balancer allocates work requests to each server sequentially, resulting in each getting an equal number of requests.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      81,
      80,
      78,
      83,
      84
    ],
    "source": "891437_c05"
  },
  {
    "id": 231,
    "question": "Which of the following is the process of combining multiple physical or virtual servers together in an arrangement in which the servers work together to service the same workload or application?",
    "choice_a": "JBOD",
    "choice_b": "Clustering",
    "choice_c": "Duplexing",
    "choice_d": "NIC team",
    "correct_answer": "B",
    "explanation": "Clustering is the process of combining multiple physical or virtual servers together in an arrangement called a cluster, in which the servers work together to service the same workload or application.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      78,
      79,
      81,
      46,
      84
    ],
    "source": "891437_c05"
  },
  {
    "id": 232,
    "question": "Which of the following types of fault tolerance is recommended for applications that do not have long-running in-memory state or frequently updated data?",
    "choice_a": "Clustering",
    "choice_b": "Load balancing",
    "choice_c": "RAID",
    "choice_d": "NIC teaming",
    "correct_answer": "B",
    "explanation": "A form of fault tolerance that focuses more on providing high availability of a resource is load balancing. In load balancing a frontend device or service receives work requests and allocates the requests to a number of backend servers. This type of fault tolerance is recommended for applications that do not have long-running in-memory state or frequently updated data.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      81,
      80,
      78,
      46,
      79
    ],
    "source": "891437_c05"
  },
  {
    "id": 233,
    "question": "Which of the following is a term that describes when the original system goes back online and the workload is moved back to the original system?",
    "choice_a": "Failover",
    "choice_b": "Failback",
    "choice_c": "Heartbeat",
    "choice_d": "Resumption",
    "correct_answer": "B",
    "explanation": "Failback is a term that describes when the original system goes back online and the workload is moved back to the original system.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      78,
      148,
      146,
      72,
      73
    ],
    "source": "891437_c05"
  },
  {
    "id": 234,
    "question": "Which of the following can be done with either software or hardware?",
    "choice_a": "Load balancing",
    "choice_b": "Clustering",
    "choice_c": "Heartbeat",
    "choice_d": "Failover",
    "correct_answer": "A",
    "explanation": "Load balancing can be done using load balancing software or it can be done with a physical appliance called a load balancer.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      81,
      80,
      78,
      79,
      46
    ],
    "source": "891437_c05"
  },
  {
    "id": 235,
    "question": "What is another name for NIC teaming?",
    "choice_a": "Link aggregation",
    "choice_b": "NIC tunneling",
    "choice_c": "NRP",
    "choice_d": "STP",
    "correct_answer": "A",
    "explanation": "NIC teaming is the process of combining multiple physical network connections into a single logical interface. This process goes by other names as well, including link aggregation and link bonding.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      84,
      82,
      83,
      81,
      133
    ],
    "source": "891437_c05"
  },
  {
    "id": 236,
    "question": "Which of the following is also an IEEE standard later replaced by 802.1ax-2008?",
    "choice_a": "802.11a",
    "choice_b": "802.1ad",
    "choice_c": "802.15",
    "choice_d": "802.3ad",
    "correct_answer": "D",
    "explanation": "Combining physical links can be done using proprietary methods, and there is also an IEEE standard for the process called 802.3ad, later replaced by 802.1ax-2008.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      84,
      81,
      78,
      79,
      39
    ],
    "source": "891437_c05"
  },
  {
    "id": 237,
    "question": "In which of the following load balancing algorithms could a user make two requests that actually go to two different servers?",
    "choice_a": "MRU",
    "choice_b": "Active\u2013active",
    "choice_c": "Round robin",
    "choice_d": "Active\u2013passive",
    "correct_answer": "C",
    "explanation": "In a round robin allocation system, the load balancer allocates work requests to each server sequentially, resulting in each getting an equal number of requests. This could mean that a user may make two requests that actually go to two different servers.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      81,
      80,
      83,
      84,
      46
    ],
    "source": "891437_c05"
  },
  {
    "id": 238,
    "question": "Which of the following devices will stand between the work requests and the work servers and will allocate work between the systems?",
    "choice_a": "Load balancer",
    "choice_b": "Fiber switch",
    "choice_c": "NIC team",
    "choice_d": "Jump server",
    "correct_answer": "A",
    "explanation": "Load balancing can be done using load balancing software or it can be done with a physical appliance called a load balancer.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      81,
      80,
      78,
      46,
      79
    ],
    "source": "891437_c05"
  },
  {
    "id": 239,
    "question": "Which authentication mechanism is an example of something you have?",
    "choice_a": "Password",
    "choice_b": "Username",
    "choice_c": "Smart card",
    "choice_d": "Retina scan",
    "correct_answer": "C",
    "explanation": "While passwords and usernames are examples of something you know and a retina scan is an example of something you are, possessing a smart card is an example of something you have.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      122,
      86,
      119,
      111,
      117
    ],
    "source": "891437_c06"
  },
  {
    "id": 240,
    "question": "Which of the following is a series of two doors with a small room between them?",
    "choice_a": "Mantrap",
    "choice_b": "Bigate",
    "choice_c": "Holding cell",
    "choice_d": "Visual check door",
    "correct_answer": "A",
    "explanation": "A mantrap is a series of two doors with a small room between them. The user is authenticated at the first door and then allowed into the room. At that point additional verification will occur (such as a guard visually identifying the person) and then the user is allowed through the second door.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      87,
      98,
      100,
      121,
      117
    ],
    "source": "891437_c06"
  },
  {
    "id": 241,
    "question": "Which of the following is not a drawback of using active RFID chips?",
    "choice_a": "The tag signal can be read by any reader in range.",
    "choice_b": "The tag signal can only go a few feet.",
    "choice_c": "Multiple readers in an area can interfere with one another.",
    "choice_d": "Multiple devices can interfere with one another when responding.",
    "correct_answer": "B",
    "explanation": "The drawbacks of this technology are that the tag signal can be read by any reader in range, multiple readers in an area can interfere with one another, and multiple devices can interfere with one another when responding. Active tags are more expensive but can transmit up to a hundred meters.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      86,
      92,
      97,
      98,
      99
    ],
    "source": "891437_c06"
  },
  {
    "id": 242,
    "question": "Which of the following authentication methods is not an example of biometrics?",
    "choice_a": "Password",
    "choice_b": "Hand scanners",
    "choice_c": "Fingerprint scan",
    "choice_d": "Retina scan",
    "correct_answer": "A",
    "explanation": "Biometric devices use physical characteristics to identify the user. Such devices are becoming more common in the business environment. Biometric systems include hand scanners, retinal scanners, and soon, possibly, DNA scanners.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      86,
      122,
      119,
      87,
      90
    ],
    "source": "891437_c06"
  },
  {
    "id": 243,
    "question": "Which of the following offers the most flexibility in reacting to security events?",
    "choice_a": "Cameras",
    "choice_b": "Security guards",
    "choice_c": "Motion sensors",
    "choice_d": "Intrusion prevention systems",
    "correct_answer": "B",
    "explanation": "Security guards offer the most flexibility in reacting to whatever occurs. Guards can use discriminating judgment based on the situation, which automated systems cannot do. This makes guards an excellent addition to the layers of security you should be trying to create.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      87,
      90,
      85,
      98,
      96
    ],
    "source": "891437_c06"
  },
  {
    "id": 244,
    "question": "Which of the following statements is false with respect to safes?",
    "choice_a": "All safes are fireproof.",
    "choice_b": "United Laboratories (UL) assigns ratings to safes that you can use to assess the suitability of the safe.",
    "choice_c": "Those that are fire-resistant might protect a document from being destroyed.",
    "choice_d": "When considering a safe, you should focus on two items: the ease with which the safe can be compromised and the ability of the safe to withstand a fire.",
    "correct_answer": "A",
    "explanation": "With respect to fire, first understand that no safe is fireproof. Many are fire-resistant and will protect a document from being destroyed, which occurs at a much higher temperature than many of the other items (such as backup tapes and CDs) can tolerate without damage. For these reasons, items such as backup tapes should be stored off-site.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      91,
      152,
      150,
      157,
      155
    ],
    "source": "891437_c06"
  },
  {
    "id": 245,
    "question": "Which of the following is a physical hardening technique?",
    "choice_a": "Stopping unneeded services",
    "choice_b": "Closing unneeded ports",
    "choice_c": "Installing only required software",
    "choice_d": "Assigning a BIOS password",
    "correct_answer": "D",
    "explanation": "Assigning a BIOS password is considered a physical hardening technique.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      109,
      105,
      87,
      86,
      91
    ],
    "source": "891437_c06"
  },
  {
    "id": 246,
    "question": "When discussing security, which of the following is defined as any point of entry into the network?",
    "choice_a": "Access point",
    "choice_b": "Endpoint",
    "choice_c": "Drop point",
    "choice_d": "Access link",
    "correct_answer": "B",
    "explanation": "When discussing network security, an endpoint or host is any point of entry into the network. A typical example of an endpoint is a laptop connected to the network with a remote access connection. Therefore, the process of providing endpoint security is the process of ensuring that every endpoint (including servers) has been secured in the same way in which you would secure the network gateway.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      108,
      106,
      117,
      120,
      86
    ],
    "source": "891437_c06"
  },
  {
    "id": 247,
    "question": "Which of the following is not true of an HIDS?",
    "choice_a": "A high number of false positives can cause a lax attitude on the part of the security team.",
    "choice_b": "An HIDS cannot address authentication issues.",
    "choice_c": "Encrypted packets cannot be analyzed.",
    "choice_d": "An HIDS monitors all traffic that goes through it looking for signs of attack on any machine in the network.",
    "correct_answer": "D",
    "explanation": "A host-based system is installed on the device (for purposes of our discussion, a server) and the system focuses solely on identifying attacks on that device only. This is in contrast to a network-based system, which monitors all traffic that goes through it looking for signs of attack on any machine in the network.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      99,
      121,
      106,
      110,
      105
    ],
    "source": "891437_c06"
  },
  {
    "id": 248,
    "question": "Which CIA goal is supported by using environmental controls?",
    "choice_a": "Availability",
    "choice_b": "Accountability",
    "choice_c": "Integrity",
    "choice_d": "Confidentiality",
    "correct_answer": "A",
    "explanation": "You might think it a bit off topic to discuss environmental controls in a security chapter. However, it makes perfect sense to do so if you consider what the A in the security triad CIA stands for. CIA is an acronym for the three goals of security: to provide confidentiality (data can be read only by those for which it is intended), integrity (the data has not been altered in any way), and availability (the data is available to those who need it when they need it).",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      89,
      100,
      116,
      99,
      97
    ],
    "source": "891437_c06"
  },
  {
    "id": 249,
    "question": "Which of the following is <i>not</i> an example of physical hardening of the server?",
    "choice_a": "Disabling USB ports",
    "choice_b": "Implementing strong authentication to log into the server",
    "choice_c": "Installing locks on server racks",
    "choice_d": "Installing locks on the server room door",
    "correct_answer": "B",
    "explanation": "While important, implementing strong authentication is a form of digital security.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      109,
      122,
      86,
      87,
      88
    ],
    "source": "891437_c06"
  },
  {
    "id": 250,
    "question": "Which of the following utilities receive information from log files of critical systems and centralize the collection and analysis of this data?",
    "choice_a": "RAID",
    "choice_b": "SIEM",
    "choice_c": "JBOD",
    "choice_d": "LANwake",
    "correct_answer": "B",
    "explanation": "Security information and event management (SIEM) utilities receive information from log files of critical systems and centralize the collection and analysis of this data. SIEM technology is an intersection of two closely related technologies: security information management (SIM) and security event management (SEM).",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      99,
      96,
      97,
      121,
      108
    ],
    "source": "891437_c06"
  },
  {
    "id": 251,
    "question": "Which of the following malware recognition processes analyzes traffic and compares patterns to those that reside within the IDS database?",
    "choice_a": "Anomaly-based",
    "choice_b": "Heuristics",
    "choice_c": "Signature-based",
    "choice_d": "Event-based",
    "correct_answer": "C",
    "explanation": "Signature-based recognition analyzes traffic and compares patterns, called signatures, that reside within the IDS database. This means it requires constant updating of the signature database.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      94,
      108,
      102,
      103,
      104
    ],
    "source": "891437_c06"
  },
  {
    "id": 252,
    "question": "Which fire suppression system is not recommended for rooms where equipment will be damaged by water?",
    "choice_a": "Dry pipe",
    "choice_b": "Preaction",
    "choice_c": "Hybrid",
    "choice_d": "Wet pipe",
    "correct_answer": "D",
    "explanation": "Wet pipe systems use water contained in pipes to extinguish the fire. In some areas, the water may freeze and burst the pipes, causing damage. These systems are not recommended for rooms where equipment will be damaged by the water.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      88,
      89,
      91,
      90,
      85
    ],
    "source": "891437_c06"
  },
  {
    "id": 253,
    "question": "Which of the following social engineering attacks can be mitigated by document shredding?",
    "choice_a": "Dumpster diving",
    "choice_b": "Piggybacking",
    "choice_c": "Shoulder surfing",
    "choice_d": "Tailgating",
    "correct_answer": "A",
    "explanation": "Dumpster diving is a common physical access method. Companies normally generate a huge amount of paper, most of which eventually winds up in dumpsters or recycle bins. Dumpsters may contain information that is highly sensitive in nature (such as passwords after a change and before the user has the new one memorized). In high-security and government environments, sensitive papers should be either shredded or burned.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      98,
      127,
      96,
      86,
      87
    ],
    "source": "891437_c06"
  },
  {
    "id": 254,
    "question": "Which of the following is <i>not</i> a physical hardening process?",
    "choice_a": "BIOS password",
    "choice_b": "Open case alarm",
    "choice_c": "Closing unneeded ports",
    "choice_d": "Laptop locks",
    "correct_answer": "C",
    "explanation": "Closing unneeded ports is a logical hardening method.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      109,
      105,
      85,
      87,
      86
    ],
    "source": "891437_c06"
  },
  {
    "id": 255,
    "question": "Which of the following are short vertical posts placed at the building\u2019s entranceway and lining sidewalks that help to provide protection from vehicles that might either intentionally or unintentionally crash into or enter the building or injure pedestrians?",
    "choice_a": "Mantrap",
    "choice_b": "Bollards",
    "choice_c": "PDU",
    "choice_d": "Barriers",
    "correct_answer": "B",
    "explanation": "Barriers called bollards have become quite common around the perimeter of new office and government buildings. These are short vertical posts placed at the building\u2019s entranceway and lining sidewalks that help to provide protection from vehicles that might either intentionally or unintentionally crash into or enter the building or injure pedestrians.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      85,
      87,
      90,
      88,
      91
    ],
    "source": "891437_c06"
  },
  {
    "id": 256,
    "question": "Which of the following refers to designing the facility from the ground up to support security?",
    "choice_a": "SIEM",
    "choice_b": "OSSINT",
    "choice_c": "CPTED",
    "choice_d": "WOL",
    "correct_answer": "C",
    "explanation": "Crime Prevention Through Environmental Design (CPTED) refers to designing the facility from the ground up to support security. It is actually a broad concept that can be applied to any project (housing developments, office buildings, and retail establishments). It addresses the building entrance, landscaping, and interior design.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      85,
      90,
      89,
      109,
      86
    ],
    "source": "891437_c06"
  },
  {
    "id": 257,
    "question": "Which of the following are enclosures that can block signals?",
    "choice_a": "Bollards",
    "choice_b": "Mantraps",
    "choice_c": "Faraday cage",
    "choice_d": "Security vestibule",
    "correct_answer": "C",
    "explanation": "There are emissions coming from the servers themselves that can sometimes disclose sensitive information. This can be addressed by placing the server inside enclosures that can block signals. One example is called a Faraday cage, which implements an outer barrier or coating called a Faraday shield.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      92,
      109,
      85,
      89,
      88
    ],
    "source": "891437_c06"
  },
  {
    "id": 258,
    "question": "Which of the following is no longer legal to use in a fire suppression system?",
    "choice_a": "Halon",
    "choice_b": "Water",
    "choice_c": "Argon",
    "choice_d": "NAS-S-III",
    "correct_answer": "A",
    "explanation": "At one time, fire suppression systems used Halon gas, which works well by suppressing combustion through a chemical reaction. However, these systems are no longer used because they have been found to damage the ozone layer.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      88,
      85,
      87,
      90,
      109
    ],
    "source": "891437_c06"
  },
  {
    "id": 259,
    "question": "Which of the following types of groups\u2019 main function is to serve as a group to which an email can be sent and every member of the group receives the email?",
    "choice_a": "Security",
    "choice_b": "Domain",
    "choice_c": "Distribution",
    "choice_d": "OU",
    "correct_answer": "C",
    "explanation": "There is an interesting relationship between security groups and distribution groups. While a security group can also be used as a distribution group, a distribution group cannot be used as a security group.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      118,
      124,
      125,
      117,
      121
    ],
    "source": "891437_c07"
  },
  {
    "id": 260,
    "question": "Group memberships can be monitored using which Group Policy setting?",
    "choice_a": "Restricted Groups",
    "choice_b": "gpedit.msc",
    "choice_c": "gpresult.msc",
    "choice_d": "Privileged access",
    "correct_answer": "A",
    "explanation": "Group memberships can be monitored using a Group Policy setting, Restricted Groups. When this policy is applied to a container in Active Directory, it checks the membership of each group each time the policy is refreshed (at login and startup), removes any members that are not approved, and readds any members that have somehow been deleted.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      125,
      118,
      117,
      110,
      96
    ],
    "source": "891437_c07"
  },
  {
    "id": 261,
    "question": "Which of the following authentication methods is <i>not</i> an example of biometrics?",
    "choice_a": "Password",
    "choice_b": "Hand scanners",
    "choice_c": "Fingerprint scan",
    "choice_d": "Retina scan",
    "correct_answer": "A",
    "explanation": "Biometric devices use physical characteristics to identify the user. Such devices are becoming more common in the business environment. Biometric systems include hand scanners, retinal scanners, and soon, possibly, DNA scanners.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      86,
      122,
      119,
      100,
      87
    ],
    "source": "891437_c07"
  },
  {
    "id": 262,
    "question": "Which of the following is <i>not</i> an NTFS file permission?",
    "choice_a": "Read",
    "choice_b": "List Folder Contents",
    "choice_c": "Full Control",
    "choice_d": "Write",
    "correct_answer": "B",
    "explanation": "List Folder Contents is an NTFS folder permission, not a file permission.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      120,
      123,
      122,
      106,
      105
    ],
    "source": "891437_c07"
  },
  {
    "id": 263,
    "question": "Which of the following groups have the same rights as standard users except that they can\u2019t access log files?",
    "choice_a": "Guests",
    "choice_b": "Administrators",
    "choice_c": "Print Managers",
    "choice_d": "Server Operators",
    "correct_answer": "A",
    "explanation": "For the most part, members of Guests have the same rights as users except that they can\u2019t access log files. The best reason to make users members of the Guests group is if they are accessing the system only for a limited time.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      118,
      117,
      124,
      125,
      121
    ],
    "source": "891437_c07"
  },
  {
    "id": 264,
    "question": "Data that resides on storage devices is called which of the following?",
    "choice_a": "Data in transit",
    "choice_b": "Data in use",
    "choice_c": "Data at rest",
    "choice_d": "Data in process",
    "correct_answer": "C",
    "explanation": "When using encryption to protect data that resides on storage devices, the data is called data at rest.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      112,
      113,
      114,
      115,
      116
    ],
    "source": "891437_c07"
  },
  {
    "id": 265,
    "question": "Which of the following is an encryption tool built into all Enterprise versions of Windows?",
    "choice_a": "NTFS",
    "choice_b": "AES",
    "choice_c": "EFS",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "Encryption at the file level is performed on each file or on a folder that contains files. In Windows this is done using the Encrypting File System (EFS). EFS is an encryption tool built into all Enterprise versions of Windows.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      112,
      111,
      120,
      107,
      129
    ],
    "source": "891437_c07"
  },
  {
    "id": 266,
    "question": "Which of the following is located on the motherboard of the system and provides password protection, digital rights management (DRM), and full-disk encryption?",
    "choice_a": "EEPROM",
    "choice_b": "TPM",
    "choice_c": "EFS",
    "choice_d": "SSH",
    "correct_answer": "B",
    "explanation": "Disk-level encryption may use a Trusted Platform Module (TPM) chip. This chip is located on the motherboard of the system and provides password protection, digital rights management (DRM), and full-disk encryption.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      112,
      109,
      111,
      119,
      100
    ],
    "source": "891437_c07"
  },
  {
    "id": 267,
    "question": "Which of the following is a file that locates the operating system files and loads them into memory so that they can be executed to start the OS?",
    "choice_a": "Bootstrap",
    "choice_b": "Bootloader",
    "choice_c": "BIOS",
    "choice_d": "UEFI",
    "correct_answer": "B",
    "explanation": "A bootloader is a file that locates the operating system files and loads them into memory so that they can be executed to start the OS. For example, GRUB is the bootloader package in Linux and Unix systems.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      105
    ],
    "source": "891437_c07"
  },
  {
    "id": 268,
    "question": "Which of the following helps in determining the relative priority of each dataset?",
    "choice_a": "Data encoding",
    "choice_b": "Data classification",
    "choice_c": "Data dictionary",
    "choice_d": "Data print",
    "correct_answer": "B",
    "explanation": "Determining the relative priority of each dataset cannot be done until all data is classified. There should be a system of data classification that extends to cover sensitive documents such as contracts, leases, design plans, and product details.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      116,
      101,
      115,
      127,
      129
    ],
    "source": "891437_c07"
  },
  {
    "id": 269,
    "question": "Which of the following is the strongest password?",
    "choice_a": "0135",
    "choice_b": "PassWord",
    "choice_c": "MyP@$$phraSe",
    "choice_d": "We@kP@$$w0rd",
    "correct_answer": "D",
    "explanation": "We@kP@$$w0rd contains all four character types, making it the strongest password.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      105,
      106,
      98,
      99,
      96
    ],
    "source": "891437_c07"
  },
  {
    "id": 270,
    "question": "Which of the following is sometimes called a superuser account?",
    "choice_a": "Guest",
    "choice_b": "Administrator",
    "choice_c": "Print Manager",
    "choice_d": "Support",
    "correct_answer": "B",
    "explanation": "The term <i>superuser</i> applies to any user account that has total control and access to a system. This user will possess the Full Control permission to every resource and object on the device for which the user possesses this account type. Various operating systems attach different names to this account. Windows systems call this the Administrator account.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      117,
      124,
      120,
      119,
      125
    ],
    "source": "891437_c07"
  },
  {
    "id": 271,
    "question": "Which of the following tracks all events on a particular Windows computer?",
    "choice_a": "Event Viewer",
    "choice_b": "Action Center",
    "choice_c": "Security Center",
    "choice_d": "Audit Center",
    "correct_answer": "A",
    "explanation": "Every program and process theoretically could have its own logging utility, but Microsoft provides the Event Viewer, which, through log files, tracks all events on a Windows computer.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      121,
      99,
      96,
      97,
      119
    ],
    "source": "891437_c07"
  },
  {
    "id": 272,
    "question": "Which of the following is <i>not</i> an example of something you are?",
    "choice_a": "Fingerprint",
    "choice_b": "Password",
    "choice_c": "Retina scan",
    "choice_d": "Voice recognition",
    "correct_answer": "B",
    "explanation": "A password is an example of something you know.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      122,
      119,
      86,
      98,
      109
    ],
    "source": "891437_c07"
  },
  {
    "id": 273,
    "question": "Which of the following gives users access to all the applications and systems they need when they log on?",
    "choice_a": "HIDS",
    "choice_b": "PDU",
    "choice_c": "SSO",
    "choice_d": "UPS",
    "correct_answer": "C",
    "explanation": "The purpose of single sign-on (SSO) is to give users access to all the applications and systems they need when they log on. This has become a reality in many environments, including Kerberos, Microsoft Active Directory, Novell eDirectory, and some certificate model implementations.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      123,
      117,
      124,
      125,
      118
    ],
    "source": "891437_c07"
  },
  {
    "id": 274,
    "question": "Which of the following describes any method that deletes data in such a way that the data can be recovered later using special data forensics software?",
    "choice_a": "Degaussing",
    "choice_b": "Shredding",
    "choice_c": "Incinerating",
    "choice_d": "Soft wipe",
    "correct_answer": "D",
    "explanation": "A soft wipe describes any method that deletes data in such a way that the data can be recovered later using special data forensics software. The best example of this is the simple file deletion process.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      101,
      115,
      129,
      97
    ],
    "source": "891437_c07"
  },
  {
    "id": 275,
    "question": "Which of the following is a term used to describe any deletion process that cannot be reversed using data recovery or forensics software?",
    "choice_a": "Deletion",
    "choice_b": "Hard wipe",
    "choice_c": "Soft wipe",
    "choice_d": "Remote Wipe",
    "correct_answer": "B",
    "explanation": "A hard wipe is a term used to describe any deletion process that cannot be reversed using data recovery or forensics software. Most disk management software will provide this type of deletion and may refer to it in various terms, such as \u201cscrubbing\u201d the drive.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      127,
      97,
      99,
      115,
      155
    ],
    "source": "891437_c07"
  },
  {
    "id": 276,
    "question": "What is the most effective data destruction method?",
    "choice_a": "Degaussing",
    "choice_b": "Hard wipe",
    "choice_c": "Remote wipe",
    "choice_d": "Shredding",
    "correct_answer": "D",
    "explanation": "Physical destruction is always the best method.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      127,
      115,
      101,
      116,
      97
    ],
    "source": "891437_c07"
  },
  {
    "id": 277,
    "question": "Which of the following is a grouping of resources that can be used to restrict the range of an operation or action?",
    "choice_a": "Realm",
    "choice_b": "Domain",
    "choice_c": "OU",
    "choice_d": "Scope",
    "correct_answer": "D",
    "explanation": "Scope-based access control allows you to create a custom set of resources (called a scope) and assign access to them to a user.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      118,
      120,
      124,
      106,
      125
    ],
    "source": "891437_c07"
  },
  {
    "id": 278,
    "question": "Which of the following is the loopback address in IPV6?",
    "choice_a": "127.0.0.1",
    "choice_b": "FE80::",
    "choice_c": "::1",
    "choice_d": "FEC0:",
    "correct_answer": "C",
    "explanation": "In IPv6 the loopback address is all zeroes in every hextet except the last. Closing up the first seven hextets with a double colon results in ::, and the one in the last hextet results in ::1 after omitting the leading zeroes in the last hextet.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      136,
      137,
      143,
      134,
      141
    ],
    "source": "891437_c08"
  },
  {
    "id": 279,
    "question": "Which of the following is the IPv6 prefix of an autoconfigured address?",
    "choice_a": "127.0.0.1",
    "choice_b": "FE80::",
    "choice_c": "::1",
    "choice_d": "FEC0:",
    "correct_answer": "B",
    "explanation": "When autoconfiguration is used, the first hextet will always be FE80::. The rest of the address will be derived from the MAC address of the device.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      143,
      136,
      137,
      138,
      142
    ],
    "source": "891437_c08"
  },
  {
    "id": 280,
    "question": "When implementing CIDR, what configuration setting is manipulated to size the subnet as desired?",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Default gateway",
    "choice_d": "Duplex",
    "correct_answer": "B",
    "explanation": "Using CIDR, administrators can create smaller networks called subnets by manipulating the subnet mask of a larger classless or major network ID. This allows you to create a subnet that is much closer in size to what you need, thus wasting fewer IP addresses and increasing performance in each subnet.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      137,
      130,
      131,
      132,
      136
    ],
    "source": "891437_c08"
  },
  {
    "id": 281,
    "question": "Which of the following is <i>not</i> a private IP address?",
    "choice_a": "10.0.0.5",
    "choice_b": "172.16.5.9",
    "choice_c": "192.168.5.9",
    "choice_d": "172.32.63.4",
    "correct_answer": "D",
    "explanation": "The Class B range of private IP addresses is from 172.16.0.0 to 172.31.255.255.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      138,
      136,
      130,
      142,
      143
    ],
    "source": "891437_c08"
  },
  {
    "id": 282,
    "question": "Which of the following is an APIPA address?",
    "choice_a": "168.254.3.3",
    "choice_b": "172.16.5.9",
    "choice_c": "192.168.5.9",
    "choice_d": "169.254.5.6",
    "correct_answer": "D",
    "explanation": "Automatic Private IP Addressing (APIPA) is a TCP/IP feature Microsoft added to their operating systems. If a DHCP server cannot be found and the clients are configured to obtain IP addresses automatically, the clients automatically assign themselves an IP address, somewhat randomly, in the 169.254.x.x range with a subnet mask of 255.255.0.0.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      143,
      142,
      138,
      137,
      130
    ],
    "source": "891437_c08"
  },
  {
    "id": 283,
    "question": "Which of the following is an example of a link local IPv6 address?",
    "choice_a": "FE80::2237:06FF:FECF:67E4/64",
    "choice_b": "FE80::1/64",
    "choice_c": "::1",
    "choice_d": "FEC0: 2237:06FF:FECF:67E4/64",
    "correct_answer": "A",
    "explanation": "In IPv6, there is a type of address called a link local address that in many ways is like an APIPA address in that the device will generate one of these addresses for each interface with no intervention from a human, as is done with APIPA. The devices always generate the address using the same IPv6 prefix (the equivalent of a network ID in IPv4), which is FE80::/64. The reminder of the address is created by spreading the 48-bit MAC address across the last 64 bits.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      143,
      136,
      137,
      142,
      141
    ],
    "source": "891437_c08"
  },
  {
    "id": 284,
    "question": "Which of the following is <i>not</i> a FQDN?",
    "choice_a": "tmcmillan",
    "choice_b": "tmcmillan.acme.com",
    "choice_c": "ws5.ajax.com",
    "choice_d": "smitht.smithcorp.com",
    "correct_answer": "A",
    "explanation": "Fully qualified domain names (FQDN) identify the host and the location of the hostname in the DNS namespace of the organization. They consist of at least two parts and perhaps more. All FQDNs will have a hostname and a domain name.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      133,
      135,
      136,
      138
    ],
    "source": "891437_c08"
  },
  {
    "id": 285,
    "question": "When does a device use a DNS suffix search list?",
    "choice_a": "At all times",
    "choice_b": "When an unqualified hostname is encountered",
    "choice_c": "When an FQDN is encountered",
    "choice_d": "When the users select to use the list",
    "correct_answer": "B",
    "explanation": "In many instances, users make references to unqualified hostnames when accessing resources. When this occurs, DNS needs to know how to handle these unqualified domain names. It is possible to configure a list of domain names called suffixes for the DNS to append to unqualified hostnames and the order in which they should be tried.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      135,
      134,
      133,
      141,
      130
    ],
    "source": "891437_c08"
  },
  {
    "id": 286,
    "question": "Which of the following is a file type used to automate a command or set of commands?",
    "choice_a": "JPG",
    "choice_b": "BAT",
    "choice_c": "TXT",
    "choice_d": "SFX",
    "correct_answer": "B",
    "explanation": "Batch files, or files with a <code>.bat</code> extension, are used to automate a command or set of commands each time you execute the batch file.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      144,
      148,
      145,
      29,
      25
    ],
    "source": "891437_c08"
  },
  {
    "id": 287,
    "question": "Which of the following are freestanding devices that operate in a largely self-contained manner, requiring less maintenance and support than a server-based product?",
    "choice_a": "VMs",
    "choice_b": "Appliances",
    "choice_c": "Rack systems",
    "choice_d": "Modules",
    "correct_answer": "B",
    "explanation": "Firewalls are becoming available as appliances, meaning they\u2019re installed as the primary device separating two networks. Appliances are freestanding devices that operate in a largely self-contained manner, requiring less maintenance and support than a server-based product.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      140,
      139,
      60,
      24,
      35
    ],
    "source": "891437_c08"
  },
  {
    "id": 288,
    "question": "Which of the following is a method of spreading the 48-bit MAC address across 64 bits so that it can be used as the last 64 bits of the 128-bit IPv6 address?",
    "choice_a": "TACACS",
    "choice_b": "EIU-64 format",
    "choice_c": "TACACS+",
    "choice_d": "MAC-48 format",
    "correct_answer": "B",
    "explanation": "When EUI-64 is used, it doesn\u2019t actually change the format of the physical 48-bit MAC address. It is a method of spreading the 48-bit MAC address across 64 bits so that it can be used as the last 64 bits of the 128-bit IPv6 address.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      136,
      137,
      134,
      141,
      142
    ],
    "source": "891437_c08"
  },
  {
    "id": 289,
    "question": "Which of the following parts of a MAC address identify the manufacturer of the interface?",
    "choice_a": "UAA",
    "choice_b": "BAA",
    "choice_c": "OUI",
    "choice_d": "EUI-64",
    "correct_answer": "C",
    "explanation": "Each part of this address communicates information. The left half of the address is called the organizationally unique identifier (OUI). The right half is called the universally administered address (UAA). Together they make a globally unique MAC address.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      136,
      137,
      138,
      143,
      141
    ],
    "source": "891437_c08"
  },
  {
    "id": 290,
    "question": "Which of the following attacks\u2019 aim is to receive traffic from a VLAN of which the hacker\u2019s port is not a member?",
    "choice_a": "SYN flood",
    "choice_b": "VLAN hopping",
    "choice_c": "DoS",
    "choice_d": "Teardrop",
    "correct_answer": "B",
    "explanation": "A VLAN security issue you should be aware of is called VLAN hopping. By default, a switch port is an access port, which means it can only be a member of a single VLAN. Ports that are configured to carry the traffic of multiple VLANs, called trunk ports, are used to carry traffic between switches and to routers. A VLAN hopping attack\u2019s aim is to receive traffic from a VLAN of which the hacker\u2019s port is not a member.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      131,
      132,
      140,
      42,
      43
    ],
    "source": "891437_c08"
  },
  {
    "id": 291,
    "question": "Which of the following is the address of the machine to send data to that is not intended for a host on this network?",
    "choice_a": "Subnet mask",
    "choice_b": "Default gateway",
    "choice_c": "Management port",
    "choice_d": "Secondary address",
    "correct_answer": "B",
    "explanation": "In TCP/IP, a gateway is the address of the machine to send data to that is not intended for a host on this network (in other words, a default gateway). It is the router that allows traffic to be sent beyond the internal network.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      132,
      130,
      142,
      141,
      137
    ],
    "source": "891437_c08"
  },
  {
    "id": 292,
    "question": "What is the most important resource for a DNS server?",
    "choice_a": "CPU",
    "choice_b": "Disk",
    "choice_c": "NIC",
    "choice_d": "Memory",
    "correct_answer": "D",
    "explanation": "Memory is the most important resource because the entire DNS zone file will be loaded into memory. As you add zones, or as a zone gets larger, you should add memory.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      37,
      133,
      35,
      36,
      46
    ],
    "source": "891437_c08"
  },
  {
    "id": 293,
    "question": "Which of the following is the port number for SMTP?",
    "choice_a": "21",
    "choice_b": "161",
    "choice_c": "25",
    "choice_d": "20",
    "correct_answer": "C",
    "explanation": "Simple Mail Transfer Protocol (SMTP) is a protocol for sending email. SMTP uses port 25 by default.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      141,
      41,
      134,
      132,
      144
    ],
    "source": "891437_c08"
  },
  {
    "id": 294,
    "question": "Which of the following services uses port number 22?",
    "choice_a": "SFTP",
    "choice_b": "NTP",
    "choice_c": "HTTP",
    "choice_d": "HTTPS",
    "correct_answer": "A",
    "explanation": "Secure File Transfer Protocol over SSH, or SFTP, is a version of FTP that is encrypted by SSH. Since it operates over an SSH session and SSH uses port 22, SFTP uses port 22.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      141,
      41,
      144,
      42,
      84
    ],
    "source": "891437_c08"
  },
  {
    "id": 295,
    "question": "Which of the following has lost favor to SSH because it sends data\u2014including passwords\u2014in plain-text format?",
    "choice_a": "POP3",
    "choice_b": "Telnet",
    "choice_c": "RDP",
    "choice_d": "IMAP",
    "correct_answer": "B",
    "explanation": "Telnet is a protocol that functions at the Application layer of the OSI model, providing terminal-emulation capabilities. Telnet runs on port 23 but has lost favor to SSH because Telnet sends data\u2014including passwords\u2014in plain-text format.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      141,
      140,
      42,
      133,
      144
    ],
    "source": "891437_c08"
  },
  {
    "id": 296,
    "question": "Which of the following is the default Class C subnet mask?",
    "choice_a": "255.255.0.0",
    "choice_b": "255.255.255.0",
    "choice_c": "255.0.0.0",
    "choice_d": "255.255.255.240",
    "correct_answer": "B",
    "explanation": "The default subnet masks are:<ul><li>Class A: 255.0.0.0</li><li>Class B: 255.255.0.0</li><li>Class C: 255.255.255.0.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      137,
      130,
      136,
      142,
      143
    ],
    "source": "891437_c08"
  },
  {
    "id": 297,
    "question": "Which of the following is a remote administration tool that can serve as a secure alternative to using Telnet to remotely access and configure a device like a router or switch?",
    "choice_a": "SSL",
    "choice_b": "SSH",
    "choice_c": "STP",
    "choice_d": "SCP",
    "correct_answer": "B",
    "explanation": "Although it requires a bit more setup than Telnet, SSH provides an encrypted command-line session for managing devices remotely.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      141,
      41,
      27,
      140,
      77
    ],
    "source": "891437_c08"
  },
  {
    "id": 298,
    "question": "Which of the following site types contains only electrical and communications wiring, air conditioning, plumbing, and raised flooring?",
    "choice_a": "Mirrored",
    "choice_b": "Warm",
    "choice_c": "Cold",
    "choice_d": "Hot",
    "correct_answer": "C",
    "explanation": "A cold site is a leased facility that contains only electrical and communications wiring, air conditioning, plumbing, and raised flooring. No communications equipment, networking hardware, or computers are installed at a cold site until it is necessary to bring the site to full operation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      158,
      114,
      151,
      155,
      152
    ],
    "source": "891437_c09"
  },
  {
    "id": 299,
    "question": "Which of the following replication methods results in the secondary site being constantly up-to-date?",
    "choice_a": "Asynchronous",
    "choice_b": "Bidirectional",
    "choice_c": "Constant",
    "choice_d": "Synchronous",
    "correct_answer": "C",
    "explanation": "When constant replication is in use, each time a change is made (data addition, deletion, change, etc.) at the primary site, the same change is written to the secondary site. This results in the secondary site being constantly up-to-date and is generally an expensive option.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      159,
      160,
      158,
      161,
      154
    ],
    "source": "891437_c09"
  },
  {
    "id": 300,
    "question": "In which replication method is the write operation to the primary system acknowledged by the primary system before the write is sent to the secondary?",
    "choice_a": "Asynchronous",
    "choice_b": "Bidirectional",
    "choice_c": "Constant",
    "choice_d": "Synchronous",
    "correct_answer": "A",
    "explanation": "With asynchronous replication, the write operation to the primary system is acknowledged by the primary system before the write is sent to the secondary, whereas with synchronous replication, the write is sent to the secondary system without waiting for acknowledgment from the primary.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      159,
      160,
      150,
      156,
      161
    ],
    "source": "891437_c09"
  },
  {
    "id": 301,
    "question": "Which of the following replication methods is advisable if the system to which the replication is occurring is also performing work on behalf of users?",
    "choice_a": "Bidirectional",
    "choice_b": "Synchronous",
    "choice_c": "Constant",
    "choice_d": "Background",
    "correct_answer": "D",
    "explanation": "Background replication means that the replication process is performed as a background operation. A background operation is processing that occurs \u201cin the background\u201d while a user is performing other tasks in the system.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      159,
      158,
      150,
      157,
      156
    ],
    "source": "891437_c09"
  },
  {
    "id": 302,
    "question": "Which tape format uses colors to indicate a specific cartridge type?",
    "choice_a": "IBM",
    "choice_b": "Oracle",
    "choice_c": "BIA",
    "choice_d": "LTO",
    "correct_answer": "D",
    "explanation": "One interesting feature with respect to the various versions of LTO is the use of colors to indicate a specific cartridge type. For example, though not a standard, LTO-6 cartridges are typically black whereas LTO-5 cartridges are red (unless they are from HP, which has its own color scheme).",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      152,
      112,
      151,
      150,
      153
    ],
    "source": "891437_c09"
  },
  {
    "id": 303,
    "question": "Which type of snapshot is a snapshot of everything rather than just the changes?",
    "choice_a": "Copy-on-write",
    "choice_b": "Shadow",
    "choice_c": "File lock",
    "choice_d": "Split mirror",
    "correct_answer": "D",
    "explanation": "This type of snapshot is created every time a change is made and is a snapshot of everything rather than just the changes. However, it takes significant storage space and the restore process is slower.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      154,
      149,
      152,
      155,
      156
    ],
    "source": "891437_c09"
  },
  {
    "id": 304,
    "question": "What file attribute is used to communicate to the backup system whether a particular file has changed since the last backup?",
    "choice_a": "Read only",
    "choice_b": "Archive",
    "choice_c": "System",
    "choice_d": "Hidden",
    "correct_answer": "B",
    "explanation": "The archive bit is used to communicate to the backup system whether a particular file has changed since the last backup. When the archive bit is cleared (0), it communicates that the file has been backed up already and has not changed since. When the bit is on (1), it communicates that the file has changed since the last backup and should be backed up again.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      149,
      150,
      151,
      157,
      155
    ],
    "source": "891437_c09"
  },
  {
    "id": 305,
    "question": "Which backup methods do <i>not</i> clear the archive bit? (Choose two.)",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Copy",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Neither the differential nor the copy backup clears the archive bit.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      149,
      150,
      151,
      157,
      155
    ],
    "source": "891437_c09"
  },
  {
    "id": 306,
    "question": "Which of the following always requires exactly two tapes to restore?",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Copy",
    "correct_answer": "B",
    "explanation": "While a full backup requires only one backup tape for restoration and the number of tapes required when using incremental and copy methods depends on when the failure occurs, when the differential method is used you always only need the last full backup and the last differential backup tapes to restore.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      149,
      151,
      156,
      155,
      157
    ],
    "source": "891437_c09"
  },
  {
    "id": 307,
    "question": "You do a full backup every Saturday at 1 a.m. and an incremental backup every other day of the week at 1 a.m. A drive failure occurs on Thursday afternoon at 5:30. How many backup tapes do you need to restore?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "4",
    "choice_d": "6",
    "correct_answer": "D",
    "explanation": "You will need the last full tape from Saturday and the incremental tapes from Sunday, Monday, Tuesday, Wednesday, and Thursday.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      149,
      151,
      155,
      157,
      161
    ],
    "source": "891437_c09"
  },
  {
    "id": 308,
    "question": "Which snapshot type is taken every time a user enters data or changes data and includes only the changed data?",
    "choice_a": "Site-to-site",
    "choice_b": "Copy-on-write",
    "choice_c": "Array-based",
    "choice_d": "Split mirror",
    "correct_answer": "B",
    "explanation": "This type of snapshot is taken every time a user enters data or changes data, and it only includes the changed data. Although it allows for rapid recovery from a loss of data, it requires you to have access to all previous snapshots during recovery.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      154,
      150,
      149,
      157,
      156
    ],
    "source": "891437_c09"
  },
  {
    "id": 309,
    "question": "Which of the following is required to be supported to perform an open file backup?",
    "choice_a": "VSS",
    "choice_b": "BAA",
    "choice_c": "OUI",
    "choice_d": "EUI-64",
    "correct_answer": "A",
    "explanation": "Backup programs that use the Windows Volume Shadow Copy Service (VSS) can back up open files. However, you should know that when you back up open files in this manner, changes that may have been made to the file while it was open and the backup job was proceeding will not be present in the backup of the open file and will not be recorded until the next backup.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      155,
      150,
      154,
      149,
      157
    ],
    "source": "891437_c09"
  },
  {
    "id": 310,
    "question": "Which disaster test type is the riskiest test to perform but will also generate the best data about the sufficiency of your disaster recovery plan?",
    "choice_a": "Live failover",
    "choice_b": "Simulated failover",
    "choice_c": "Tabletop",
    "choice_d": "Staged",
    "correct_answer": "A",
    "explanation": "A live failover test is one in which the primary site is taken down and operations are completely switched over to the secondary site. While this is the riskiest test to perform, it will also generate the best data about the sufficiency of your disaster recovery plan.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      161,
      158,
      160,
      159,
      155
    ],
    "source": "891437_c09"
  },
  {
    "id": 311,
    "question": "Which backup media type provides linear access to the data?",
    "choice_a": "CD",
    "choice_b": "Tape",
    "choice_c": "DVD",
    "choice_d": "External hard drive",
    "correct_answer": "B",
    "explanation": "While younger technicians may be unfamiliar with the task of rewinding or fast-forwarding a music tape or cassette to access a particular song, it illustrates the way linear access works. A song cannot be played until the tape head (reader) is positioned over the location where that song resides. Accessing data on a tape must be done the same way.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      152,
      153,
      149,
      151,
      157
    ],
    "source": "891437_c09"
  },
  {
    "id": 312,
    "question": "What is the purpose of creating a backup using checksums?",
    "choice_a": "For integrity verification",
    "choice_b": "To encrypt the data",
    "choice_c": "To speed restoration",
    "choice_d": "To deduplicate the data",
    "correct_answer": "A",
    "explanation": "Checksums are used to verify that the data has not been corrupted during the backup.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      155,
      95,
      157,
      151,
      150
    ],
    "source": "891437_c09"
  },
  {
    "id": 313,
    "question": "Which of the following is from machine to machine or server to server?",
    "choice_a": "Mirroring replication",
    "choice_b": "Asynchronous replication",
    "choice_c": "Synchronous replication",
    "choice_d": "Background replication",
    "correct_answer": "A",
    "explanation": "While replication is considered to be from database to database, mirroring is from machine to machine or server to server. In server-to-server replication, also called host-based replication, software on the servers handle the replication process.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      160,
      159,
      158,
      161,
      150
    ],
    "source": "891437_c09"
  },
  {
    "id": 314,
    "question": "Which of the following uses three sets of backup tapes?",
    "choice_a": "GFS",
    "choice_b": "Tower of Hanoi",
    "choice_c": "FIFO",
    "choice_d": "LIFO",
    "correct_answer": "A",
    "explanation": "In this scheme, three sets of backups are defined. Most often these three definitions are daily, weekly, and monthly.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      151,
      149,
      152,
      155,
      157
    ],
    "source": "891437_c09"
  },
  {
    "id": 315,
    "question": "Which of the following rotation schemes does not protect against data errors?",
    "choice_a": "GFS",
    "choice_b": "Tower of Hanoi",
    "choice_c": "FIFO",
    "choice_d": "LIFO",
    "correct_answer": "C",
    "explanation": "In this scheme, the newest backup is saved to the oldest media. Although this is the simplest rotation scheme, it does not protect against data errors. If an error in data occurs, this system may result over time in all copies containing the error.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      151,
      157,
      155,
      149,
      95
    ],
    "source": "891437_c09"
  },
  {
    "id": 316,
    "question": "Which of the following is a storage device that contains multiple tape drives?",
    "choice_a": "Jumpbox",
    "choice_b": "Tape library",
    "choice_c": "Content library",
    "choice_d": "Jukebox",
    "correct_answer": "B",
    "explanation": "A tape library contains a number of slots to hold tape cartridges and a barcode reader that is used to identify the cartridges.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      152,
      157,
      151,
      114,
      153
    ],
    "source": "891437_c09"
  },
  {
    "id": 317,
    "question": "Which type of disaster plan testing is the most cost-effective and efficient way to identify issues?",
    "choice_a": "Live failover",
    "choice_b": "Simulated failover",
    "choice_c": "Tabletop",
    "choice_d": "Staged",
    "correct_answer": "C",
    "explanation": "Conducting a tabletop exercise is the most cost-effective and efficient way to identify areas of vulnerability before moving on to more involved testing. A tabletop exercise is an informal brainstorming session that encourages participation from business leaders and other key employees.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      161,
      158,
      155,
      157,
      159
    ],
    "source": "891437_c09"
  },
  {
    "id": 318,
    "question": "Which of the following steps in the CompTIA troubleshooting method come last?",
    "choice_a": "Verify full system functionality and, if applicable, implement preventive measures.",
    "choice_b": "Document findings, actions, and outcomes throughout the process.",
    "choice_c": "Identify the problem and determine the scope.",
    "choice_d": "Perform a root cause analysis.",
    "correct_answer": "B",
    "explanation": "The steps in order are:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      164,
      163,
      162,
      166,
      165
    ],
    "source": "891437_c10"
  },
  {
    "id": 319,
    "question": "Which of the following actions should be taken before making changes during troubleshooting?",
    "choice_a": "Reboot the computer in safe mode.",
    "choice_b": "Perform a backup.",
    "choice_c": "Notify the user.",
    "choice_d": "Disable the antimalware.",
    "correct_answer": "B",
    "explanation": "You may find yourself making significant changes on a server in an attempt to locate and/or solve the issue. Be sure that you do a backup before you make any changes so that all your actions can be undone, if necessary.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      165,
      162,
      163,
      164,
      194
    ],
    "source": "891437_c10"
  },
  {
    "id": 320,
    "question": "Which of the following statements is true with regard to troubleshooting?",
    "choice_a": "Make one change at a time.",
    "choice_b": "If multiple users are involved, the source is likely their local computers.",
    "choice_c": "You should always try to replicate the issue in the production environment.",
    "choice_d": "Always assume the cabling is good.",
    "correct_answer": "A",
    "explanation": "When you make multiple changes at a time, those changes might interact with one another and make the picture even muddier.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      163,
      162,
      164,
      195,
      197
    ],
    "source": "891437_c10"
  },
  {
    "id": 321,
    "question": "Which of the following events causes chip creep?",
    "choice_a": "High humidity",
    "choice_b": "Overheating",
    "choice_c": "Dropping the device",
    "choice_d": "Power surges",
    "correct_answer": "B",
    "explanation": "Chip creep\u2014the unseating of components\u2014is one of the more common byproducts of a cycle of overheating and cooling off the inside of the system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      175,
      176,
      164,
      163,
      162
    ],
    "source": "891437_c10"
  },
  {
    "id": 322,
    "question": "Replacing slot covers helps to prevent which event?",
    "choice_a": "Corrosion",
    "choice_b": "Overheating",
    "choice_c": "Theft",
    "choice_d": "EMI",
    "correct_answer": "B",
    "explanation": "Replacing slot covers is vital. Servers are designed to circulate air with slot covers in place or cards plugged into the ports. Leaving slots on the back of the computer open alters the air circulation and causes more dust to be pulled into the system.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      176,
      175,
      174,
      180,
      162
    ],
    "source": "891437_c10"
  },
  {
    "id": 323,
    "question": "In Linux you can use which of the following commands to stop a process?",
    "choice_a": "<code>quit</code>",
    "choice_b": "<code>kill</code>",
    "choice_c": "<code>stop</code>",
    "choice_d": "<code>net stop</code>",
    "correct_answer": "B",
    "explanation": "In Linux you can use the <code>kill</code> command to stop the process. To do so, you must identify the guilty process using the <code>ps</code> command.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      173,
      210,
      162,
      163,
      229
    ],
    "source": "891437_c10"
  },
  {
    "id": 324,
    "question": "What operating system generates BSOD error messages?",
    "choice_a": "Mac",
    "choice_b": "Linux",
    "choice_c": "Windows",
    "choice_d": "Android",
    "correct_answer": "C",
    "explanation": "A serious issue is a STOP message or Blue Screen of Death (BSOD) message. Once a regular occurrence when working with Windows, blue screens have become less common.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      169,
      168,
      171,
      228,
      193
    ],
    "source": "891437_c10"
  },
  {
    "id": 325,
    "question": "Which of the following is a group of different interfaces that share the same security attributes or the same level of trust?",
    "choice_a": "Zone",
    "choice_b": "Scope",
    "choice_c": "Subnet",
    "choice_d": "Collision domain",
    "correct_answer": "A",
    "explanation": "Some firewalls offer the ability to filter based on zones. A zone is a group of different interfaces that share the same security attributes or the same level of trust. You define which interfaces are in the same zone and then you create rules controlling traffic between zones.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      212,
      206,
      213,
      209,
      195
    ],
    "source": "891437_c10"
  },
  {
    "id": 326,
    "question": "Which of the following starts by using a preselected minimal set of drivers and startup programs?",
    "choice_a": "Clean boot",
    "choice_b": "Safe mode",
    "choice_c": "Diagnostic boot",
    "choice_d": "Core mode",
    "correct_answer": "B",
    "explanation": "Safe mode starts Windows in a basic state, using a limited set of files and drivers. If a problem doesn\u2019t happen in safe mode, this means that default settings and basic device drivers aren\u2019t causing the issue.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      193,
      163,
      162,
      169,
      185
    ],
    "source": "891437_c10"
  },
  {
    "id": 327,
    "question": "Which of the following servers are used as a time source by the devices in the network.?",
    "choice_a": "WINS",
    "choice_b": "NTP",
    "choice_c": "DNS",
    "choice_d": "Global Catalog",
    "correct_answer": "B",
    "explanation": "Network Time Protocol (NTP) servers are used as a time source by the devices in the network. When the devices are configured with the address of an NTP server, they will periodically check in with the server to ensure their time is correct.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      188,
      207,
      196,
      172,
      204
    ],
    "source": "891437_c10"
  },
  {
    "id": 328,
    "question": "Which of the following is <i>not</i> a possible reason users are having difficulty logging on to a server?",
    "choice_a": "Incorrect password",
    "choice_b": "Account disabled",
    "choice_c": "SQL server failure",
    "choice_d": "User error typing the password",
    "correct_answer": "C",
    "explanation": "SQL servers have no impact on users logging into to servers. When users have difficulty logging on to a server, it can be one of several things:<ul><li>User error typing the password</li><li>Incorrect password</li><li>Account disabled</li><li>Account expired</li><li>Inability to contact the domain controller</li><li>DNS server failure</li><li>Incorrect DNS server IP address on the server</li><li>Unauthorized user.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      182,
      199,
      196,
      162,
      163
    ],
    "source": "891437_c10"
  },
  {
    "id": 329,
    "question": "Which of the following is true of server backplanes?",
    "choice_a": "They can be a single point of failure.",
    "choice_b": "They provide data and control signal connectors for the CPU.",
    "choice_c": "Backplane failures are common.",
    "choice_d": "You should implement redundant backplanes.",
    "correct_answer": "A",
    "explanation": "Backplanes are advantageous in that they provide data and control signal connectors for the hard drives. They also provide the interconnect for the front I/O board, power and locator buttons, and system/component status LEDs. Unfortunately, this creates a serious single point of failure because if the backplane fails, we lose communication with the servers to which it is connected.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      180,
      174,
      162,
      163,
      164
    ],
    "source": "891437_c10"
  },
  {
    "id": 330,
    "question": "How should you use compressed air inside the case?",
    "choice_a": "Use long sustained bursts.",
    "choice_b": "Use short bursts.",
    "choice_c": "Hold the can 12 inches away from the system.",
    "choice_d": "Hold the can upside down.",
    "correct_answer": "B",
    "explanation": "You can remove dust and debris from inside servers with compressed air blown in short bursts. The short bursts are useful in preventing the dust from flying too far out and entering another machine, as well as in preventing the can from releasing the air in liquid form.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      176,
      175,
      162,
      163,
      229
    ],
    "source": "891437_c10"
  },
  {
    "id": 331,
    "question": "What should the humidity be in the server room?",
    "choice_a": "30 percent",
    "choice_b": "40 percent",
    "choice_c": "50 percent",
    "choice_d": "60 percent",
    "correct_answer": "C",
    "explanation": "Maintain the relative humidity at around 50 percent.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      176,
      175,
      180,
      172,
      224
    ],
    "source": "891437_c10"
  },
  {
    "id": 332,
    "question": "What can be the result of low humidity?",
    "choice_a": "Corrosion",
    "choice_b": "ESD",
    "choice_c": "RFI",
    "choice_d": "EMI",
    "correct_answer": "B",
    "explanation": "It is a balancing act keeping humidity at the right level since low humidity causes ESD and high humidity causes moisture condensation.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      177,
      176,
      175,
      168,
      179
    ],
    "source": "891437_c10"
  },
  {
    "id": 333,
    "question": "Which tab in Device Manager is used to identify IRQ conflicts?",
    "choice_a": "General",
    "choice_b": "Resources",
    "choice_c": "Driver",
    "choice_d": "Security",
    "correct_answer": "B",
    "explanation": "This tab shows the system resources in use (I/O, IRQ, and so on) and whether there are conflicts.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      187,
      186,
      229,
      228,
      162
    ],
    "source": "891437_c10"
  },
  {
    "id": 334,
    "question": "Which of the following may indicate a failing fan?",
    "choice_a": "Burning smell",
    "choice_b": "Whining sound",
    "choice_c": "Clicking noise",
    "choice_d": "Grinding noise",
    "correct_answer": "B",
    "explanation": "When the system makes noises, you should listen. A grinding or clicking noise can be a failing drive. A whining sound could be a fan on its way to failing.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      175,
      174,
      162,
      163,
      164
    ],
    "source": "891437_c10"
  },
  {
    "id": 335,
    "question": "Which of the following could <i>not</i> be a reason why a user cannot log on?",
    "choice_a": "User error typing the password",
    "choice_b": "Unauthorized user",
    "choice_c": "Incorrect password",
    "choice_d": "Spyware",
    "correct_answer": "D",
    "explanation": "Spyware would compromise the privacy of the users browsing but would not prevent them from logging on.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      214,
      212,
      196,
      162
    ],
    "source": "891437_c10"
  },
  {
    "id": 336,
    "question": "Which of the following occurs when an application is issued some memory to use and does not return the memory?",
    "choice_a": "Kernel panic",
    "choice_b": "BSOD",
    "choice_c": "Memory leak",
    "choice_d": "Mantrap",
    "correct_answer": "C",
    "explanation": "Memory leaks occur when an application is issued some memory to use and does not return the memory nor any temporary file to the operating system after the program no longer needs it.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      170,
      220,
      189,
      222,
      229
    ],
    "source": "891437_c10"
  },
  {
    "id": 337,
    "question": "Which of the following is an attack where the attacker submits too much data?",
    "choice_a": "SQL injection",
    "choice_b": "Buffer overflow",
    "choice_c": "Teardrop attack",
    "choice_d": "VLAN hopping",
    "correct_answer": "B",
    "explanation": "Buffers are portions of system memory that are used to store information. A buffer overflow is an attack that occurs when the amount of data that is submitted to is larger than the buffer can handle.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      189,
      170,
      210,
      220,
      224
    ],
    "source": "891437_c10"
  },
  {
    "id": 338,
    "question": "Which of the following addresses is used to test the functionality of the NIC?",
    "choice_a": "0.0.0.0",
    "choice_b": "127.0.0.1",
    "choice_c": "255.255.255.255",
    "choice_d": "0.0.0.1",
    "correct_answer": "B",
    "explanation": "Ensure that the NIC is functional and the TCP/IP protocol is installed and functional by pinging the loopback address 127.0.0.1.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      197,
      195,
      205,
      204,
      162
    ],
    "source": "891437_c11"
  },
  {
    "id": 339,
    "question": "Which of the following is <i>not</i> the proper application of a crossover cable?",
    "choice_a": "From one computer to another",
    "choice_b": "From a computer to a switch",
    "choice_c": "From a switch to a router",
    "choice_d": "From a switch to a switch",
    "correct_answer": "C",
    "explanation": "Crossover cables are used when:<ul><li>Connecting a computer to a computer</li><li>Connecting a router to a router</li><li>Connecting a switch to a switch</li><li>Connecting a hub to a hub</li><li>Connecting a router to a PC because both devices have the same components.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      197,
      195,
      204,
      202,
      209
    ],
    "source": "891437_c11"
  },
  {
    "id": 340,
    "question": "Which of the following attempts to avoid detection by masking itself from applications?",
    "choice_a": "Multipartite virus",
    "choice_b": "Stealth virus",
    "choice_c": "Armored virus",
    "choice_d": "Zero-day threat",
    "correct_answer": "B",
    "explanation": "A stealth virus attempts to avoid detection by masking itself from applications. It may attach itself to the boot sector of the hard drive. When a system utility or program runs, the stealth virus redirects commands around itself to avoid detection.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      185,
      214,
      213,
      216,
      224
    ],
    "source": "891437_c11"
  },
  {
    "id": 341,
    "question": "Which of the following commands clears the local DNS cache?",
    "choice_a": "<code>ipconfig/flushdns</code>",
    "choice_b": "<code>flushdns</code>",
    "choice_c": "<code>cache/flushdns</code>",
    "choice_d": "<code>ipconfig/flush</code>",
    "correct_answer": "A",
    "explanation": "If recent changes have occurred in the DNS mappings or if your connection to the destination device has recently failed because of a temporary network issue that has been solved, you may need to clear the local DNS cache using the <code>ipconfig/flushdns</code> command.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      203,
      199,
      204,
      196,
      195
    ],
    "source": "891437_c11"
  },
  {
    "id": 342,
    "question": "Which of the following should be the same on all devices in the same subnet?",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Hostname",
    "choice_d": "FQDN",
    "correct_answer": "B",
    "explanation": "Sometimes an incorrect mask will prevent all communication, but in some cases it results in successful connections locally but not remotely (outside the local subnet). The subnet mask value should be the same mask used on the router interface connecting to the local network.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      198,
      208,
      195,
      196,
      212
    ],
    "source": "891437_c11"
  },
  {
    "id": 343,
    "question": "Which of the following are programs that enter a system or network under the guise of another program?",
    "choice_a": "Middleware",
    "choice_b": "Worms",
    "choice_c": "Trojans",
    "choice_d": "Viruses",
    "correct_answer": "C",
    "explanation": "A Trojan horse may be included as an attachment or as part of an installation program. The Trojan horse can create a backdoor or replace a valid program during installation.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      215,
      214,
      213,
      185,
      210
    ],
    "source": "891437_c11"
  },
  {
    "id": 344,
    "question": "To monitor traffic on the network segment, the network interface card (NIC) must be operating in what mode?",
    "choice_a": "Promiscuous",
    "choice_b": "Active",
    "choice_c": "Passive",
    "choice_d": "Autosense",
    "correct_answer": "A",
    "explanation": "The most common IDS, a network-based IDS (NIDS), monitors network traffic on a local network segment. To monitor traffic on the network segment, the NIC must be operating in promiscuous mode.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      213,
      204,
      205,
      197,
      195
    ],
    "source": "891437_c11"
  },
  {
    "id": 345,
    "question": "Which of the following are APs that you do not control and manage?",
    "choice_a": "Fat AP",
    "choice_b": "Thin AP",
    "choice_c": "Rogue AP",
    "choice_d": "NIDAP",
    "correct_answer": "C",
    "explanation": "There are two types: those that are connected to your wired infrastructure and those that are not. The ones that are connected to your wired network present a danger to your wired and wireless networks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      201,
      212,
      206,
      195,
      203
    ],
    "source": "891437_c11"
  },
  {
    "id": 346,
    "question": "Which of the following would not be a cause of an inability to connect to the Internet?",
    "choice_a": "The IP address of the computer",
    "choice_b": "The MAC address of the computer",
    "choice_c": "The default gateway address of the computer",
    "choice_d": "The DNS server address of the computer",
    "correct_answer": "B",
    "explanation": "This issue can have a number of sources, including:<ul><li>The IP configuration of the user\u2019s computer</li><li>The IP configuration of the user\u2019s default gateway or router</li><li>The IP configuration of any routers that stand between the gateway and the Internet</li><li>The DNS server</li><li>The ISP</li><li>The DHCP server.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      196,
      198,
      207,
      199,
      197
    ],
    "source": "891437_c11"
  },
  {
    "id": 347,
    "question": "Which of the following commands could be used to see if HTTP is working on a server?",
    "choice_a": "<code>telnet 192.168.5.5</code>",
    "choice_b": "<code>ping 192.168.5.5 :80</code>",
    "choice_c": "<code>telnet 192.168.5.65 80</code>",
    "choice_d": "<code>pathping 192.168.5.5</code>",
    "correct_answer": "C",
    "explanation": "You can determine this by attempting a Telnet connection to the IP address of the device and adding the port number.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      203,
      204,
      195,
      212,
      163
    ],
    "source": "891437_c11"
  },
  {
    "id": 348,
    "question": "What is the code number of a destination unreachable message when it indicates the destination host is unreachable?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "B",
    "explanation": "It will appear as a destination unreachable message (this is a group of message types that all have code numbers) with a code number of 1.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      200,
      195,
      197,
      196,
      202
    ],
    "source": "891437_c11"
  },
  {
    "id": 349,
    "question": "You receive a destination unreachable message with no source IP address. Where is it coming from?",
    "choice_a": "A remote router",
    "choice_b": "A remote DNS server",
    "choice_c": "A local DNS server",
    "choice_d": "The local router",
    "correct_answer": "D",
    "explanation": "If the message comes with no source IP address, the message is coming from the local router (the default gateway of the sender). If it has the source IP address of the sender, then it is another router in the path.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      200,
      195,
      198,
      163,
      162
    ],
    "source": "891437_c11"
  },
  {
    "id": 350,
    "question": "When the default gateway address is incorrect on the router, which connections will succeed?",
    "choice_a": "From a local device to a remote device",
    "choice_b": "From a remote device to a local device",
    "choice_c": "From a local device to the Internet",
    "choice_d": "From a local device to a local device",
    "correct_answer": "D",
    "explanation": "If the computers cannot connect to the default gateway (which will be the case if the gateway is incorrect), it will be confined to communicating with devices on the local network.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      198,
      195,
      196,
      199,
      212
    ],
    "source": "891437_c11"
  },
  {
    "id": 351,
    "question": "Which server could be the source of an inability to connect to a local host by name?",
    "choice_a": "NAT server",
    "choice_b": "SQL server",
    "choice_c": "DNS server",
    "choice_d": "Web server",
    "correct_answer": "C",
    "explanation": "It is a name resolution or a DNS issue.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      199,
      204,
      196,
      195,
      197
    ],
    "source": "891437_c11"
  },
  {
    "id": 352,
    "question": "At what layer of the OSI model are devices in different VLANs separated?",
    "choice_a": "Layer 1",
    "choice_b": "Layer 2",
    "choice_c": "Layer 4",
    "choice_d": "Layer 7",
    "correct_answer": "B",
    "explanation": "Even if you assign devices in different VLANs with IP addresses in the same subnet, they will not be able to communicate because they are separated at Layer 2.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      202,
      209,
      205,
      198,
      199
    ],
    "source": "891437_c11"
  },
  {
    "id": 353,
    "question": "Which of the following features can be used to prevent unauthorized devices from connecting to a switch?",
    "choice_a": "NAT",
    "choice_b": "Port security",
    "choice_c": "Portfast",
    "choice_d": "Cipher",
    "correct_answer": "B",
    "explanation": "Some of the things you can specify using the port security feature are the only MAC address or addresses allowed to send traffic in the port, the total number of MAC addresses that can transmit on the port, and an action to be taken when a violation occurs (either shut the port down or prevent transmissions by the guilty MAC address).",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      209,
      212,
      206,
      201,
      213
    ],
    "source": "891437_c11"
  },
  {
    "id": 354,
    "question": "Which of the following processes completes its work but is mistakenly marked as a dead process, preventing it from ending?",
    "choice_a": "Inactive process",
    "choice_b": "Orphan process",
    "choice_c": "Zombie process",
    "choice_d": "Active process",
    "correct_answer": "C",
    "explanation": "A zombie process (work performed on behalf of services is done using processes) is one that is a child of another process. It becomes a zombie when it completes its work but is mistakenly marked as a dead process, preventing it from ending.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      210,
      173,
      163,
      164,
      193
    ],
    "source": "891437_c11"
  },
  {
    "id": 355,
    "question": "Which of the following features can administrators use to create smaller networks called subnets by manipulating the subnet mask of a larger classless or major network?",
    "choice_a": "NAT",
    "choice_b": "CIDR",
    "choice_c": "DHCP",
    "choice_d": "DNS",
    "correct_answer": "B",
    "explanation": "To allow for the creation of smaller networks that operate better, the concept of classless routing, or Classless Interdomain Routing (CIDR), was born.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      198,
      195,
      196,
      200,
      197
    ],
    "source": "891437_c11"
  },
  {
    "id": 356,
    "question": "What command is used on a router to identify the routes of which the router is aware?",
    "choice_a": "<code>show ip route</code>",
    "choice_b": "<code>show route</code>",
    "choice_c": "<code>route print</code>",
    "choice_d": "<code>show ip route</code>",
    "correct_answer": "A",
    "explanation": "The <code>show ip route</code> command can be used to identify the routes of which the router is aware.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      195,
      197,
      198,
      200,
      212
    ],
    "source": "891437_c11"
  },
  {
    "id": 357,
    "question": "Which commands are used on a router to identify the path taken to a destination network? (Choose two.)",
    "choice_a": "<code>traceroute</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ipconfig/trace</code>",
    "choice_d": "<code>trace</code>",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The <code>tracert</code> command (called <code>traceroute</code> in Linux and Unix) is used to trace the path of a packet through the network on routers.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      203,
      195,
      204,
      197,
      196
    ],
    "source": "891437_c11"
  },
  {
    "id": 358,
    "question": "In Linux, which of the following can cause an inability to locate the operating system?",
    "choice_a": "Missing NTLDR",
    "choice_b": "Missing GRUB",
    "choice_c": "Missing Bootmgr",
    "choice_d": "Missing boot.ini",
    "correct_answer": "B",
    "explanation": "In Linux and Unix, this issue can be caused by a missing GRUB/LILO.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      223,
      185,
      162,
      163,
      164
    ],
    "source": "891437_c12"
  },
  {
    "id": 359,
    "question": "Which of the following Windows commands lets you manage storage from the command line?",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "<code>net use</code>",
    "choice_d": "<code>format/s</code>",
    "correct_answer": "B",
    "explanation": "<code>diskpart</code> enables you to manage objects (disks, partitions, or volumes) by using scripts or direct input at a command prompt. It can perform all the functions that can be done with the Disk Management utility and quite a few that cannot be done with Disk Management.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      226,
      221,
      217,
      228,
      225
    ],
    "source": "891437_c12"
  },
  {
    "id": 360,
    "question": "What command can be used to attempt a repair of the dda drive in Linux?",
    "choice_a": "<code>fsck -a /dev/dda</code>",
    "choice_b": "<code>fdisk -s /dev/dda</code>",
    "choice_c": "<code>fsck /dev/dda</code>",
    "choice_d": "<code>fdisk /dev/dda</code>",
    "correct_answer": "A",
    "explanation": "If you want <code>fsck</code> to attempt to repair any errors it finds, add the <code>-a</code> or <code>-y</code> parameter after the command.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      224,
      217,
      221,
      185,
      162
    ],
    "source": "891437_c12"
  },
  {
    "id": 361,
    "question": "Which of the following commands in Linux can be used to diagnose a memory issue?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>top</code>",
    "choice_c": "<code>grub</code>",
    "choice_d": "<code>grep</code>",
    "correct_answer": "B",
    "explanation": "Among the issues that can be diagnosed with the <code>top</code> command are memory issues.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      220,
      173,
      210,
      170,
      168
    ],
    "source": "891437_c12"
  },
  {
    "id": 362,
    "question": "Which of the following operations makes the drive available to the disk management system, and in most cases, the drive will not show up until you do this?",
    "choice_a": "Mounting",
    "choice_b": "Formatting",
    "choice_c": "Initializing",
    "choice_d": "Extending",
    "correct_answer": "C",
    "explanation": "Initializing the drive can be done at the command line using <code>diskpart</code> or with the Disk Management tool. You need to know that initialization will wipe out the drive\u2019s contents!",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      226,
      221,
      217,
      224,
      216
    ],
    "source": "891437_c12"
  },
  {
    "id": 363,
    "question": "Which of the following is the most common cause of backup failures?",
    "choice_a": "Tape drive failure",
    "choice_b": "Human error",
    "choice_c": "Software errors",
    "choice_d": "SAN issues",
    "correct_answer": "B",
    "explanation": "While most data recovery failures are due to human error in the data backup process (running multiple jobs simultaneously, failure to change tapes, forgetting to remove a cleaning tape), there are some issues that are beyond your control.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      165,
      162,
      163,
      164,
      224
    ],
    "source": "891437_c12"
  },
  {
    "id": 364,
    "question": "For fiber-optic cables, if no specific recommendations are available from the cable manufacturer, the cable should not be pulled over a bend radius smaller than how many times the cable diameter?",
    "choice_a": "5",
    "choice_b": "10",
    "choice_c": "15",
    "choice_d": "20",
    "correct_answer": "D",
    "explanation": "When working with cables, especially fiber cables, you must recognize that every cable has a maximum bend radius, which you cannot exceed without damaging the cable. For fiber-optic cables, if no specific recommendations are available from the cable manufacturer, the cable should not be pulled over a bend radius smaller than 20 times the cable diameter.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      205,
      195,
      197,
      162,
      163
    ],
    "source": "891437_c12"
  },
  {
    "id": 365,
    "question": "Which of the following symptoms is caused by the read/write heads making contact with the platters?",
    "choice_a": "Whining sound",
    "choice_b": "Clicking sound",
    "choice_c": "Burning smell",
    "choice_d": "Poor performance",
    "correct_answer": "B",
    "explanation": "A loud clicking noise, sometimes referred to as the click of death, is caused by the read/write heads making contact with the platters. After that happens, both the heads and the platters become damaged, and the system becomes unable to establish a successful starting point to read the drive.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      219,
      216,
      221,
      217,
      224
    ],
    "source": "891437_c12"
  },
  {
    "id": 366,
    "question": "Which of the following Windows commands is used to identify and repair disk issues?",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "<code>chkdsk</code>",
    "choice_d": "<code>format/s</code>",
    "correct_answer": "C",
    "explanation": "There are a number of commercial partition tools that you can use to repair damaged partitions. Before you use one of these commercial tools, you might want to use one of the system tools available to you. One of these is <code>chkdsk</code> (Check Disk).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      221,
      217,
      224,
      222,
      228
    ],
    "source": "891437_c12"
  },
  {
    "id": 367,
    "question": "Which of the following writes parity information across the drives and writes two stripes, which allows the system to recover from two drive failures?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": "D",
    "explanation": "RAID 6 writes parity information across the drives as is done in RAID 5, but it writes two stripes, which allows the system to recover from two drive failures whereas RAID 5 cannot. As each set of parities must be calculated separately, performance is slowed during writing to the drive. The cost is higher due to the two drives dedicated to parity information.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      225,
      227,
      224,
      228,
      222
    ],
    "source": "891437_c12"
  },
  {
    "id": 368,
    "question": "What file is used by Linux to mount partitions on boot?",
    "choice_a": "<code>fstab</code>",
    "choice_b": "<code>grub</code>",
    "choice_c": "<code>lilo</code>",
    "choice_d": "<code>remount</code>",
    "correct_answer": "A",
    "explanation": "<code>fstab</code> (File System Table) is a file used by Linux operating systems to mount partitions on boot.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      226,
      216,
      193,
      223,
      192
    ],
    "source": "891437_c12"
  },
  {
    "id": 369,
    "question": "Which of the following is <i>not</i> a best practice when manually rebuilding RAID arrays?",
    "choice_a": "Clearly label the disks as you remove them and note the corresponding port.",
    "choice_b": "Identify, remove, and similarly label the faulty drive.",
    "choice_c": "The drives should be placed back in the reversed order of removals.",
    "choice_d": "If you are replacing a failed drive, ensure that it and the other drives are connected to the original port numbers.",
    "correct_answer": "C",
    "explanation": "The drives should be placed back in the reversed order of failures (failures, not removals).",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      227,
      225,
      219,
      224,
      164
    ],
    "source": "891437_c12"
  },
  {
    "id": 370,
    "question": "What command can be used in Linux to detect bad sectors?",
    "choice_a": "<code>fschk</code>",
    "choice_b": "<code>badblocks</code>",
    "choice_c": "<code>fstab</code>",
    "choice_d": "<code>grub</code>",
    "correct_answer": "B",
    "explanation": "<code>badblocks</code> has several different modes that allow you to detect bad sectors in Linux.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      224,
      167,
      217,
      171,
      162
    ],
    "source": "891437_c12"
  },
  {
    "id": 371,
    "question": "Which of the following <i>must</i> match when adding drives to a set of existing drives?",
    "choice_a": "Speed",
    "choice_b": "Capacity",
    "choice_c": "Architecture",
    "choice_d": "Vendor",
    "correct_answer": "C",
    "explanation": "While it is possible to use mismatched drives, you should have a clear understanding of the implications of each type of mismatch. The only requirement set in stone is that they must be of the same architecture.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      167,
      219,
      222,
      221,
      217
    ],
    "source": "891437_c12"
  },
  {
    "id": 372,
    "question": "What command is used to connect users to shared drives?",
    "choice_a": "<code>net share</code>",
    "choice_b": "<code>net use</code>",
    "choice_c": "<code>mount</code>",
    "choice_d": "<code>dmap</code>",
    "correct_answer": "B",
    "explanation": "The <code>net use</code> command is used to connect users to shared drives.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      195,
      196,
      204,
      197,
      162
    ],
    "source": "891437_c12"
  },
  {
    "id": 373,
    "question": "Which of the following is used to manage storage in Windows Server 2012 R2 at the command line?",
    "choice_a": "<code>fdisk</code>",
    "choice_b": "<code>format</code>",
    "choice_c": "<code>diskpart</code>",
    "choice_d": "<code>fstab</code>",
    "correct_answer": "C",
    "explanation": "In Windows Server 2012 R2, the <code>diskpart</code> command is used to manage storage from the command line.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      227,
      225,
      221,
      217,
      218
    ],
    "source": "891437_c12"
  },
  {
    "id": 374,
    "question": "Which of the following commands lists the partitions in a Linux system?",
    "choice_a": "<code>sudo fdisk -l</code>",
    "choice_b": "<code>sudo fdisk /dev</code>",
    "choice_c": "<code>fstab -a</code>",
    "choice_d": "<code>sudo fstab -a</code>",
    "correct_answer": "A",
    "explanation": "The <code>sudo fdisk -l</code> command lists the partitions on the system.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      221,
      224,
      222,
      217,
      167
    ],
    "source": "891437_c12"
  },
  {
    "id": 375,
    "question": "Which of the following tools cannot be used to mount a volume on a basic disk in Windows Server 2012 R2?",
    "choice_a": "<code>mountvol</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "Disk Management",
    "choice_d": "<code>fdisk</code>",
    "correct_answer": "D",
    "explanation": "<code>fdisk</code> is not available in Windows Server 2012 R2.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      226,
      221,
      217,
      223,
      228
    ],
    "source": "891437_c12"
  },
  {
    "id": 376,
    "question": "Which of the following can track the use of the CPU, memory, disk system, and network card in real time?",
    "choice_a": "Event Viewer",
    "choice_b": "Resource Monitor",
    "choice_c": "System",
    "choice_d": "Control Panel",
    "correct_answer": "B",
    "explanation": "Resource Monitor, available from the same Tools menu in Server Manager where you access Event Viewer, can track the use of the CPU, memory, disk system, and network card in real time. It has a tab for each and an Overview tab.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      229,
      186,
      173,
      162,
      163
    ],
    "source": "891437_c12"
  },
  {
    "id": 377,
    "question": "In Linux the log file that contains general and system-related messages like any you would be interested in for storage issues is located where?",
    "choice_a": "<code>/var/messages</code>",
    "choice_b": "<code>/var/log</code>",
    "choice_c": "<code>/log/messages</code>",
    "choice_d": "/<code>var/log/messages</code>",
    "correct_answer": "D",
    "explanation": "In Linux this log file is located at <code>/var/log/messages</code>.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      228,
      162,
      229,
      185,
      221
    ],
    "source": "891437_c12"
  },
  {
    "id": 378,
    "question": "With of the following is probably the most widely used fiber-optic connector?",
    "choice_a": "LC",
    "choice_b": "SC",
    "choice_c": "SFP",
    "choice_d": "ST",
    "correct_answer": "D",
    "explanation": "The straight tip (ST) fiber-optic connector, developed by AT&T, is probably the most widely used fiber-optic connector. It uses a BNC attachment mechanism that makes connections and disconnections fairly easy.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      13,
      20,
      67,
      66,
      16
    ],
    "source": "ch01"
  },
  {
    "id": 379,
    "question": "Which of the following fiber connectors is sometimes known as a square connector?",
    "choice_a": "LC",
    "choice_b": "SC",
    "choice_c": "SFP",
    "choice_d": "ST",
    "correct_answer": "B",
    "explanation": "Subscriber connectors (SC), also sometimes known as a square connector, are latched connectors, making it virtually impossible for you to pull out the connector without releasing its latch, usually by pressing a button or release.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      13,
      14,
      67,
      20,
      66
    ],
    "source": "ch01"
  },
  {
    "id": 380,
    "question": "Which of the following allow for adding functionality to a device  ?",
    "choice_a": "SLA",
    "choice_b": "MOU",
    "choice_c": "SFP",
    "choice_d": "STP",
    "correct_answer": "C",
    "explanation": "The small form-factor pluggable (SFP) allow for adding functionality to a device. For example you plug in a fiber SFP into an open SFP slot in a device and add a fiber connection where there was none.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      14,
      20,
      21,
      53,
      15
    ],
    "source": "ch01"
  },
  {
    "id": 381,
    "question": "Which of the following is used on twisted pair cabling?",
    "choice_a": "RJ-11",
    "choice_b": "RJ-45",
    "choice_c": "BNC",
    "choice_d": "ST",
    "correct_answer": "B",
    "explanation": "The connector used with UTP cable is called RJ-45. The RJ-45 has room for four pairs (eight wires).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      12,
      11,
      14,
      20,
      15
    ],
    "source": "ch01"
  },
  {
    "id": 382,
    "question": "Which of the following are used to route cable across the room?",
    "choice_a": "vertical trays",
    "choice_b": "side trays",
    "choice_c": "horizontal trays",
    "choice_d": "cross channel",
    "correct_answer": "C",
    "explanation": "Horizontal trays are used to route cable across the room either on the floor, the ceiling or anywhere in between.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      16,
      17,
      1,
      4,
      3
    ],
    "source": "ch01"
  },
  {
    "id": 383,
    "question": "Which of the following describes size, appearance or dimensions of a server?",
    "choice_a": "form factor",
    "choice_b": "outline",
    "choice_c": "footprint",
    "choice_d": "layout",
    "correct_answer": "A",
    "explanation": "When we use the term form factor we are talking about the size and dimensions of the enclosure in which the server exists.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      17,
      1,
      6,
      21,
      53
    ],
    "source": "ch01"
  },
  {
    "id": 384,
    "question": "What component allows for the server to be slid out of the rack for maintenance?",
    "choice_a": "bay rack",
    "choice_b": "rail kit",
    "choice_c": "rack tray",
    "choice_d": "service shelf",
    "correct_answer": "B",
    "explanation": "Rail kits, when implemented, allow for the server to be slid out of the rack for maintenance.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      3,
      17,
      2,
      4,
      1
    ],
    "source": "ch01"
  },
  {
    "id": 385,
    "question": "How wide is a standard sized rack?",
    "choice_a": "10 inches",
    "choice_b": "15 inches",
    "choice_c": "19 inches",
    "choice_d": "22 inches",
    "correct_answer": "C",
    "explanation": "The 19-inch rack is a standardized frame. Each module has a front panel that is 19 inches (482.6 mm) wide.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      1,
      17,
      3,
      4,
      6
    ],
    "source": "ch01"
  },
  {
    "id": 386,
    "question": "What value is used to represent the height of a rack component?",
    "choice_a": "W",
    "choice_b": "T",
    "choice_c": "H",
    "choice_d": "U",
    "correct_answer": "D",
    "explanation": "This dimension is measured in rack units or U for short. Each U is 1.75 inches (4.445 cm) high.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      1,
      17,
      3,
      16,
      53
    ],
    "source": "ch01"
  },
  {
    "id": 387,
    "question": "You have a device that is 2 U. What is its height in inches?",
    "choice_a": "3.5",
    "choice_b": "4.2",
    "choice_c": "5.1",
    "choice_d": "6.4",
    "correct_answer": "A",
    "explanation": "Each U is 1.75 inches (4.445 cm) high, so a 2 U component is 3.5 inches. .",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      1,
      17,
      3,
      2,
      4
    ],
    "source": "ch01"
  },
  {
    "id": 388,
    "question": "Which component provides the slack required when sliding the rack out while keeping the cables from blanketing the back of the rack and causing overheating?",
    "choice_a": "rack clip",
    "choice_b": "cable management arm",
    "choice_c": "cable tie",
    "choice_d": "cable tray",
    "correct_answer": "B",
    "explanation": "To provide the slack required and to keep the cables from blanketing the back of the rack and causing overheating, cable management arms are used. These arms contain the slack and are designed to follow the server when it is slid out of the bay.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      2,
      3,
      1,
      4
    ],
    "source": "ch01"
  },
  {
    "id": 389,
    "question": "Which technology consists of a server chassis housing multiple thin, modular circuit boards, each acting as a server?",
    "choice_a": "rack housing",
    "choice_b": "hard bay",
    "choice_c": "blade technology",
    "choice_d": "mother board",
    "correct_answer": "C",
    "explanation": "Each blades (or card) contains processors, memory, integrated network controllers, and other input/output (IO) ports.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      20,
      21,
      18,
      10
    ],
    "source": "ch01"
  },
  {
    "id": 390,
    "question": "Which of the following are used to direct and alter the flow of air?",
    "choice_a": "blanking panels",
    "choice_b": "hot aisle /cold aisle",
    "choice_c": "baffles",
    "choice_d": "filler panels",
    "correct_answer": "C",
    "explanation": "Another technique used both inside the case and in the server room is deploying baffles or shrouds to direct and alter the flow of air. Inside the case they are used to channel the air in the desired direction.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      1,
      6,
      53,
      17
    ],
    "source": "ch01"
  },
  {
    "id": 391,
    "question": "By default, when a log fills to its maximum size, what does it do?",
    "choice_a": "purges the log",
    "choice_b": "old entries are deleted in first in, first out (FIFO) order",
    "choice_c": "archives the log",
    "choice_d": "stops capturing events",
    "correct_answer": "B",
    "explanation": "You can set maximum log size by right-clicking on the log and choosing Properties. By default, when a log fills to its maximum size, old entries are deleted in first in, first out (FIFO) order.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      148,
      138,
      143,
      136,
      130
    ],
    "source": "ch02"
  },
  {
    "id": 392,
    "question": "Which of the following tools allows you to choose a counter for an object with granularity?",
    "choice_a": "Performance Monitor",
    "choice_b": "Resource Monitor",
    "choice_c": "Drive Optimization tool",
    "choice_d": "System Monitor",
    "correct_answer": "A",
    "explanation": "Where Performance Monitor  differs from Resource Monitor is that it allows you to choose a counter for an object with granularity. For example, perhaps you know that the CPU is working harder than usual, rather than just view the overall performance you can choose to add the % Privileged time counter.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      40,
      37,
      39,
      38,
      36
    ],
    "source": "ch02"
  },
  {
    "id": 393,
    "question": "Which of the following installation types installs  the part of the operating system shared by all Windows Server versions?",
    "choice_a": "core",
    "choice_b": "bare metal",
    "choice_c": "virtualized",
    "choice_d": "remote",
    "correct_answer": "A",
    "explanation": "Server Core has a smaller disk footprint, and therefore a smaller attack surface due to a smaller code base. There is no desktop in this system. All work is done at the command line, although here will be GUI during the installation process.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      27,
      24,
      28,
      25,
      31
    ],
    "source": "ch02"
  },
  {
    "id": 394,
    "question": "If you want the IP address of the VM to be hidden, what network setting should you use?",
    "choice_a": "NAT",
    "choice_b": "bridging",
    "choice_c": "proxy",
    "choice_d": "host",
    "correct_answer": "A",
    "explanation": "The easiest configuration is to bridge the VM to use the NIC of the host and use its own IP address. But if you want the IP address of the VM to be hidden, then using NAT will ensure that all packets coming from ether the VM or its host will appear to come from the host.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      43,
      138,
      130,
      133,
      137
    ],
    "source": "ch02"
  },
  {
    "id": 395,
    "question": "What virtual disk type is used to store changes made to an image, when you decide to keep a copy of a previous version of the image?",
    "choice_a": "differencing disk",
    "choice_b": "disk version",
    "choice_c": "versioning disk",
    "choice_d": "disk snap",
    "correct_answer": "A",
    "explanation": "This disk type is used to store changes made to an image, when you decide to keep a copy of a previous version of the image. This is what allows for the process of rolling back an image after making changes that you would like to reverse.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      32,
      46,
      30,
      44,
      36
    ],
    "source": "ch02"
  },
  {
    "id": 396,
    "question": "Which virtual disk type uses only as much datastore space as the disk initially need?",
    "choice_a": "thick provision eager zeroed",
    "choice_b": "thin provision",
    "choice_c": "thick provision lazy zeroed",
    "choice_d": "thick provision",
    "correct_answer": "B",
    "explanation": "This where the disk efficiency comes in. At first, a thin provisioned disk uses only as much datastore space as the disk initially needs. If the thin disk needs more space later, it can grow to the maximum capacity allocated to it.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      46,
      38,
      30,
      68,
      35
    ],
    "source": "ch02"
  },
  {
    "id": 397,
    "question": "With which virtual disk type is space required for the virtual disk allocated at creation time.?",
    "choice_a": "thick provision eager zeroed",
    "choice_b": "thin provision",
    "choice_c": "thick provision lazy zeroed",
    "choice_d": "fat  provision",
    "correct_answer": "C",
    "explanation": "This is analogous to the classic regular hard drive. Space required for the virtual disk is allocated at creation time. In contrast to the flat format, the data remaining on the physical device is zeroed out during creation.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      30,
      68,
      46,
      36,
      37
    ],
    "source": "ch02"
  },
  {
    "id": 398,
    "question": "Which of the following is a value that describes how fast the drive can read and write to the disk.?",
    "choice_a": "latency",
    "choice_b": "RPM",
    "choice_c": "IOP",
    "choice_d": "seek time",
    "correct_answer": "C",
    "explanation": "IOPS, or in -outs per second is a value that describes how fast the drive can read and write to the disk.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      148
    ],
    "source": "ch02"
  },
  {
    "id": 399,
    "question": "Which of the following documents describes the type of service  to be provided, in what format, in what time frame and at what cost.?",
    "choice_a": "VDI",
    "choice_b": "SLA",
    "choice_c": "IDSA",
    "choice_d": "DSA",
    "correct_answer": "B",
    "explanation": "Service levels agreements can be made with customers and they can be made with departments of the organization. These documents describe whey type of service is to be provides, in what format, in what time frame and at what cost.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      74,
      60,
      73,
      59,
      70
    ],
    "source": "ch03"
  },
  {
    "id": 400,
    "question": "Which of the following is a method for making a software program free, while requiring that all modified and extended versions of the program also be free and released under the same terms and conditions?",
    "choice_a": "permissive",
    "choice_b": "commercial",
    "choice_c": "copyleft",
    "choice_d": "closed source",
    "correct_answer": "C",
    "explanation": "There are two main types of open source licenses  , copyleft and permissive. Copyleft is a method for making a software program free, while requiring that all modified and extended versions of the program also be free and released under the same terms and conditions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      58,
      59,
      60,
      57,
      55
    ],
    "source": "ch03"
  },
  {
    "id": 401,
    "question": "Which of the following  depicts a workflow and how information involved in a single transaction or business process goes from one logical component in the network to another?",
    "choice_a": "critical path",
    "choice_b": "Gant chart",
    "choice_c": "pert chart",
    "choice_d": "dataflow diagram",
    "correct_answer": "D",
    "explanation": "While some of your network diagrams will focus on the physical pieces of the network, others will be focused on the flow of data in the network in the process of doing business.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      43,
      45,
      46,
      78,
      80
    ],
    "source": "ch03"
  },
  {
    "id": 402,
    "question": "Which of the following licensing models evolved from the software as a service (SaaS) cloud model where the software is not installed but rather is run from the cloud?",
    "choice_a": "copyleft",
    "choice_b": "subscription",
    "choice_c": "permissive",
    "choice_d": "site",
    "correct_answer": "B",
    "explanation": "While many license models are what we call perpetual with no end date, with subscription  licensing you pay by the month for as long as you want access. This model evolved from the software as a service (SaaS) cloud model where the software is not installed but rather is run from the cloud.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      58,
      55,
      59,
      57,
      60
    ],
    "source": "ch03"
  },
  {
    "id": 403,
    "question": "Which of the following is a type of SCSI that uses serial operation rather than parallel as the original SCSI did?",
    "choice_a": "SAS",
    "choice_b": "SATA",
    "choice_c": "eSATA",
    "choice_d": "SD",
    "correct_answer": "A",
    "explanation": "Serial Attached SCSI (SAS) is a type of SCSI that uses serial operation rather than parallel as the original SCSI did. There are several other ways in which it differs from parallel SCSI. A SCSI bus is a multidrop bus (one on which multiple points of attachment exist) whereas SAS uses point-to-point communication.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      66,
      67,
      62,
      61,
      64
    ],
    "source": "ch03"
  },
  {
    "id": 404,
    "question": "Which of the following is also known as disk striping?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "A",
    "explanation": "RAID 0 is also known as disk striping.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      61,
      62,
      21,
      53,
      63
    ],
    "source": "ch03"
  },
  {
    "id": 405,
    "question": "Which folder contains all the files that are required for a Windows installation?",
    "choice_a": "system32/winsxs",
    "choice_b": "windows\\winsxs",
    "choice_c": "winsxs/windows",
    "choice_d": "system32/windows",
    "correct_answer": "B",
    "explanation": "One of the things that you can do in Windows to mitigate the amount of space used by constant updates is to manage a folder called the component store. This folder, called windows\\winsxs, contains all the files that are required for a Windows installation. Any updates to those files are also held within the component store as the updates are installed. This means that over time this directory can get huge.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      68,
      24,
      29,
      25,
      27
    ],
    "source": "ch03"
  },
  {
    "id": 406,
    "question": "Which of the following guides and organizes labeling and ensures consistency?",
    "choice_a": "circuit guide",
    "choice_b": "certificate of labeling",
    "choice_c": "service plan",
    "choice_d": "naming convention",
    "correct_answer": "D",
    "explanation": "A naming system or convention guides and organizes labeling and ensures consistency. No matter what name or numbering system you use, be consistent.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      72,
      134,
      135,
      70
    ],
    "source": "ch04"
  },
  {
    "id": 407,
    "question": "Which type of drive is unaffected by magnetism?",
    "choice_a": "SSD",
    "choice_b": "HDD",
    "choice_c": "tape",
    "choice_d": "RAM drive",
    "correct_answer": "A",
    "explanation": "SSDs unlike HHDs are unaffected by magnetism, so they cannot be erased using this as you can do with an HDD.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      52,
      65,
      64,
      62,
      63
    ],
    "source": "ch04"
  },
  {
    "id": 408,
    "question": "Which of the following is used to identify HBAs?",
    "choice_a": "Mac address",
    "choice_b": "WWN",
    "choice_c": "IRQ",
    "choice_d": "DLCI",
    "correct_answer": "B",
    "explanation": "Each HBA has a unique World Wide Name (WWN), which like a MAC address uses an Organizationally Unique Identifier (OUI) assigned by the IEEE.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      67,
      13,
      14,
      15,
      66
    ],
    "source": "ch04"
  },
  {
    "id": 409,
    "question": "Which SCSI type uses point to point communication?",
    "choice_a": "SATA",
    "choice_b": "UASP",
    "choice_c": "SAS",
    "choice_d": "PATA",
    "correct_answer": "C",
    "explanation": "Serial attached SCSI is a type of SCSI that uses serial operation rather than parallel as the original SCSI did. There are several other ways in which it differs from parallel SCSI. A SCSI bus is a multidrop bus while SAS uses point to point communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      62,
      61,
      64
    ],
    "source": "ch04"
  },
  {
    "id": 410,
    "question": "Which of the following is the time it takes for the actuator arm to arrive at the proper location where the read or write will occur ?",
    "choice_a": "latency",
    "choice_b": "RPM",
    "choice_c": "IOP",
    "choice_d": "seek time",
    "correct_answer": "D",
    "explanation": "Seek time is the time it takes for the actuator arm to arrive at the proper location where the read or write will occur.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      64,
      52,
      65,
      61,
      62
    ],
    "source": "ch04"
  },
  {
    "id": 411,
    "question": "Which technology uses a interface resembles that of USB and IEEE 1394 (FireWire), but the cable cannot be as long, and the cable does not supply power to the device?",
    "choice_a": "eSATA",
    "choice_b": "SATA",
    "choice_c": "SAS",
    "choice_d": "PCI",
    "correct_answer": "A",
    "explanation": "eSATA provides a form of SATA meant for external connectivity. SATA  is used for drive connections internally on many PCs. eSATA uses a more robust connector, longer shielded cables, and stricter (but backward-compatible) electrical standards.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      66,
      67,
      52,
      64,
      65
    ],
    "source": "ch04"
  },
  {
    "id": 412,
    "question": "What is a measure of the time it takes the platter to spin the disk around so the actuator arm is over the proper section.?",
    "choice_a": "latency",
    "choice_b": "RPM",
    "choice_c": "IOP",
    "choice_d": "seek time",
    "correct_answer": "A",
    "explanation": "Latency is a measure of the time it takes the platter to spin the disk around so the actuator arm is over the proper section. Latency is largely a function of the RPMs as a faster spinning disk will arrive at the desired location faster than a slower disk.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      64,
      52,
      61,
      62,
      66
    ],
    "source": "ch04"
  },
  {
    "id": 413,
    "question": "What is the most common form factor for laptop hard drives?",
    "choice_a": "2.5 inch",
    "choice_b": "3.0 inch",
    "choice_c": "3.25 inch",
    "choice_d": "3.5 inch",
    "correct_answer": "D",
    "explanation": "The two most common are the 2.5 inch small form factor (SFF) for laptops and the 3.5 large form factor (LFF) for desktops.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      64,
      52,
      65,
      53,
      62
    ],
    "source": "ch04"
  },
  {
    "id": 414,
    "question": "Which bus type has a maximum cable length of 3 feet?",
    "choice_a": "SATA",
    "choice_b": "SCSI",
    "choice_c": "Fiber channel",
    "choice_d": "SAS",
    "correct_answer": "A",
    "explanation": "Serial ATA cables can be up to 3 feet.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      66,
      67,
      62,
      64,
      61
    ],
    "source": "ch04"
  },
  {
    "id": 415,
    "question": "Which bus type is the fastest?",
    "choice_a": "SATA",
    "choice_b": "SCSI",
    "choice_c": "Fiber channel",
    "choice_d": "SAS",
    "correct_answer": "C",
    "explanation": "While fiber channel is the fastest it is also the most costly.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      67,
      14,
      13,
      52,
      21
    ],
    "source": "ch04"
  },
  {
    "id": 416,
    "question": "How much space is usable  with a 3 500 GB disks in a RAID 5 array?",
    "choice_a": "250 GB",
    "choice_b": "500 GB",
    "choice_c": "750 GB",
    "choice_d": "1000 GB",
    "correct_answer": "D",
    "explanation": "With 3 disks the partly information consumes a third of the total space of 1500 GB.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      61,
      21,
      62,
      64,
      53
    ],
    "source": "ch04"
  },
  {
    "id": 417,
    "question": "Which RAID method consumes the most space for redundancy?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "B",
    "explanation": "RAID 1 uses half the disk space for redundancy.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      61,
      62,
      21,
      63,
      52
    ],
    "source": "ch04"
  },
  {
    "id": 418,
    "question": "With which if the following are striped sets  mirrored?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "D",
    "explanation": "RAID 10 is also known as RAID 1+0. Striped sets are mirrored (a minimum of four drives, and the number of drives must be even).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      61,
      62,
      21,
      52,
      63
    ],
    "source": "ch04"
  },
  {
    "id": 419,
    "question": "Which clustering scheme comes with the cost of having a server sitting idle until a failure occurs?",
    "choice_a": "active/sleeping",
    "choice_b": "active/active",
    "choice_c": "passive/passive",
    "choice_d": "active/passive",
    "correct_answer": "D",
    "explanation": "In an active/passive cluster at least one of the servers in the cluster is not actively working but simply sitting idle until a failure occurs.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      78,
      79,
      81,
      84,
      34
    ],
    "source": "ch05"
  },
  {
    "id": 420,
    "question": "Which load balancer setting allocates work requests to each server sequentially?",
    "choice_a": "n+m",
    "choice_b": "circular",
    "choice_c": "round robin",
    "choice_d": "communal",
    "correct_answer": "C",
    "explanation": "In a round robin allocation system, the load balancer allocates work requests to each server sequentially, resulting in each getting an equal number of requests.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      81,
      80,
      78,
      83,
      84
    ],
    "source": "ch05"
  },
  {
    "id": 421,
    "question": "What is a connection between servers in a load balancing scenario called?",
    "choice_a": "magic packet",
    "choice_b": "heartbeat connection",
    "choice_c": "trunk",
    "choice_d": "load monitor",
    "correct_answer": "B",
    "explanation": "A heartbeat connection is a  connection between servers in a load balancing scenario that the servers use to send a heartbeat signal back and forth  that the server use to determine when the other server is down.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      79,
      78,
      81,
      80,
      84
    ],
    "source": "ch05"
  },
  {
    "id": 422,
    "question": "Which of the following  is a term that describes when a system fails and the workload is transferred to the backup system?",
    "choice_a": "failover",
    "choice_b": "copyleft",
    "choice_c": "failback",
    "choice_d": "assumption",
    "correct_answer": "A",
    "explanation": "Failover is a term that describes when a system fails and the workload is transferred to the backup system. Failback is a term that describes  when the original system  goes back online and the workload is moved  back to the original  system.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      78,
      79,
      84,
      45,
      44
    ],
    "source": "ch05"
  },
  {
    "id": 423,
    "question": "Whichof the following usedx is a frontend device or service to receive work requests and allocate the requests to a number of backend servers. ?",
    "choice_a": "clustering",
    "choice_b": "RAID",
    "choice_c": "load balancing",
    "choice_d": "duplexing",
    "correct_answer": "C",
    "explanation": "This type of fault tolerance is recommended for applications that do not have long-running in-memory state or frequently updated data. Web servers are good candidates for load balancing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      81,
      80,
      78,
      82,
      36
    ],
    "source": "ch05"
  },
  {
    "id": 424,
    "question": "Which of the following is the use of separate controller cards for each disk?",
    "choice_a": "duplexing",
    "choice_b": "multi-channel",
    "choice_c": "overloading",
    "choice_d": "isolation",
    "correct_answer": "A",
    "explanation": "Disk duplexing is the use of separate controller cards for each disk when implementing disk mirroring (RAID 1), thus providing fault tolerance at both the disk level and at the disk controller level, protecting against both a single disk failure and a single controller card failure.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      80,
      30,
      78,
      82,
      79
    ],
    "source": "ch05"
  },
  {
    "id": 425,
    "question": "Which workload allocation method attempts to send clients into running servers, preferably the most recently used server before starting new servers?",
    "choice_a": "round robin",
    "choice_b": "MRU",
    "choice_c": "link aggregation",
    "choice_d": "least used",
    "correct_answer": "B",
    "explanation": "The Most Recently Used algorithm attempts to send clients into running servers, preferably the most recently used server before starting new servers. The goal of this algorithm is to reduce the overhead of starting new servers by using servers that are already running.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      81,
      78,
      79,
      40,
      38
    ],
    "source": "ch05"
  },
  {
    "id": 426,
    "question": "Optical media should be stored at what  humidity?",
    "choice_a": "45 to 55  %.",
    "choice_b": "20 to 40 %.",
    "choice_c": "40 to 60 %.",
    "choice_d": "10 to 30 %.",
    "correct_answer": "A",
    "explanation": "The humidity should be 45 to 55 %. This media should be kept out of direct sunlight, although the effect on some variants of optical media (disk that are read/write) is minimal.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      89,
      114,
      155,
      152,
      153
    ],
    "source": "ch06"
  },
  {
    "id": 427,
    "question": "Which of the following  are short vertical posts placed at the building\u2019s entrance way and lining sidewalks that help to provide protection from vehicles that might either intentionally or unintentionally crash into or enter the building or injure pedestrians?",
    "choice_a": "blanking panels",
    "choice_b": "bollards",
    "choice_c": "baffles",
    "choice_d": "mantraps",
    "correct_answer": "B",
    "explanation": "Barriers called bollards have become quite common around the perimeter of new office and government buildings.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      85,
      87,
      90,
      91,
      98
    ],
    "source": "ch06"
  },
  {
    "id": 428,
    "question": "What is the purpose of a hot aisle and cold aisle arrangement?",
    "choice_a": "better performance",
    "choice_b": "removing hot air",
    "choice_c": "enhanced security",
    "choice_d": "humidity control",
    "correct_answer": "B",
    "explanation": "A common way to ensure that the hot is removed and cool air introduced properly is to establish   the racks in a hot aisle and cold aisle arrangement Hot air is vented upward and then out of the room .on the hot aisles and cold air is introduced from the floor and vented into the backs of the same racks that just vented hot air upward.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      89,
      110,
      126,
      155,
      97
    ],
    "source": "ch06"
  },
  {
    "id": 429,
    "question": "Which of the following attaches to the top of racks and cabinets for improved air flow?",
    "choice_a": "blanking panels",
    "choice_b": "hot aisle /cold aisle",
    "choice_c": "baffles",
    "choice_d": "slot covers",
    "correct_answer": "C",
    "explanation": "They are typically used when the air on one side of the row of racks needs to be channeled a certain way. In a hot aisle /cold aisle arrangement (covered in the next section more fully) these baffles usually are used on the hot aisle to prevent the hot air from recirculating back ingot the hot aisle.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      91,
      109,
      86,
      85,
      126
    ],
    "source": "ch06"
  },
  {
    "id": 430,
    "question": "Environmental controls are used  to satisfy which  part of the CIA triad?",
    "choice_a": "authenticity",
    "choice_b": "availability",
    "choice_c": "confidentiality",
    "choice_d": "integrity",
    "correct_answer": "B",
    "explanation": "It is the goal of availability that maintaining proper environmental control serves. When proper environmental practices are not in place, servers lock up, shut down, and suffer any number of ailments that make them unable to perform their role or make their resources available.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      89,
      158,
      159,
      160,
      149
    ],
    "source": "ch06"
  },
  {
    "id": 431,
    "question": "Which  humidity level is recommended for optimal performance and reliability in the data center ?",
    "choice_a": "between 45% and 55%",
    "choice_b": "between 35% and 65%",
    "choice_c": "between 45% and 57%",
    "choice_d": "between 25% and 45%",
    "correct_answer": "A",
    "explanation": "A humidity level between 45% and 55% is recommended for optimal performance and reliability. When the level is too high, it causes condensation which is bad news for any electronics and when it is too low, the dry air is conducive to ESD.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      89,
      88,
      91,
      114,
      95
    ],
    "source": "ch06"
  },
  {
    "id": 432,
    "question": "What  ambient temperature range is optimal for system reliability ?",
    "choice_a": "68\u00b0 to 75\u00b0F",
    "choice_b": "58\u00b0 to 65\u00b0F",
    "choice_c": "78\u00b0 to 85\u00b0F",
    "choice_d": "48\u00b0 to 65\u00b0F",
    "correct_answer": "A",
    "explanation": "Maintaining an ambient temperature range of 68\u00b0 to 75\u00b0F (20\u00b0 to 24\u00b0C) is optimal for system reliability. When temperatures rise bad things start to occur such as server rebooting.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      89,
      95,
      93,
      104,
      107
    ],
    "source": "ch06"
  },
  {
    "id": 433,
    "question": "With of the following are programs that enter a system or network under the guise of another program.?",
    "choice_a": "virus",
    "choice_b": "worm",
    "choice_c": "trojan",
    "choice_d": "ransomware",
    "correct_answer": "C",
    "explanation": "A Trojan horse may be included as an attachment or as part of an installation program. The Trojan horse can create a back door or replace a valid program during installation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      93,
      102,
      104,
      94,
      98
    ],
    "source": "ch06"
  },
  {
    "id": 434,
    "question": "Which of the following apply only when a user is accessing a file or folder through the network.?",
    "choice_a": "NTFS permissions",
    "choice_b": "share permissions",
    "choice_c": "system permissions",
    "choice_d": "remote permissions",
    "correct_answer": "B",
    "explanation": "Share permissions apply only when a user is accessing a file or folder through the network.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      120,
      119,
      118,
      117,
      121
    ],
    "source": "ch07"
  },
  {
    "id": 435,
    "question": "What does the following refer to designing the facility from the ground up to support security?",
    "choice_a": "SID",
    "choice_b": "DSI",
    "choice_c": "CPTED",
    "choice_d": "ESF",
    "correct_answer": "C",
    "explanation": "Crime Prevention Through Environmental Design (CPTED) refers to designing the facility from the ground up to support security. It is actually a broad concept that can be applied to any project (housing developments, office buildings, and retail establishments).",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      85,
      90,
      89,
      109,
      106
    ],
    "source": "ch07"
  },
  {
    "id": 436,
    "question": "Which of the following is used to block emissions coming from the servers themselves that can sometimes disclose sensitive information?",
    "choice_a": "bollard",
    "choice_b": "faraday cage",
    "choice_c": "mantrap",
    "choice_d": "reflective  glass",
    "correct_answer": "B",
    "explanation": "There are  emissions coming from the servers themselves that can sometimes disclose sensitive information. This can be addressed by placing the server inside enclosures that can block signals. One example is called a Faraday cage, which implements an outer barrier or coating  called a Faraday Shield.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      92,
      90,
      89,
      88,
      109
    ],
    "source": "ch07"
  },
  {
    "id": 437,
    "question": "Which of the following involves applying a strong magnetic field to initialize the media?",
    "choice_a": "incinerating",
    "choice_b": "zeroing out",
    "choice_c": "degaussing",
    "choice_d": "shredding",
    "correct_answer": "C",
    "explanation": "Since degaussing uses a specifically designed electromagnet to eliminate all data on the drive, that destruction also includes the factory prerecorded servo tracks.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      126,
      115,
      101,
      116
    ],
    "source": "ch07"
  },
  {
    "id": 438,
    "question": "Which of the following describes any deletion process that cannot be reversed using data recovery or forensics software?",
    "choice_a": "safe wipe",
    "choice_b": "clear wipe",
    "choice_c": "soft wipe",
    "choice_d": "hard wipe",
    "correct_answer": "D",
    "explanation": "A hard weep is a term used to describe any deletion process that cannot be reversed using data recovery or forensics software. Most disk management software will provide this type of deletion and may call is various marketing names such as \u201cscrubbing\u201d the drive.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      115,
      101,
      97,
      155
    ],
    "source": "ch07"
  },
  {
    "id": 439,
    "question": "Which version of the LTO standard supports encryption?",
    "choice_a": "4",
    "choice_b": "5",
    "choice_c": "6",
    "choice_d": "7",
    "correct_answer": "A",
    "explanation": "Starting with version 4 of the Linear Tape Open tape standard (LTO-4) encryption is a supported feature.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      152,
      112,
      111,
      149,
      157
    ],
    "source": "ch07"
  },
  {
    "id": 440,
    "question": "Which of the following is true with respect to tape encryption?",
    "choice_a": "perform compression prior to performing encryption.",
    "choice_b": "perform encryption  prior to performing compression.",
    "choice_c": "perform compression  and encryption simultaneously",
    "choice_d": "neither encrypt nor compress the tape.",
    "correct_answer": "A",
    "explanation": "Choose a product that will perform compression prior to performing encryption. Otherwise the tape will not compress because encryption effectively scrambles the data, removing the redundancy that compression algorithms rely on.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      112,
      152,
      151,
      157,
      150
    ],
    "source": "ch07"
  },
  {
    "id": 441,
    "question": "With of the following is a chip is located on the motherboard of the system and provides password protection, digital rights management (DRM), and full disk encryption ?",
    "choice_a": "DPP chip",
    "choice_b": "TPM chip",
    "choice_c": "BitLocker",
    "choice_d": "TrueCrypt",
    "correct_answer": "B",
    "explanation": "A Trusted Platform Module (TPM) chip protects the keys used to encrypt the computer's hard disks and provide integrity authentication for a trusted boot pathway.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      112,
      109,
      111,
      119,
      104
    ],
    "source": "ch07"
  },
  {
    "id": 442,
    "question": "Which of the following are logical subdivisions of a switch that segregate ports from one another as if they were in different LANs?",
    "choice_a": "VLANs",
    "choice_b": "VPNs",
    "choice_c": "collision domains",
    "choice_d": "realms",
    "correct_answer": "A",
    "explanation": "VLANs offer another way to add a layer of separation between sensitive devices and the rest of the network. For example, if only one device should be able to connect to the Finance server, the device and the Finance server could be placed in a VLAN separate from the other VLANs. As traffic between VLANs can only occur through a router, access control lists (ACLs) can be used to control the traffic allowed between VLANs.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      131,
      132,
      84,
      140,
      43
    ],
    "source": "ch08"
  },
  {
    "id": 443,
    "question": "Which of the following is true of VLANs?",
    "choice_a": "switched networks with VLANs are more costly than routed networks",
    "choice_b": "by creating larger broadcast domains performance improves.",
    "choice_c": "removes the requirement that devices in the same LAN be in the same location.",
    "choice_d": "provides separation at Layers 3",
    "correct_answer": "C",
    "explanation": "The following are all true of VLANs:<ul><li>Switched networks with VLANs are less costly than routed networks because routers cost more than switches.</li><li>By creating smaller broadcast domains (each VLAN is a broadcast domain), performance improves.</li><li>Removes the requirement that devices in the same LAN ( or in this case, VLAN) be in the same location.</li><li>Provides one more layer of separation at Layers 2 and 3.</li></ul>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      131,
      137,
      84,
      141,
      142
    ],
    "source": "ch08"
  },
  {
    "id": 444,
    "question": "Which of the following is an attack  whose \u2019s aim is to receive traffic from a VLAN of which the hacker\u2019s port is not a member?",
    "choice_a": "SYN flood",
    "choice_b": "VLAN hopping",
    "choice_c": "Teardrop",
    "choice_d": "Land",
    "correct_answer": "B",
    "explanation": "A VLAN hopping attack\u2019s aim is to receive traffic from a VLAN of which the hacker\u2019s port is not a member. It can be done two ways switch spoofing and double tagging.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      131,
      139,
      140,
      132,
      130
    ],
    "source": "ch08"
  },
  {
    "id": 445,
    "question": "Which service performs  name resolution?",
    "choice_a": "ARP",
    "choice_b": "DNS",
    "choice_c": "UDP",
    "choice_d": "HTTP",
    "correct_answer": "B",
    "explanation": "Name resolution services resolve device and domain names (website names) to IP addresses, and vice versa. They make it possible to connect to either without knowing the IP address of the device or the server hosting the website. Domain name service (DNS) servers perform name resolution.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      133,
      135,
      141,
      134,
      130
    ],
    "source": "ch08"
  },
  {
    "id": 446,
    "question": "In the example FQDN tmcmillan.atlanta.acme.com, which part is he domaij name?",
    "choice_a": "tmcmillan",
    "choice_b": "atlanta",
    "choice_c": "acme",
    "choice_d": ".com",
    "correct_answer": "C",
    "explanation": "If the DNS namespace of the organization is subdivided into subdomains, it could have a subdomain section as well. In the example tmcmillan.atlanta.acme.com, tmcmillan is the hostname, atlanta identifies the subdomain, and acme.com is the domain name.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      133,
      135,
      141,
      142
    ],
    "source": "ch08"
  },
  {
    "id": 447,
    "question": "Which FQDN is fully qualified?",
    "choice_a": "tmcmillan",
    "choice_b": "tmcmillan.atlanta",
    "choice_c": "ssmith.axme.tuscon",
    "choice_d": "trisk.atlanta.georgia.com",
    "correct_answer": "D",
    "explanation": "While trisk.atlanta.georgia.com describes a FQDN, if we just consider the hostname portion, tmcmillan without the domain name ( and the required.com. .mil or .org etc)) , we would call the name unqualified because it is lacking information that fully qualifies or describes its location in the DNS namespace.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      134,
      133,
      135,
      141,
      142
    ],
    "source": "ch08"
  },
  {
    "id": 448,
    "question": "With of the following is the most important resource for a DNS server?",
    "choice_a": "memory",
    "choice_b": "disk",
    "choice_c": "CPU",
    "choice_d": "network card",
    "correct_answer": "A",
    "explanation": "Memory is the most important resource because the entire DNS zone file will be loaded into memory. As you add zones, or as a zone gets larger, you should add memory. If you expect the server to be answering large numbers of queries concurrently, then that will require additional memory as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      133,
      37,
      34,
      36,
      35
    ],
    "source": "ch08"
  },
  {
    "id": 449,
    "question": "Which of the following is a full backup performed by synthesizing the data from the previous full backup (either a regular full backup for the first backup, or the previous synthetic full backup) and the periodic incremental backups?",
    "choice_a": "synthetic full",
    "choice_b": "incremental",
    "choice_c": "copy",
    "choice_d": "differential",
    "correct_answer": "A",
    "explanation": "A synthetic backup is a full backup performed by synthesizing the data from the previous full backup (either a regular full backup for the first backup, or the previous synthetic full backup) and the periodic incremental backups. The incremental backups are the only files that need to be transferred during replication, greatly reducing the bandwidth needed for offsite replication.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      150,
      149,
      159,
      153,
      155
    ],
    "source": "ch09"
  },
  {
    "id": 450,
    "question": "In which type of backup are all files that have been changed since the last full backup will be backed up?",
    "choice_a": "synthetic full",
    "choice_b": "incremental",
    "choice_c": "copy",
    "choice_d": "differential",
    "correct_answer": "D",
    "explanation": "During the differential backup process, the archive bit for each file is not cleared. Each differential backup will back up all the files in the previous differential backup if a full backup has not occurred since that time. In an organization that uses a full/differential scheme, the full and only the most recent differential backup must be re-stored, meaning only two backups are needed to perform a restoration.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      149,
      151,
      157,
      155,
      154
    ],
    "source": "ch09"
  },
  {
    "id": 451,
    "question": "In which media rotation scheme is  the newest backup is saved to the oldest media?",
    "choice_a": "tower of Hanoi",
    "choice_b": "GFS",
    "choice_c": "FIFO",
    "choice_d": "LIFO",
    "correct_answer": "C",
    "explanation": "In this scheme, the newest backup is saved to the oldest media. Although this is the simplest rotation scheme, it does not protect against data errors. If an error in data occurs, this system over time may result in all copies containing the error.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      151,
      157,
      149,
      155,
      95
    ],
    "source": "ch09"
  },
  {
    "id": 452,
    "question": "In which of the following are three sets of backups are defined. ?",
    "choice_a": "GFS",
    "choice_b": "FIFO",
    "choice_c": "LIFO",
    "choice_d": "Tower of Hanoi",
    "correct_answer": "A",
    "explanation": "In the Grandfather/father/son (GFS) scheme, three sets of backups are defined. Most often these three definitions are daily, weekly, and monthly. The daily backups are the sons, the weekly backups are the fathers, and the monthly backups are the grandfathers. Each week, one son advances to the father set. Each month, one father advances to the grandfather set.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      151,
      149,
      150,
      152,
      129
    ],
    "source": "ch09"
  },
  {
    "id": 453,
    "question": "Which of the following helps to ensure the integrity of a backup?",
    "choice_a": "checksums",
    "choice_b": "CRC",
    "choice_c": "FCS",
    "choice_d": "ECC",
    "correct_answer": "A",
    "explanation": "If you create the backup using checksums (which is an option with many utilities) it will allow you to check that the data has not changed since it was made or that it has been corrupted or damaged.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      155,
      95,
      151,
      152,
      150
    ],
    "source": "ch09"
  },
  {
    "id": 454,
    "question": "With of the following does NOT provide random access?",
    "choice_a": "CD",
    "choice_b": "flash drive",
    "choice_c": "Tape",
    "choice_d": "hard drive",
    "correct_answer": "C",
    "explanation": "Tapes cannot provide instant access (also called random access) to any location on the tape (as can be done with CDs, DVDs, and external drives. They provide linear access to the data.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      152,
      153,
      149,
      157,
      151
    ],
    "source": "ch09"
  },
  {
    "id": 455,
    "question": "Which of the following is the first step in the CompTIA troubleshooting methodology?",
    "choice_a": "Implement the solution or escalate",
    "choice_b": "Test the theory to determine the cause",
    "choice_c": "Establish a theory of probable cause (question the obvious)",
    "choice_d": "Identify the problem and determine the scope",
    "correct_answer": "D",
    "explanation": "The steps in order are as follows:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      162,
      163,
      164,
      165,
      166
    ],
    "source": "ch10"
  },
  {
    "id": 456,
    "question": "Which of the following is a  technology is built into most drives to determine if the device is still physically healthy or failing due to hardware issues?",
    "choice_a": "SMART",
    "choice_b": "ILO",
    "choice_c": "GRUB",
    "choice_d": "SAS",
    "correct_answer": "A",
    "explanation": "Some issues will issue a warning that a failure is in the future. An example of such a device is a hard drive that has support for Monitoring, Analysis and Reporting Technology (SMART) . This technology is built into most drives to determine if the device is still physically healthy or failing due to hardware issues.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      167,
      216,
      171,
      222,
      224
    ],
    "source": "ch10"
  },
  {
    "id": 457,
    "question": "Which of the following is the final step in the CompTIA troubleshooting methodology?",
    "choice_a": "Implement the solution or escalate",
    "choice_b": "Document findings, actions, and out-comes throughout the process",
    "choice_c": "Establish a theory of probable cause (question the obvious)",
    "choice_d": "Identify the problem and determine the scope",
    "correct_answer": "B",
    "explanation": "The steps in order are as follows:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      164,
      163,
      162,
      165,
      166
    ],
    "source": "ch10"
  },
  {
    "id": 458,
    "question": "Which of the following tools  is a collection of software tools that automates the process of installing, upgrading, configuring, and removing computer programs for a computer in a consistent manner?",
    "choice_a": "Diskfrag",
    "choice_b": "Drivefrag",
    "choice_c": "Package management system",
    "choice_d": "Data organizer",
    "correct_answer": "C",
    "explanation": "A package-management system is a collection of software tools that automates the process of installing, upgrading, configuring, and removing computer programs for a computer in a consistent manner. These tools can make managing updates much easier. There are third party tools but one of the most well know systems comes free with Windows as a server role.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      191,
      229,
      228,
      226,
      164
    ],
    "source": "ch10"
  },
  {
    "id": 459,
    "question": "Which of the following is the second step in the CompTIA troubleshooting methodology?",
    "choice_a": "Implement the solution or escalate",
    "choice_b": "Document findings, actions, and out-comes throughout the process",
    "choice_c": "Establish a theory of probable cause (question the obvious)",
    "choice_d": "Identify the problem and determine the scope",
    "correct_answer": "C",
    "explanation": "The steps in order are as follows:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      163,
      162,
      165,
      166,
      164
    ],
    "source": "ch10"
  },
  {
    "id": 460,
    "question": "Which of the following is one of the most dangerous risks associated with working with computers?",
    "choice_a": "excessive lifting",
    "choice_b": "ESD",
    "choice_c": "burns",
    "choice_d": "cuts on cases",
    "correct_answer": "B",
    "explanation": "Electrostatic discharge (ESD) is one of the most dangerous risks associated with working with computers. Not only does ESD have the potential to damage components of the computer, but it can also injure you. Not understanding the proper way to avoid it could cause you great harm.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      177,
      176,
      162,
      163,
      164
    ],
    "source": "ch10"
  },
  {
    "id": 461,
    "question": "Which of the following is the seventh step in the CompTIA troubleshooting methodology?",
    "choice_a": "Implement the solution or escalate",
    "choice_b": "Document findings, actions, and out-comes throughout the process",
    "choice_c": "Perform a root cause analysis",
    "choice_d": "Identify the problem and determine the scope",
    "correct_answer": "C",
    "explanation": "The steps in order are as follows:<ul><li>Identify the problem and determine the scope.</li><li>Establish a theory of probable cause.</li><li>Test the theory to determine the cause.</li><li>Establish a plan of action to resolve the problem and notify impacted users.</li><li>Implement the solution or escalate as appropriate.</li><li>Verify full system functionality and, if applicable, implement preventive measures.</li><li>Perform a root cause analysis.</li><li>Document findings, actions, and outcomes throughout the process.</li></ul>",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      164,
      163,
      162,
      166,
      165
    ],
    "source": "ch10"
  },
  {
    "id": 462,
    "question": "Which of the following is a Windows command line utility that can be used to view and alter the encryption of files on an NTFS partition?",
    "choice_a": "diskpart",
    "choice_b": "cipher",
    "choice_c": "rdisk",
    "choice_d": "discman",
    "correct_answer": "B",
    "explanation": "Cipher is a Windows command line utility that can be used to view and alter the encryption of files on an NTFS partition. Run with no parameters it will display the encryption state of current folder and any file contained within.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      183,
      226,
      221,
      185,
      228
    ],
    "source": "ch11"
  },
  {
    "id": 463,
    "question": "Which of the following is one of the most widely used sniffers?",
    "choice_a": "zone alarm",
    "choice_b": "wire shark",
    "choice_c": "net dog",
    "choice_d": "packet cap",
    "correct_answer": "B",
    "explanation": "One of the most widely used sniffers is Wireshark. It captures raw packets off the interface on which it is configured and allows you to examine each packet.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      200,
      213,
      195,
      197,
      212
    ],
    "source": "ch11"
  },
  {
    "id": 464,
    "question": "Which if the following is the process of capturing packets for analysis?",
    "choice_a": "sniffing",
    "choice_b": "scooping",
    "choice_c": "baselining",
    "choice_d": "mapping",
    "correct_answer": "A",
    "explanation": "Sniffing is the process of capturing packets for analysis; sniffing used maliciously is referred to as eavesdropping.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      213,
      212,
      214,
      215,
      199
    ],
    "source": "ch11"
  },
  {
    "id": 465,
    "question": "Which of the following is used for port scans?",
    "choice_a": "portping",
    "choice_b": "pathping",
    "choice_c": "nmap",
    "choice_d": "metasploit",
    "correct_answer": "C",
    "explanation": "One of the most widely used port scanners is Network Mapper (Nmap), a free and open source utility for network discovery and security auditing.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      204,
      203,
      213,
      195,
      206
    ],
    "source": "ch11"
  },
  {
    "id": 466,
    "question": "Which of the following tools lets you shut down nonresponsive applications selectively in all Windows versions?",
    "choice_a": "Performance Monitor",
    "choice_b": "Task manager",
    "choice_c": "Drive Optimization tool",
    "choice_d": "System Monitor",
    "correct_answer": "B",
    "explanation": "Task Manager lets you shut down nonresponsive applications selectively in all Windows versions.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      173,
      186,
      229,
      162,
      163
    ],
    "source": "ch11"
  },
  {
    "id": 467,
    "question": "Which of the following commands is used to view the ARP cache where the MAC address\u2013to\u2013IP address mapping?",
    "choice_a": "arp-d",
    "choice_b": "ipconfig",
    "choice_c": "net use",
    "choice_d": "net share",
    "correct_answer": "A",
    "explanation": "You can use the arp-a command to view the ARP cache where the MAC address\u2013to\u2013IP address mappings are located.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      203,
      204,
      195,
      196,
      197
    ],
    "source": "ch11"
  },
  {
    "id": 468,
    "question": "Which if the following commands is used to show the Resultant Set of Policy (RSoP) report/values for a remote user and computer?",
    "choice_a": "pdisk",
    "choice_b": "policyres",
    "choice_c": "gpresult",
    "choice_d": "gpscan",
    "correct_answer": "C",
    "explanation": "Fortunately, there is a tool that can help identity the reason why a particular policy is not being applied to a device or user. The GPRESULT command is used to show the Resultant Set of Policy (RSoP) report/values for a remote user and computer order.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      182,
      163,
      162,
      192,
      203
    ],
    "source": "ch11"
  },
  {
    "id": 469,
    "question": "Which of the following tools is used to defragment a drive?",
    "choice_a": "Diskfrag",
    "choice_b": "Drivefrag",
    "choice_c": "Drive Optimization tool",
    "choice_d": "Data organizer",
    "correct_answer": "C",
    "explanation": "You can analyze the drive and the degree of fragmentation will be determined or you choose to select Optimize and start the defragmentation process without analyzing. You can also make schedules so that this occurs automatically.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      222,
      226,
      221,
      217,
      224
    ],
    "source": "ch12"
  },
  {
    "id": 470,
    "question": "Which if the following is the only type of partition that can be split in Windows?",
    "choice_a": "formatted with FAT32",
    "choice_b": "formatted with FAT",
    "choice_c": "formatted with NTFS",
    "choice_d": "formatted with NFS",
    "correct_answer": "C",
    "explanation": "Optical media should be stored at a temperature between 41 and 68 You can only shrink basic volumes that use the NTFS filesystem (and space exists) or that do not have a filesystem.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      221,
      217,
      183,
      223,
      224
    ],
    "source": "ch12"
  },
  {
    "id": 471,
    "question": "Which if the following makes  a drive available to the disk management system and in most cases the drive will not show up until you do this?",
    "choice_a": "formatting",
    "choice_b": "Initializing",
    "choice_c": "aligning",
    "choice_d": "mapping",
    "correct_answer": "B",
    "explanation": "Once the drive has been connected or installed, this should be done. Initializing the drive can be done at the command using diskpart or in the Disk Management tooll.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      226,
      221,
      217,
      223,
      224
    ],
    "source": "ch12"
  },
  {
    "id": 472,
    "question": "Which of the following is a command-line disk management utility in Windows?",
    "choice_a": "diskpart",
    "choice_b": "bootrec",
    "choice_c": "rdisk",
    "choice_d": "discman",
    "correct_answer": "A",
    "explanation": "Diskpart is command-line disk management utility in Windows. It enables you to manage objects (disks, partitions, or volumes) by using scripts or direct input at a command prompt.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      226,
      217,
      221,
      229,
      224
    ],
    "source": "ch12"
  },
  {
    "id": 473,
    "question": "Which of the following is true with regard to cables?",
    "choice_a": "The smaller the allowable bend radius, the greater is the material flexibility.",
    "choice_b": "The greater the allowable bend radius, the greater is the material flexibility.",
    "choice_c": "The smaller the allowable bend radius, the smaller is the material flexibility.",
    "choice_d": "The greater the allowable bend radius, the smaller is the material flexibility.",
    "correct_answer": "C",
    "explanation": "The smaller the allowable bend radius, the greater is the material flexibility. If you exceed the recommended bend radius this you will damage the cable.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      205,
      197,
      176,
      177,
      180
    ],
    "source": "ch12"
  },
  {
    "id": 474,
    "question": "What is the most common ratio used for read and write cache on  RAID controller?",
    "choice_a": "50:50",
    "choice_b": "60:40",
    "choice_c": "75:25",
    "choice_d": "25:75",
    "correct_answer": "C",
    "explanation": "This memory can be configured into two caches, a read cache and a write cache. A common ratio used for the two is 75:25 write: read.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      218,
      227,
      225,
      220,
      222
    ],
    "source": "ch12"
  },
  {
    "id": 475,
    "question": "In Linux the log file that contains general and system related messages such as you would be interested in for storage issues is located where?",
    "choice_a": "/var/messages",
    "choice_b": "/log/messages",
    "choice_c": "/var/log",
    "choice_d": "/var/log/messages",
    "correct_answer": "D",
    "explanation": "In Linux the log file that contains general and system related messages such as you would be interested in for storage issues is located at:<code>/var/log/messages</code>.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      162,
      228,
      229,
      223,
      221
    ],
    "source": "ch12"
  },
  {
    "id": 476,
    "question": "Which of the following are files located on the hard drive that are utilized temporarily to hold items moved from memory when there is a shortage of memory required for a particular function.?",
    "choice_a": "swap files",
    "choice_b": "storage spaces",
    "choice_c": "hard pages",
    "choice_d": "paging drives",
    "correct_answer": "A",
    "explanation": "Swap are files located on the hard drive that are utilized temporarily to hold items moved from memory when there is a shortage of memory required for a particular function. The running programs believe that their information is still in RAM, but the OS has moved the data to the hard drive.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      220,
      170,
      222,
      189,
      168
    ],
    "source": "ch12"
  },
  {
    "id": 477,
    "question": "Which of the following will wipe out the drive?",
    "choice_a": "initializing",
    "choice_b": "mounting",
    "choice_c": "defragmenting",
    "choice_d": "driver mapping",
    "correct_answer": "A",
    "explanation": "Initializing the drive can be done at the command using diskpart or in the Disk Management tool. You need to know that initialization will wipe out the drive!",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      226,
      221,
      217,
      224,
      222
    ],
    "source": "ch12"
  },
  {
    "id": 478,
    "question": "Which of the following is  the tool used on Linux to manage partitions?",
    "choice_a": "fdisk",
    "choice_b": "diskpart",
    "choice_c": "nmap",
    "choice_d": "drivemap",
    "correct_answer": "A",
    "explanation": "While the fsidk command is no longer used in Windows Server 2012 R2, it is still the tool used on Linux to manage partitions.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      224,
      226,
      221,
      217,
      162
    ],
    "source": "ch12"
  },
  {
    "id": 479,
    "question": "Backplanes constructed with slots on both sides and are located in the middle of the enclosure and are called?",
    "choice_a": "subplane",
    "choice_b": "biplane",
    "choice_c": "midplane",
    "choice_d": "dual plan",
    "correct_answer": "C",
    "explanation": ".Some backplanes are constructed with slots on both sides and in that case they are located in the middle of the enclosure and are called midplanes. They can also host drives as well as servers in storage devices.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      180,
      174,
      175,
      176,
      218
    ],
    "source": "ch12"
  },
  {
    "id": 480,
    "question": "A size mismatch between drives will result in what?",
    "choice_a": "decreased performance",
    "choice_b": "more drive failures",
    "choice_c": "wasted drive space",
    "choice_d": "lower security",
    "correct_answer": "C",
    "explanation": "A size mismatch will simply mean that the largest volume on any drive can be no larger than the smallest drive in the array. That results in some wasted drive space.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      226,
      218,
      162,
      163,
      178
    ],
    "source": "ch12"
  },
  {
    "id": 481,
    "question": "Which of the following   identities bad sectors in UNIX?",
    "choice_a": "badblocks",
    "choice_b": "chkdsk",
    "choice_c": "diskpart",
    "choice_d": "fdisk",
    "correct_answer": "A",
    "explanation": "Badblocks has several different modes to be able to detect bad sectors in Linux. One of those is destructive to the data and should not be used where you have data but rather on a new drive.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      217,
      224,
      216,
      185,
      168
    ],
    "source": "ch12"
  }
];
